import * as i0 from '@angular/core';
import { InjectionToken, NgModule, Pipe, inject, signal, Injectable, makeStateKey, PLATFORM_ID, Inject, Optional, EventEmitter, Directive, Input, Output, HostListener, DestroyRef, ElementRef, Renderer2, Component, ChangeDetectionStrategy, ViewChild, ViewEncapsulation, HostBinding } from '@angular/core';
import * as i1 from '@angular/platform-browser';
import { Title, Meta, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import * as i2 from '@angular/common';
import { CommonModule, isPlatformBrowser, isPlatformServer, DOCUMENT, NgClass } from '@angular/common';
import { map as map$1, take, tap, catchError, filter, mergeMap, first, debounceTime, takeUntil, share, delay } from 'rxjs/operators';
import * as i1$1 from '@angular/common/http';
import { HttpClient, HttpParams, HttpStatusCode } from '@angular/common/http';
import { forkJoin, map, of, EMPTY, Subject, from, take as take$1, catchError as catchError$1, BehaviorSubject, filter as filter$1, tap as tap$1, throwError, retry, lastValueFrom, startWith, switchMap, fromEvent } from 'rxjs';
import { FacebookLoginProvider } from '@abacritt/angularx-social-login';
import * as i3 from 'ngx-toastr';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import * as i1$2 from '@angular/router';
import { NavigationEnd, PRIMARY_OUTLET, RouterLinkActive, RouterLink } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Validators } from '@angular/forms';
import * as i1$3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { trigger, state, style, transition, animate } from '@angular/animations';

const APP_CONFIG = new InjectionToken('Core config');

class CoreModule {
    static forRoot(environment) {
        return {
            ngModule: CoreModule,
            providers: [{ provide: APP_CONFIG, useValue: environment }],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: CoreModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CoreModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CoreModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

class TrustPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(input, type = 'URL') {
        switch (type) {
            case 'HTML':
                return this.sanitizer.bypassSecurityTrustHtml(input);
            case 'STYLE':
                return this.sanitizer.bypassSecurityTrustStyle(input);
            case 'SCRIPT':
                return this.sanitizer.bypassSecurityTrustScript(input);
            case 'URL':
                return this.sanitizer.bypassSecurityTrustUrl(input);
            case 'RESOURCE_URL':
                return this.sanitizer.bypassSecurityTrustResourceUrl(input);
            default:
                throw new Error(`Unknown type: ${type}`);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TrustPipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: TrustPipe, isStandalone: true, name: "trust" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TrustPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'trust',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1.DomSanitizer }] });

class SafeHtmlPipe {
    constructor(sanitized) {
        this.sanitized = sanitized;
    }
    transform(value) {
        return this.sanitized.bypassSecurityTrustHtml(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SafeHtmlPipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: SafeHtmlPipe, isStandalone: true, name: "safeHtml" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SafeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safeHtml',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1.DomSanitizer }] });

class FirstLetterPipe {
    transform(value) {
        if (!value) {
            return '';
        }
        return value.charAt(0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: FirstLetterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: FirstLetterPipe, isStandalone: true, name: "firstLetter" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: FirstLetterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'firstLetter',
                    standalone: true,
                }]
        }] });

const pipes$3 = [FirstLetterPipe];
class FirstLetterPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: FirstLetterPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: FirstLetterPipeModule, imports: [CommonModule, FirstLetterPipe], exports: [FirstLetterPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: FirstLetterPipeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: FirstLetterPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ...pipes$3],
                    exports: [...pipes$3],
                }]
        }] });

function updateObjectValues(target, source) {
    const updatedObject = { ...target };
    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== '') {
            updatedObject[key] = source[key];
        }
    }
    return updatedObject;
}

function isObjectEmpty(obj) {
    return obj ? Object.keys(obj).length === 0 : true;
}
function isObject(value) {
    return typeof value === 'object' && value !== null;
}

function intersection(...arrays) {
    const resultMap = {};
    const result = [];
    for (const array of arrays) {
        for (const element of array) {
            const key = JSON.stringify(element);
            resultMap[key] = (resultMap[key] || 0) + 1;
        }
    }
    for (const key in resultMap) {
        if (resultMap[key] === arrays.length) {
            result.push(JSON.parse(key));
        }
    }
    return result;
}

function findBlock(blocks, storeId, predicate) {
    return blocks.find((block) => Number.parseInt(block?.store_id) === storeId && predicate(block));
}
function findBlockByIdentifier(blocks, identifier, storeId) {
    return findBlock(blocks, storeId, (block) => block?.identifier === identifier);
}
function findBlockById(blocks, id, storeId) {
    return findBlock(blocks, storeId, (block) => Number.parseInt(block.block_id) === Number.parseInt(id));
}

function objectNumberToString(o) {
    // @ts-ignore
    Object.keys(o).forEach((k) => {
        if (isObject(o[k])) {
            return objectNumberToString(o[k]);
        }
        o[k] = String(o[k]);
    });
    return o;
}

function isEqual(objA, objB) {
    // Check if both parameters are objects
    if (typeof objA !== 'object' || typeof objB !== 'object') {
        return false;
    }
    // Get the keys of each object
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    // Check if the number of keys is the same
    if (keysA.length !== keysB.length) {
        return false;
    }
    // Iterate over keys and compare values
    for (const key of keysA) {
        // If the key doesn't exist in objB or values are different, objects are not equal
        if (!Object.prototype.hasOwnProperty.call(objB, key) || objA[key] !== objB[key]) {
            return false;
        }
    }
    // Objects are equal
    return true;
}

function getExistedBlocksLength(identifiers) {
    const blockService = inject(BlockService);
    // Create an array of observables
    const blockRequests = identifiers.map((id) => blockService.getBlockByIdentifier(id));
    // Use forkJoin to wait for all HTTP requests to complete
    return forkJoin(blockRequests).pipe(map((results) => results.filter((i) => !!i).length));
}

function getAuthServiceConfigs(configService) {
    return {
        autoLogin: false,
        lang: 'en',
        providers: [
            {
                id: FacebookLoginProvider.PROVIDER_ID,
                provider: new FacebookLoginProvider(configService.getConfig('speedy/social_login/fb_app_id')),
            },
        ],
        onError: (err) => {
            console.error(err);
        },
    };
}

class BlockService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(ConfigService);
        this.storeService = inject(StoreService);
        this.blocks = signal([]);
    }
    setBlocks(blocks) {
        this.blocks.update(() => blocks);
    }
    getBlockById(id) {
        const storeId = this.storeService.getCurrentStoreId();
        const block = findBlockById(this.blocks(), id, storeId);
        return of(block);
    }
    getBlockByIdentifier(identifier) {
        const storeId = this.storeService.getCurrentStoreId();
        const block = findBlockByIdentifier(this.blocks(), identifier, storeId);
        if (block) {
            return of(block);
        }
        return this.requestBlockByIdentifier(identifier).pipe(map$1(() => findBlockByIdentifier(this.blocks(), identifier, storeId)));
    }
    /**
     * add blocks to cache
     * @param identifier
     */
    requestBlockByIdentifier(identifier) {
        const params = new HttpParams().set('patterns', identifier);
        const url = `${this.configService.get('expressApiUrl')}cms/block`;
        return this.http.get(url, { params }).pipe(take(1), tap((block) => {
            if (block) {
                this.blocks.update((b) => b.concat(block));
            }
        }), catchError(() => {
            return EMPTY;
        }));
    }
    requestBlocksByIdentifier(identifiers) {
        const params = new HttpParams().set('patterns', identifiers.join(','));
        const url = `${this.configService.get('expressApiUrl')}cms/blocks`;
        return this.http.get(url, { params }).pipe(take(1), tap((blocks) => {
            this.blocks.update((b) => b.concat(blocks));
        }), catchError(() => {
            return EMPTY;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: BlockService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: BlockService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: BlockService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class ProductionService {
    constructor(platformId, state) {
        this.platformId = platformId;
        this.state = state;
    }
    isBrowserMode() {
        return isPlatformBrowser(this.platformId);
    }
    isServerMode() {
        return isPlatformServer(this.platformId);
    }
    setDataToTransferState(key, data) {
        if (this.isServerMode()) {
            const isDataExist = this.state.get(makeStateKey(key), null);
            if (!isDataExist) {
                this.state.set(makeStateKey(key), data);
            }
        }
    }
    getDataFromTransferState(key) {
        if (this.isBrowserMode()) {
            const data = this.state.get(makeStateKey(key), null);
            if (data) {
                this.state.remove(makeStateKey(key));
                return data;
            }
        }
        return undefined;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ProductionService, deps: [{ token: PLATFORM_ID }, { token: i0.TransferState }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ProductionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ProductionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i0.TransferState }] });

class ExtendedValidator {
    asValidatorFn() {
        return (control) => this.validate(control);
    }
}

function isEnumValue(enumType, value) {
    return Object.values(enumType).includes(value);
}

function optionalToFixed(value, precision) {
    const fixed = value.toFixed(precision);
    const num = Number(fixed);
    const result = num.toString();
    return result;
}

const baseConfig = {
    direction: 'horizontal',
    speed: 1000,
    slidesPerView: 6,
    keyboard: false,
    mousewheel: false,
    spaceBetween: 20,
    observer: true,
};
const breakpoints = {
    992: { slidesPerView: 6 },
    768: { slidesPerView: 4 },
    575: { slidesPerView: 3 },
    320: { slidesPerView: 2 },
};
const generateSliderConfig = (name) => ({
    ...baseConfig,
    navigation: {
        nextEl: `.swiper-${name}.swiper-button-next`,
        prevEl: `.swiper-${name}.swiper-button-prev`,
    },
    scrollbar: {
        el: `.swiper-${name} .swiper-scrollbar`,
        draggable: true,
    },
    breakpoints: breakpoints,
});
const relatedProdsCartConfig = {
    ...generateSliderConfig('related-products'),
    breakpoints: {
        1050: { slidesPerView: 4 },
        992: { slidesPerView: 3 },
        900: { slidesPerView: 2 },
        768: { slidesPerView: 4 },
        550: { slidesPerView: 3 },
        320: { slidesPerView: 2 },
    },
};

/** Updating first object based on fields of second object with checking fields from array withFields  */
function updateObjectWith(object1, object2, withFields) {
    // Create a copy of object1
    const newObject = { ...object1 };
    // Loop through all keys of object2
    for (const key in object1) {
        // Check if the key is in the withFields array
        if (withFields.includes(key)) {
            // Update the newObject with the value from object2 if it exists, otherwise set it to null
            newObject[key] = key in object2 ? object2[key] : null;
        }
    }
    // Return the new object
    return newObject;
}

function formatImageToWebp(imageUrl) {
    return imageUrl;
    /** TODO: disabled for demo purpose */
    // return imageUrl.replace(/\.(jpg|png)$/i, '.webp');
}

class EventsService {
    constructor() {
        this.listeners = {};
        this.eventsSubject = new Subject();
        this.events = from(this.eventsSubject);
        this.events.subscribe(({ name, args }) => {
            if (this.listeners[name]) {
                for (const listener of this.listeners[name]) {
                    listener(...args);
                }
            }
        });
    }
    on(name, listener) {
        if (!this.listeners[name]) {
            this.listeners[name] = [];
        }
        this.listeners[name].push(listener);
    }
    broadcast(name, ...args) {
        this.eventsSubject.next({
            name,
            args,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: EventsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: EventsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: EventsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

class StoreService {
    constructor(config) {
        this.config = config;
        this.productionService = inject(ProductionService);
        this.eventService = inject(EventsService);
        this.stores = {};
        this.websites = [];
        this.store$ = new Subject();
        this.defaultStoreCode = config.defaultStoreCode;
    }
    setStores(stores) {
        const result = {};
        const defaultStore = stores.find((store) => store.code == this.defaultStoreCode);
        stores.forEach((store) => {
            if (defaultStore?.website_id === store.website_id) {
                result[store.code] = store;
            }
        });
        this.stores = result;
        if (this.productionService.isBrowserMode()) {
            this._init();
        }
        else {
            this._initServer();
        }
    }
    _initServer() {
        if (!this.currentStore) {
            this.currentStore = this.getStoreByCode(this.defaultStoreCode);
        }
    }
    _init() {
        if (!this.currentStore) {
            this.currentStore = this.getStoreByCode(this.defaultStoreCode);
        }
        this.broadCastStoreChange();
        if (!this.currentStore) {
            throw 'Store with code ' + this.defaultStoreCode + ' does not exist';
        }
    }
    getDefaultStoreCode() {
        return this.config.defaultStoreCode;
    }
    setCurrentStoreId(storeId) {
        const store = this.getStoreById(storeId);
        this._setCurrentStore(store);
    }
    setCurrentStoreByCode(storeCode) {
        const store = this.stores[storeCode];
        this._setCurrentStore(store);
    }
    _setCurrentStore(store) {
        if (!store) {
            console.info('Cant find specified store');
            this.currentStore = this.getStoreByCode(this.defaultStoreCode);
            this.broadCastStoreChange();
        }
        else if (parseInt(this.currentStore.store_id) !== parseInt(store.store_id)) {
            this.currentStore = store;
            this.broadCastStoreChange();
        }
    }
    broadCastStoreChange() {
        this.store$.next(this.currentStore);
        this.eventService.broadcast('store_changed_after', {
            ...this.currentStore,
        });
    }
    getCurrentStoreId() {
        const store = this.getCurrentStore();
        return Number.parseInt(store?.store_id);
    }
    getCurrentStoreCode() {
        const store = this.getCurrentStore();
        if (isObjectEmpty(store)) {
            return this.config.defaultStoreCode;
        }
        return store.code;
    }
    getCurrentStore() {
        return { ...this.currentStore };
    }
    getStores() {
        return { ...this.stores };
    }
    setWebsites(websites) {
        this.websites = websites;
    }
    getWebsite() {
        const currentWebsite = this.websites.find((website) => {
            const store = this.getCurrentStore();
            return website.website_id == store?.website_id;
        });
        return { ...currentWebsite };
    }
    getWebsiteId() {
        const website = this.getWebsite();
        return website.website_id;
    }
    getStoreByCode(code) {
        const foundedStore = Object.keys(this.stores).find((key) => this.stores[key].code === code);
        return this.stores[foundedStore];
    }
    getStoreById(storeId) {
        const foundedStore = Object.keys(this.stores).find((key) => parseInt(this.stores[key].store_id) == parseInt(storeId));
        return this.stores[foundedStore];
    }
    getFrontendStoreCode(store) {
        return store.code;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: StoreService, deps: [{ token: APP_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: StoreService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: StoreService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APP_CONFIG]
                }] }] });

class ConfigService {
    constructor(envConfig, storeService) {
        this.envConfig = envConfig;
        this.storeService = storeService;
        this._mediaUrl = envConfig.m2url + 'media/';
        this.mediaCategoryUrl = this._mediaUrl + 'catalog/category/';
        this.productMediaUrl = this._mediaUrl + 'resized/800';
        this.productAttributeSwatchUrl = this.mediaUrl + 'attribute/swatch';
        this.productMediaThumbUrl = this._mediaUrl + 'resized/100';
        this.productMediaSmallUrl = this._mediaUrl + 'resized/400';
        this.productMediaOriginalUrl = this._mediaUrl + 'catalog/product/';
        this.productMediaPlaceholder = this._mediaUrl + 'catalog/product/placeholder/';
    }
    get(key) {
        return this.envConfig[key];
    }
    setConfig(config) {
        const result = {};
        config.forEach((row) => {
            Object.keys(row).forEach((key) => {
                const scopeValue = row[key];
                const scope = scopeValue.scope;
                if (!isObject(result[scope])) {
                    result[scope] = {};
                }
                if (scope === 'default' && result?.default) {
                    result.default[scopeValue.key] = scopeValue.value;
                }
                else {
                    if (!isObject(result[scopeValue.scope][scopeValue.scope_id])) {
                        result[scopeValue.scope][scopeValue.scope_id] = {};
                    }
                    result[scopeValue.scope][scopeValue.scope_id][scopeValue.key] =
                        scopeValue.value;
                }
            });
        });
        this.config = result;
    }
    getConfig(path) {
        const storeScopeValue = this.getStoreScopeValue(path);
        let result = '';
        if (!storeScopeValue) {
            const websiteScopeValue = this.getWebsiteScopeValue(path);
            const defaultScopeValue = this.getDefaultScopeValue(path);
            result = websiteScopeValue !== undefined ? websiteScopeValue : defaultScopeValue;
        }
        else {
            result = storeScopeValue;
        }
        return result !== '0' ? result : '';
    }
    getStoreScopeValue(path) {
        const storeCode = this.storeService.getCurrentStoreCode();
        return this.config?.['stores']?.[storeCode]?.[path];
    }
    getWebsiteScopeValue(path) {
        const website = this.storeService.getWebsite();
        const websiteCode = website?.code;
        return this.config?.['websites']?.[websiteCode]?.[path];
    }
    getDefaultScopeValue(path) {
        return this.config?.default?.[path];
    }
    getApiUrl() {
        const storeCode = this.storeService.getCurrentStoreCode();
        if (storeCode) {
            return `${this.get('m2url')}rest/${storeCode}/V1/`;
        }
        return `${this.get('m2url')}rest/V1/`;
    }
    getProductMediaUrl(type) {
        switch (type) {
            case 'small': {
                return this.productMediaSmallUrl;
            }
            case 'image_small': {
                return this.productMediaSmallUrl;
            }
            case 'thumb': {
                return this.productMediaThumbUrl;
            }
            case 'original': {
                return this.productMediaOriginalUrl;
            }
            case 'placeholder': {
                return this.productMediaPlaceholder;
            }
            default: {
                return this.productMediaUrl;
            }
        }
    }
    getByScope(path, scope, scopeId) {
        if (this.config[scope] && this.config[scope][scopeId]) {
            return this.config[scope][scopeId][path];
        }
        return '';
    }
    isInfiniteScrollEnabled() {
        return this.getConfig('speedy/general/infinite_scroll');
    }
    getCookieLifeTime() {
        return this.getConfig('web/cookie/cookie_lifetime');
    }
    getCurrency() {
        return this.getConfig('currency/options/default');
    }
    getLogoImage() {
        let logoUrl = 'assets/images/speedy.webp';
        const src = this.getConfig('design/header/logo_src');
        if (src) {
            logoUrl = this.mediaUrl + 'logo/' + src;
        }
        return formatImageToWebp(logoUrl);
    }
    getLogoAlt() {
        const alt = this.getConfig('design/header/logo_alt');
        return alt ? alt : 'Speedy';
    }
    getLogoWidth() {
        const width = this.getConfig('design/header/logo_width');
        return width ? width : '';
    }
    getLogoHeight() {
        const height = this.getConfig('design/header/logo_height');
        return height ? height : '';
    }
    getFavicon() {
        const src = 'assets/images/favicon.ico';
        const alt = this.mediaUrl + 'favicon/' + this.getConfig('design/head/shortcut_icon');
        return alt ? alt : src;
    }
    getPlaceholder(type = 'placeholder') {
        const local_plc = 'assets/images/speedy.webp';
        const magentoPlaceholder = this.getConfig('catalog/placeholder/image_placeholder');
        const placeholder = `${this.getProductMediaUrl(type)}${magentoPlaceholder}`;
        return magentoPlaceholder ? formatImageToWebp(placeholder) : local_plc;
    }
    getHeadTitle() {
        const src = 'Speedy';
        const alt = this.getConfig('design/head/default_title');
        return alt ? alt : src;
    }
    getSpeedyUrl() {
        return this.getConfig('speedy/general/frontend_url').replace(/\/$/g, '');
    }
    getTitleSuffix() {
        return this.getConfig('design/head/title_suffix');
    }
    getTitlePrefix() {
        return this.getConfig('design/head/title_prefix');
    }
    getProductMinOrderTotal() {
        return this.getConfig('payment/tfbank_hp/min_order_total');
    }
    getProductMaxOrderTotal() {
        return this.getConfig('payment/tfbank_hp/max_order_total');
    }
    getMinOrderTotal(paymentMethod) {
        return this.getConfig(`payment/${paymentMethod}/min_order_total`);
    }
    getMaxOrderTotal(paymentMethod) {
        return this.getConfig(`payment/${paymentMethod}/max_order_total`);
    }
    getCheckoutSuccessText() {
        return this.getConfig('speedy_config_success_page_settings/editor/editor_wysiwyg_success');
    }
    getCheckoutErrorText() {
        return this.getConfig('speedy_config_success_page_settings/editor/editor_wysiwyg_error');
    }
    getMediaCategoryUrl(isNew = false) {
        return isNew ? this.envConfig.m2url : this.mediaCategoryUrl;
    }
    get expressApiUrl() {
        return this.get('expressApiUrl') ? this.get('expressApiUrl') : '//localhost:3000/';
    }
    get mediaUrl() {
        return this._mediaUrl;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ConfigService, deps: [{ token: APP_CONFIG }, { token: StoreService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ConfigService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [APP_CONFIG]
                }] }, { type: StoreService }] });

class AuthService {
    constructor() {
        this.http = inject(HttpClient);
        this.config = inject(ConfigService);
        this.toastrService = inject(ToastrService);
        this.cookieService = inject(CookieService);
        const token = this.cookieService.get('token');
        this.token = token ? token : '';
    }
    getToken() {
        return this.cookieService.get('token');
    }
    setToken(token) {
        this.token = token;
        this.cookieService.set('token', token);
    }
    login(username, password) {
        const url = this.config.getApiUrl() + 'integration/customer/token';
        return this.http.post(url, { username, password }).pipe(tap((token) => {
            this.setToken(token);
        }));
    }
    forgotPasswordInit(username) {
        const url = this.config.getApiUrl() + 'customers/password';
        return this.http.put(url, { email: username, template: 'email_reset' });
    }
    resetTokenLink(customerId, token) {
        const url = this.config.getApiUrl() +
            'customers/' +
            customerId +
            '/password/resetLinkToken/' +
            token;
        return this.http.get(url);
    }
    resetPassword(email, resetToken, newPassword) {
        const url = this.config.getApiUrl() + 'customers/resetPassword';
        return this.http.post(url, {
            email: email,
            resetToken: resetToken,
            newPassword: newPassword,
        });
    }
    loginFacebook(data) {
        const url = this.config.getApiUrl() + 'login/facebook';
        return this.http.post(url, { data }).pipe(map$1((token) => {
            this.setToken(token);
            return true;
        }, (error) => {
            this.toastrService.error(error.error?.message);
            return false;
        }));
    }
    logout() {
        this.setToken('false');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: AuthService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: AuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [] });

var AutocompleteType;
(function (AutocompleteType) {
    AutocompleteType["PRODUCT"] = "product";
    AutocompleteType["CATEGORY"] = "category";
    AutocompleteType["TERM"] = "term";
})(AutocompleteType || (AutocompleteType = {}));

var CategoryPageType;
(function (CategoryPageType) {
    CategoryPageType["TYPE_CATEGORY"] = "category";
    CategoryPageType["TYPE_SEARCH"] = "search";
})(CategoryPageType || (CategoryPageType = {}));

var BanksCalculator;
(function (BanksCalculator) {
    BanksCalculator["Esto"] = "Esto";
    BanksCalculator["Inbank"] = "Inbank";
    BanksCalculator["TFBank"] = "TFBank";
    BanksCalculator["LHV"] = "LHV";
})(BanksCalculator || (BanksCalculator = {}));

var ProductType;
(function (ProductType) {
    ProductType["Grouped"] = "grouped";
    ProductType["Bundle"] = "bundle";
    ProductType["Configurable"] = "configurable";
    ProductType["Simple"] = "simple";
    ProductType["Virtual"] = "virtual";
})(ProductType || (ProductType = {}));

var ProductBundleOptionType;
(function (ProductBundleOptionType) {
    ProductBundleOptionType["SELECT"] = "select";
    ProductBundleOptionType["RADIO"] = "radio";
    ProductBundleOptionType["CHECKBOX"] = "checkbox";
    ProductBundleOptionType["MULTI_SELECT"] = "multi";
})(ProductBundleOptionType || (ProductBundleOptionType = {}));

class ProductService {
    constructor(customerService, configService, http, platformId) {
        this.customerService = customerService;
        this.configService = configService;
        this.http = http;
        this.platformId = platformId;
        this.productsRecentlyViewed = [];
        this.productsRecentlyViewedIndex = 'PRODUCTS_RECENTLY_VIEWED';
        this.onInit();
    }
    onInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.productsRecentlyViewed = JSON.parse(localStorage.getItem(this.productsRecentlyViewedIndex));
        }
    }
    getProductById(id) {
        return this.http
            .get(`${this.configService.expressApiUrl}products/${id}`, {})
            .pipe(take$1(1));
    }
    getProductByUrlKey(url_key) {
        return this.http
            .get(`${this.configService.expressApiUrl}products/url-key/${url_key}`)
            .pipe(map((product) => {
            this.setMedia(product);
            return product;
        }));
    }
    getProductsByIdBatch(ids) {
        return this.http
            .get(`${this.configService.expressApiUrl}products`, {
            params: { ids: ids.toString() },
        })
            .pipe(map((products) => {
            products.forEach((product) => this.setMedia(product));
            return products;
        }), catchError$1(() => of([])));
    }
    setMedia(product) {
        const mediaPath = this.configService.getProductMediaUrl('image');
        const mediaPathSmall = this.configService.getProductMediaUrl('small');
        const mediaPathThumb = this.configService.getProductMediaUrl('thumb');
        const { image } = product;
        const placeholder = formatImageToWebp(this.configService.getPlaceholder());
        if (image && image !== 'no_selection') {
            product.image = image.indexOf(mediaPath) === -1 ? mediaPath + image : image;
            product.image_small = mediaPathSmall + formatImageToWebp(image);
            product.image_thumb = mediaPathThumb + image;
        }
        else {
            product.image = placeholder;
            product.image_small = placeholder;
            product.image_thumb = placeholder;
        }
    }
    setParentPriceFromChild(parent, childProduct, qty = 1) {
        if (!childProduct) {
            return;
        }
        childProduct.finalPriceSaved = childProduct.finalPrice;
        parent.regularPrice = childProduct.regularPrice;
        parent.finalPrice = childProduct.finalPrice;
        parent.is_discount = childProduct.is_discount;
        parent.discountPercent = childProduct.discountPercent;
        this.considerTierPrices(parent, childProduct, qty);
    }
    considerTierPrices(parent, childProduct, qty) {
        if (childProduct.tier_prices_api?.length > 0) {
            let changedByTierPrice = false;
            childProduct.tier_prices_api.forEach((tierPrice) => {
                if (qty >= parseInt(tierPrice.qty) &&
                    parseFloat(tierPrice.price) < parseFloat(childProduct.finalPriceSaved)) {
                    changedByTierPrice = true;
                    parent.finalPrice = parseFloat(tierPrice.price).toFixed(2);
                }
            });
            if (!changedByTierPrice) {
                parent.finalPrice = childProduct.finalPriceSaved;
            }
        }
    }
    loadProductsChildren(products) {
        const childrenIds = [];
        const loadedChildren = [];
        for (const product of products) {
            if (product.type_id === ProductType.Configurable) {
                if (product?.configurable_data?.children_ids)
                    childrenIds.push(...product.configurable_data.children_ids);
                if (Array.isArray(product.children)) {
                    for (const child of product.children) {
                        if (!loadedChildren.includes(`${child.entity_id}`)) {
                            loadedChildren.push(`${child.entity_id}`);
                        }
                    }
                }
            }
        }
        const productIdsToLoad = [];
        for (const childId of childrenIds) {
            if (!loadedChildren.includes(childId)) {
                productIdsToLoad.push(childId);
            }
        }
        if (productIdsToLoad.length === 0) {
            return of(products);
        }
        return this.getProductsByIdBatch(productIdsToLoad).pipe(map((children) => {
            for (const product of products) {
                if (product.type_id === ProductType.Configurable) {
                    if (!Array.isArray(product.children)) {
                        product.children = [];
                    }
                    if (product.children.length > 0) {
                        continue;
                    }
                    // eslint-disable-next-line no-unsafe-optional-chaining
                    for (const childId of product?.configurable_data?.children_ids) {
                        const child = children.find((row) => row.entity_id === parseInt(childId));
                        if (child) {
                            product.children.push(child);
                        }
                    }
                }
            }
            return products;
        }));
    }
    addProductRecentlyViewed(product) {
        if (!this.productsRecentlyViewed) {
            this.productsRecentlyViewed = [];
        }
        this.productsRecentlyViewed = [
            product.entity_id,
            ...this.productsRecentlyViewed.filter((id) => id !== product.entity_id),
        ];
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem(this.productsRecentlyViewedIndex, JSON.stringify(this.productsRecentlyViewed));
        }
    }
    getRecentlyViewedProducts(currentProduct, size = 4) {
        this.addProductRecentlyViewed(currentProduct);
        const productIdsToQuery = this.productsRecentlyViewed
            .filter((productId) => currentProduct.entity_id !== productId)
            .slice(0, size);
        if (productIdsToQuery?.length) {
            return this.getProductsByIdBatch(productIdsToQuery).pipe();
        }
        else {
            return of([]);
        }
    }
    getRelatedProducts(product) {
        if (product.relations && product.relations.length > 0) {
            return this.getProductsByIdBatch(product.relations).pipe(map((products) => {
                for (const product of products) {
                    this.setMedia(product);
                }
                return products;
            }), map((products) => {
                const result = [];
                let nextProduct;
                for (const productId of product.relations) {
                    nextProduct = products.find((product) => product.entity_id === parseInt(productId));
                    if (nextProduct) {
                        result.push(nextProduct);
                    }
                }
                return result;
            }));
        }
        return of([]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ProductService, deps: [{ token: CustomerService }, { token: ConfigService }, { token: i1$1.HttpClient }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ProductService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ProductService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CustomerService }, { type: ConfigService }, { type: i1$1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }] });

class CustomerService {
    constructor() {
        this.http = inject(HttpClient);
        this.config = inject(ConfigService);
        this.authService = inject(AuthService);
        this.toastrService = inject(ToastrService);
        this.productionService = inject(ProductionService);
        this.storeService = inject(StoreService);
        this.customerOrders = [];
        this.subject = new BehaviorSubject(null);
    }
    initSession() {
        if (this.productionService.isServerMode() || !this.isLoggedIn())
            return of(null);
        return this.getCustomer();
    }
    logout(addSuccessMessage = true) {
        this.refreshCustomer({});
        if (addSuccessMessage) {
            this.toastrService.success('Customer Logged Out');
        }
    }
    create(customer, password) {
        return this.http.post(`${this.config.getApiUrl()}customers`, {
            customer: customer,
            password: password,
        });
    }
    getCustomer() {
        if (!this.isLoggedIn()) {
            return of(null);
        }
        if (this.customer && !isObjectEmpty(this.customer)) {
            return of(this.customer);
        }
        return this.http.get(`${this.config.getApiUrl()}customers/me`).pipe(map$1((customer) => {
            this.refreshCustomer(customer);
            return customer;
        }), catchError((error) => {
            if (error && error.status === HttpStatusCode.Unauthorized) {
                this.toastrService.error('Your session has expired, you are now logged out');
                this.logout(false);
            }
            else {
                this.toastrService.error('Could not retrieve customer data');
            }
            return of(null);
        }));
    }
    saveCustomer(customer) {
        const payload = { customer: customer };
        return this.http
            .put(`${this.config.getApiUrl()}customers/me`, payload)
            .pipe(map$1((customer) => {
            this.refreshCustomer(customer);
            return { ...this.customer };
        }));
    }
    refreshCustomer(customer) {
        this.customer = customer;
        this.subject.next(this.customer);
    }
    subscribeToCustomer() {
        return this.subject;
    }
    changePassword(currentPassword, newPassword) {
        const url = `${this.config.getApiUrl()}customers/me/password`;
        const payload = {
            currentPassword: currentPassword,
            newPassword: newPassword,
        };
        return this.http.put(url, payload);
    }
    deleteAddress(address) {
        const indexToDelete = this.customer?.addresses.findIndex((existingAddress) => existingAddress.id === address.id);
        if (indexToDelete !== undefined && indexToDelete >= 0) {
            this.customer.addresses.splice(indexToDelete, 1);
        }
        return this.saveCustomer(this.customer);
    }
    editAddress(address) {
        this._processDefaultAddressChange(address);
        if (this._isAddressNew(address)) {
            this.customer?.addresses.push(this.convertAddress(address));
        }
        else {
            this.customer?.addresses.forEach((existingAddress, key) => {
                if (existingAddress['id'] == address['id']) {
                    this.customer.addresses[key] = this.convertAddress(address);
                    return;
                }
            });
        }
        return this.saveCustomer(this.customer);
    }
    _processDefaultAddressChange(address) {
        if (address?.default_billing) {
            const previousDefaultBillingAddress = this.getDefaultBillingAddress();
            if (previousDefaultBillingAddress) {
                previousDefaultBillingAddress['default_billing'] = false;
            }
        }
        else if (address.default_billing === false) {
            this.customer.default_billing = false;
        }
        if (address?.default_shipping) {
            const previousDefaultShippingAddress = this.getDefaultShippingAddress();
            if (previousDefaultShippingAddress) {
                previousDefaultShippingAddress.default_shipping = false;
            }
        }
        else if (address.default_shipping === false) {
            this.customer.default_shipping = false;
        }
    }
    _isAddressNew(address) {
        if (!address?.id)
            return true;
        return this.customer?.addresses.find((existingAddress) => existingAddress.id === address.id);
    }
    getDefaultBillingAddress() {
        if (!this.customer || !this.customer?.addresses?.length)
            return false;
        return this.customer.addresses.find((address) => address?.id === parseInt(this.customer.default_billing));
    }
    getDefaultShippingAddress() {
        if (!this.customer || !this.customer?.addresses)
            return false;
        return this.customer.addresses.find((address) => address?.id === parseInt(this.customer.default_shipping));
    }
    getAdditionalAddresses() {
        return this.customer.addresses?.filter((address) => address.id !== parseInt(this.customer.default_shipping) &&
            address.id !== parseInt(this.customer.default_billing));
    }
    clearSession() {
        return this.http.delete(`${this.config.getApiUrl()}customers/me/logout`);
    }
    isLoggedIn() {
        // if (this.productionService.isServerMode()) return false;
        const token = this.authService.getToken();
        return token && token !== 'false';
    }
    getCustomerGroup() {
        if (!this.isLoggedIn() || !this.customer) {
            return 0;
        }
        else {
            return this.customer.group_id;
        }
    }
    convertAddress(address) {
        if (address && typeof address.street === 'string') {
            address.street = [address.street];
        }
        return address;
    }
    getCustomerOrders(pageSize = 9999, currentPage = 1) {
        const url = `${this.config.getApiUrl()}orderapi/mine/${pageSize}/${currentPage}`;
        return this.http.get(url).pipe(map$1((orders) => {
            orders.forEach((order) => {
                order.nav_link = `/${this.storeService.getCurrentStoreCode()}/customer/orders/view/${order.order_id}`;
                order.items = JSON.parse(order.items);
            });
            this.customerOrders = orders;
            return this.customerOrders;
        }), catchError((error) => {
            this.toastrService.error(error.error?.message ?? error.error);
            if (error.status === HttpStatusCode.Unauthorized && this.isLoggedIn()) {
                this.logout(false);
            }
            throw error;
        }));
    }
    getCustomerOrdersTotal() {
        const url = `${this.config.getApiUrl()}orderapi/mine/total`;
        return this.http.get(url).pipe(map$1((total) => {
            this.customerOrdersTotal = total;
            return this.customerOrdersTotal;
        }));
    }
    getOrderById(id) {
        const url = `${this.config.getApiUrl()}orderapi/getorder/${id}`;
        return this.http.get(url);
    }
    checkIsCustomerBusiness(customer) {
        const custom_attributes = customer.custom_attributes;
        const isBusiness = custom_attributes.find((attribute) => attribute.attribute_code === 'is_b2b_customer');
        return isBusiness && parseInt(isBusiness.value) === 1 ? true : false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CustomerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CustomerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CustomerService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class RouterService {
    constructor(router, storeService, productionService, configService) {
        this.router = router;
        this.storeService = storeService;
        this.productionService = productionService;
        this.configService = configService;
        this.browseHistory = [];
        this.saveUrlHistory();
    }
    saveUrlHistory() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((e) => {
            this.browseHistory.push(e.urlAfterRedirects);
        });
    }
    routeNotFound() {
        const currentStore = this.storeService.getCurrentStore();
        const url = '/' + currentStore?.code + '/notfound';
        return this.router.navigate([url]);
    }
    /**
     * if in server mode, then we make a 302 redirect
     * @param path
     * @param addStoreCode
     */
    navigate(path, addStoreCode = true, queryParams) {
        let url = path;
        if (addStoreCode) {
            const currentStore = this.storeService.getCurrentStore();
            url = '/' + currentStore.code + '/' + path;
            url.replace('//', '/');
        }
        return this.router.navigate([url], { queryParams });
    }
    afterLogin() {
        let url = this.browseHistory[this.browseHistory.length - 1]
            ? this.browseHistory[this.browseHistory.length - 1]
            : '/';
        if (url.includes('login')) {
            url = '/';
        }
        console.info('redirecting after the login to ', url);
        this.router.navigate([url]);
    }
    cleanDoubleSlash(url) {
        return url.replace(/([^:]\/)\/+/g, '$1');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: RouterService, deps: [{ token: i1$2.Router }, { token: StoreService }, { token: ProductionService }, { token: ConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: RouterService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: RouterService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$2.Router }, { type: StoreService }, { type: ProductionService }, { type: ConfigService }] });

const GUEST_CART = 'guest_cart_id';
const CUSTOMER_CART = 'customer_cart_id';
class CartService {
    constructor() {
        this.http = inject(HttpClient);
        this.config = inject(ConfigService);
        this.customerService = inject(CustomerService);
        this.toastrService = inject(ToastrService);
        this.productionService = inject(ProductionService);
        this.eventsService = inject(EventsService);
        this.routerService = inject(RouterService);
        this.cart$ = new BehaviorSubject(null);
        this.onlyVirtualProducts$ = new BehaviorSubject(false);
    }
    addToCart(product, qty) {
        this.eventsService.broadcast('add_to_cart', product);
        if (this.customerService.isLoggedIn()) {
            return this.addToCustomerCart(product['sku'], qty);
        }
        else {
            return this.addToGuestCart(product.sku, qty);
        }
    }
    addToCartConfigurable(product, qty, options) {
        const additionalData = {
            product_type: ProductType.Configurable,
            product_option: {
                extension_attributes: {
                    configurable_item_options: options,
                },
            },
        };
        this.eventsService.broadcast('add_to_cart', product);
        if (this.customerService.isLoggedIn()) {
            return this.addToCustomerCart(product['sku'], qty, additionalData);
        }
        else {
            return this.addToGuestCart(product['sku'], qty, additionalData);
        }
    }
    addToCartBundle(product, qty, options) {
        const additionalData = {
            product_type: ProductType.Bundle,
            product_option: {
                extension_attributes: {
                    bundle_options: options.map(({ option_id, option_qty, option_selections }) => ({
                        option_id,
                        option_selections,
                        option_qty,
                    })),
                },
            },
        };
        this.eventsService.broadcast('add_to_cart', product);
        if (this.customerService.isLoggedIn()) {
            return this.addToCustomerCart(product['sku'], qty, additionalData);
        }
        else {
            return this.addToGuestCart(product['sku'], qty, additionalData);
        }
    }
    updateItem(cartItem) {
        if (this.customerService.isLoggedIn()) {
            return this.updateItemCustomerCart(cartItem);
        }
        else {
            return this.updateItemGuestCart(cartItem);
        }
    }
    updateItemCustomerCart(cartItem) {
        const payLoad = {
            cart_item: {
                quote_id: this.customerCartId,
                qty: cartItem.qty.toFixed(2),
                item_id: cartItem.item_id,
            },
        };
        const url = this.config.getApiUrl() + 'carts/mine/speedyitems';
        return this.http.post(url, payLoad).pipe(catchError((error) => {
            this.addError(error);
            return EMPTY;
        }), map$1((cart) => {
            this.toastrService.success('Item added to cart');
            this.refreshCart(cart.totals);
            return cart;
        }));
    }
    updateItemGuestCart(cartItem) {
        const url = this.config.getApiUrl() + 'guest-carts/' + this.getGuestCartId() + '/speedyitems';
        const payLoad = {
            cart_item: {
                quote_id: this.getGuestCartId(),
                qty: cartItem.qty.toFixed(2),
                item_id: cartItem.item_id,
            },
        };
        return this.http.post(url, payLoad).pipe(catchError((error) => {
            this.addError(error);
            return EMPTY;
        }), map$1((cart) => {
            this.toastrService.success('Item added to cart');
            this.refreshCart(cart.totals);
            return cart;
        }));
    }
    //TODO fix for case when cart is expired, check time when it was initiated
    addToGuestCart(sku, qty, additionalData = {}) {
        const url = this.config.getApiUrl() + 'guest-carts/' + this.getGuestCartId() + '/speedyitems';
        const payLoad = {
            cart_item: {
                quote_id: this.getGuestCartId(),
                sku: sku,
                qty: qty.toFixed(2),
            },
        };
        Object.assign(payLoad?.cart_item, additionalData);
        return this.http.post(url, payLoad).pipe(map$1((cart) => {
            this.toastrService.success('Item added to cart');
            this.refreshCart(cart.totals);
            return cart;
        }));
    }
    convertCartResponseData(totals) {
        totals?.items?.forEach((item) => {
            const product = item.extension_attributes.product;
            product?.custom_attributes.forEach((attr) => {
                item[attr.attribute_code] = attr.value;
            });
            if (item.extension_attributes.thumb) {
                item.thumbnail = item.extension_attributes.thumb;
            }
        });
        return totals;
    }
    addToCustomerCart(sku, qty, additionalData = {}) {
        const payLoad = {
            cart_item: {
                quote_id: this.customerCartId,
                sku: sku,
                qty: qty.toFixed(2),
            },
        };
        Object.assign(payLoad['cart_item'], additionalData);
        const url = this.config.getApiUrl() + 'carts/mine/speedyitems';
        return this.http.post(url, payLoad).pipe(tap((cart) => {
            this.toastrService.success('Item added to cart');
            this.refreshCart(cart.totals);
            return cart;
        }));
    }
    getGuestCartId() {
        if (this.productionService.isServerMode())
            return false;
        return localStorage.getItem(GUEST_CART);
    }
    setGuestCartId(guestCartId) {
        if (this.productionService.isServerMode())
            return;
        localStorage.setItem(GUEST_CART, guestCartId);
    }
    getGuestCart() {
        if (this.productionService.isServerMode())
            return of(null);
        const guestCartId = this.getGuestCartId();
        if (!guestCartId) {
            //create new guest cart
            return this.newGuestCart().pipe(mergeMap((guestCartId) => this.guestCartTotals(guestCartId)));
        }
        return this.guestCartTotals(guestCartId);
    }
    newGuestCart() {
        return this.http.post(this.config.getApiUrl() + 'guest-carts', {}).pipe(map$1((guestCartId) => {
            this.setGuestCartId(guestCartId);
            return guestCartId;
        }), catchError((error) => {
            this.addError(error);
            return EMPTY;
        }));
    }
    guestCartTotals(guestCartId) {
        const url = this.config.getApiUrl() + `guest-carts/${guestCartId}/totals`;
        return this.http.get(url).pipe(catchError((error) => {
            console.error('cart does not exist');
            this.newGuestCart().pipe(first()).subscribe();
            return of(false);
        }));
    }
    getCustomerCart() {
        if (this.productionService.isServerMode())
            return EMPTY;
        const url = this.config.getApiUrl() + `carts/mine/totals`;
        return this.http.get(url);
    }
    addError(error) {
        if (error.status === HttpStatusCode.Unauthorized) {
            this.toastrService.error('Problems with authentication');
            if (this.customerService.isLoggedIn()) {
                this.routerService.navigate('auth/logout');
            }
        }
        else {
            this.toastrService.error(error.error?.message ? error.error.message : error.message);
        }
    }
    refreshCart(totals) {
        const convertedTotals = this.convertCartResponseData(totals);
        localStorage.setItem('totals', JSON.stringify(convertedTotals));
        if (!convertedTotals?.items_qty) {
            localStorage.setItem('shipping_method_code', 'false');
        }
        const cart = this.convertOptions(convertedTotals);
        const onlyVirtualProducts = cart.items.every((item) => item.extension_attributes.product.type_id === ProductType.Virtual);
        this.onlyVirtualProducts$.next(onlyVirtualProducts);
        this.cart$.next(cart);
    }
    convertOptions(cart) {
        const cartConverted = { ...cart };
        cartConverted?.items?.forEach((item) => {
            if (item.options) {
                item.options =
                    typeof item.options === 'string' ? JSON.parse(item.options) : item.options;
            }
        });
        return cartConverted;
    }
    deleteItem(itemId) {
        const deleteStream = this.customerService.isLoggedIn()
            ? this.deleteItemCustomer(itemId)
            : this.deleteItemGuest(itemId);
        return deleteStream.pipe(map$1((cart) => {
            this.toastrService.success('Item Deleted');
            this.refreshCart(cart.totals);
            return cart;
        }));
    }
    deleteItemGuest(itemId) {
        return this.http.delete(this.config.getApiUrl() +
            `guest-carts/${this.getGuestCartId()}/speedyitems/${itemId}`, {});
    }
    deleteItemCustomer(itemId) {
        return this.http.delete(this.config.getApiUrl() + 'carts/mine/speedyitems/' + itemId);
    }
    initCart() {
        if (this.productionService.isServerMode())
            return;
        /** Refresh cart from local storage */
        const totals = localStorage.getItem('totals');
        if (totals) {
            return this.refreshCart(JSON.parse(totals));
        }
        if (this.customerService.isLoggedIn()) {
            const url = this.config.getApiUrl() + 'carts/mine';
            this.http
                .post(url, {})
                .pipe(take(1), tap((cartId) => (this.customerCartId = cartId)), mergeMap(() => this.getCustomerCart()), tap(() => this.setGuestCartId('')))
                .subscribe((totals) => {
                this.refreshCart(totals);
            });
        }
        else {
            this.getGuestCart()
                .pipe(first())
                .subscribe((totals) => {
                this.refreshCart(totals);
            });
        }
    }
    resetCart() {
        this.cart$.next(null);
        localStorage.removeItem('totals');
        localStorage.removeItem('shipping_method_code');
        this.setGuestCartId('');
        this.customerCartId = NaN;
    }
    changeQuoteStore(storeId) {
        if (this.productionService.isServerMode())
            return;
        if (!this.customerService.isLoggedIn() && !this.getGuestCartId()) {
            return;
        }
        const url = this.customerService.isLoggedIn()
            ? `${this.config.getApiUrl()}carts/mine/changestore`
            : `${this.config.getApiUrl()}guest-carts/${this.getGuestCartId()}/changestore`;
        console.info('changing quote store to', storeId);
        this.http
            .post(url, { storeId: storeId }, { withCredentials: true })
            .pipe(take(1))
            .subscribe({
            next: (response) => {
                this.refreshCart(response.totals);
            },
        });
    }
    afterLogin() {
        const url = this.config.getApiUrl() + `carts/mine/fromguest`;
        return this.http.post(url, { cartId: this.getGuestCartId() }).pipe(map$1((cart) => {
            this.customerCartId = Number.parseInt(cart?.cart_id);
            this.refreshCart(cart?.totals);
        }));
    }
    subscribeToCart() {
        return this.cart$;
    }
    getCart() {
        return this.cart$.value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CartService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CartService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CartService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class AttributeService {
    constructor(storeService) {
        this.storeService = storeService;
    }
    setAttributes(attributes) {
        const result = {};
        for (const attribute of attributes) {
            result[attribute.attribute_code] = { ...attribute };
        }
        this.attributes = result;
    }
    getAttributes() {
        return JSON.parse(JSON.stringify(this.attributes));
    }
    getFilterableAttributes() {
        return Object.values(this.attributes).filter((attribute) => attribute.is_filterable === 1);
    }
    getAttributeLabel(attributeCode) {
        const storeId = this.storeService.getCurrentStoreId();
        const attribute = this.attributes[attributeCode];
        if (!attribute) {
            console.info('Could not find label for attr ' + attributeCode);
            return '';
        }
        if (attribute.store_labels && attribute.store_labels[storeId]) {
            return attribute.store_labels[storeId];
        }
        return attribute.frontend_label;
    }
    filterAttributeByTotal(attribute, layeredCount) {
        const store_id = this.storeService.getCurrentStoreId();
        attribute.options = attribute.options.filter((option) => {
            if (option.store_id !== store_id) {
                return false;
            }
            const countObj = layeredCount[`${attribute.attribute_code}_${option.option_id}`];
            if (isObject(countObj) && countObj.total > 0) {
                option.count = countObj.total;
                return true;
            }
            return false;
        });
    }
    filterAttributeByCount(attribute, layeredCount) {
        const store_id = this.storeService.getCurrentStoreId();
        attribute.options = attribute.options.filter((option) => {
            if (option.store_id !== store_id) {
                return false;
            }
            const countObj = layeredCount[`${attribute.attribute_code}_${option.option_id}`];
            if (countObj && countObj?.count && countObj.count > 0) {
                option.count = countObj.count;
                return true;
            }
            return false;
        });
    }
    filterAttributeByDocCount(attribute, layeredCount) {
        const store_id = this.storeService.getCurrentStoreId();
        attribute.options = attribute.options.filter((option) => {
            if (option.store_id !== store_id) {
                return false;
            }
            const countObj = layeredCount[`${attribute.attribute_code}_${option.option_id}`];
            if (countObj && countObj?.doc_count && countObj.doc_count > 0) {
                option.count = countObj.doc_count;
                return true;
            }
            return false;
        });
    }
    getAttributeText(attributeCode, value) {
        const attribute = this.attributes[attributeCode];
        if (!attribute)
            return false;
        if (attribute.frontend_input == 'select' && attribute?.options?.length > 0) {
            return attribute.frontend_label;
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: AttributeService, deps: [{ token: StoreService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: AttributeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: AttributeService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: StoreService }] });

class TranslationService {
    set translations(value) {
        this._translations = value;
    }
    get translations() {
        if (this._translations) {
            return this._translations;
        }
        const translations = localStorage.getItem('translations');
        return translations ? JSON.parse(translations) : this._translations;
    }
    constructor(configService) {
        this.configService = configService;
    }
    setTranslations(translations) {
        const result = {};
        translations.forEach((translation) => {
            if (!isObject(result[translation.locale])) {
                result[translation.locale] = {};
            }
            result[translation.locale][translation.phrase.toLowerCase()] = translation;
        });
        this.translations = result;
    }
    translate(value) {
        if (!(typeof value === 'string')) {
            console.info('you are trying to translate this', value);
            return '';
        }
        let translated = value;
        value = value.toLowerCase();
        value = value.replace(/(\r\n|\n|\r)/gm, ''); //replace line breaks
        value = value.replace(/\t/gm, ''); //replace tabs
        value = value.replace(/ +/g, ' '); //replace multiple spaces to one space
        const locale = this.configService.getConfig('general/locale/code');
        if (locale && this.translations[locale]) {
            const translation = this.getTranslation(locale, value);
            if (translation && translation.translation) {
                translated = translation.translation;
            }
        }
        return translated;
    }
    /**
     * try to translate with lowercase, with : and . at the end
     * @param locale
     * @param value
     * @param tokens
     */
    getTranslation(locale, value) {
        let translation;
        translation = this.translateAndTryLowerCase(locale, value);
        if (!translation) {
            value = value + '.';
            translation = this.translateAndTryLowerCase(locale, value);
        }
        if (!translation) {
            value = value + ':';
            translation = this.translateAndTryLowerCase(locale, value);
        }
        return translation;
    }
    translateAndTryLowerCase(locale, value) {
        return this.translations[locale][value]
            ? this.translations[locale][value]
            : this.translations[locale][value.toLowerCase()];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TranslationService, deps: [{ token: ConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TranslationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TranslationService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ConfigService }] });

class SpeedyCookieService {
    constructor() {
        this.cookieService = inject(CookieService);
        this.cookieAgreeIndex = 'cookie_agree';
        this.cookieAgreeSubject = new Subject();
    }
    getCookieAgreeValue() {
        const stringValue = this.cookieService.get(this.cookieAgreeIndex);
        const convertedValue = stringValue === 'true';
        if (convertedValue !== null) {
            this.cookieAgreedFlag = convertedValue;
            return this.cookieAgreedFlag;
        }
        return false;
    }
    agreeToUseCookies() {
        const expiryDate = new Date(Date.now() + 1000 /*sec*/ * 60 /*min*/ * 60 /*hour*/ * 24 /*day*/ * 365);
        this.cookieService.set(this.cookieAgreeIndex, 'true', expiryDate);
        this.cookieAgreeSubject.next(true);
    }
    disagreeToUseCookies() {
        const expiryDate = new Date(Date.now() + 1000 /*sec*/ * 60 /*min*/ * 60 /*hour*/ * 24 /*day*/ * 30);
        this.cookieService.set(this.cookieAgreeIndex, 'false', { expires: expiryDate });
        this.cookieAgreeSubject.next(false);
    }
    subscribeToCookieAgreed() {
        return this.cookieAgreeSubject.asObservable();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SpeedyCookieService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SpeedyCookieService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SpeedyCookieService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class UrlService {
    constructor() {
        this.previousUrl = new BehaviorSubject(null);
    }
    setPreviousUrl(previousUrl) {
        this.previousUrl.next(previousUrl);
    }
    get previousUrl$() {
        return this.previousUrl;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: UrlService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: UrlService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: UrlService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class GoogleAnalyticsService {
    constructor(
    // private titleCasePipe: TitleCasePipe,
    configService, productionService, eventsService, cookieService, urlService) {
        this.configService = configService;
        this.productionService = productionService;
        this.eventsService = eventsService;
        this.cookieService = cookieService;
        this.urlService = urlService;
        this.initialized = false;
        this.firstLoad = false;
    }
    init() {
        if (this.productionService.isServerMode())
            return;
        this.gaId = this.configService.getConfig('speedy/ga/property_id');
        const enable = this.configService.getConfig('speedy/ga/enable');
        const cookieAgreeValue = this.cookieService.getCookieAgreeValue();
        if (enable && this.gaId && this.gaId.length > 0 && !this.initialized) {
            this.initialized = true;
            this.appendScripts();
            this.bindEvents();
            if (cookieAgreeValue) {
                this.bindEcommerceTrackingEvents();
            }
        }
        this.cookieService.subscribeToCookieAgreed().subscribe((agreed) => {
            if (agreed) {
                this.bindEcommerceTrackingEvents();
            }
        });
    }
    bindEvents() {
        this.eventsService.on('page_view', this.navigation.bind(this));
        this.eventsService.on('product_view', this.productPageView.bind(this));
    }
    bindEcommerceTrackingEvents() {
        this.eventsService.on('add_to_cart', this.productAddedToCart.bind(this));
        this.eventsService.on('remove_from_cart', this.productRemoveFromCart.bind(this));
        this.eventsService.on('begin_checkout', this.beginCheckout.bind(this));
        this.eventsService.on('checkout_transport', this.checkoutTransport.bind(this));
        this.eventsService.on('checkout_payment', this.checkoutPayment.bind(this));
        this.eventsService.on('purchase', this.purchase.bind(this));
    }
    appendScripts() {
        const script = document.createElement('script');
        script.setAttribute('defer', '');
        script.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${this.gaId}`);
        document.body.appendChild(script);
        const scriptId = 'google-analytics';
        const script2 = document.createElement('script');
        script2.setAttribute('defer', '');
        script2.type = 'text/javascript';
        script2.id = scriptId;
        script2.innerText = `window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', '${this.gaId}', { 'anonymize_ip': true });
`;
        this.firstLoad = true;
        document.body.appendChild(script2);
        dataLayer.push({ ecommerce: {} });
    }
    navigation(event) {
        if (!this.initialized)
            return;
        const url = event['urlAfterRedirects'];
        if (['/', '/ee', '/ee/home'].indexOf(url) == -1 && !this.firstLoad) {
            const url = event['urlAfterRedirects'];
            gtag('config', this.gaId, { page_path: url });
        }
        else {
            this.firstLoad = false;
        }
    }
    productPageView(product) {
        if (!this.initialized)
            return;
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'productClick',
            ecommerce: {
                currencyCode: 'EUR',
                click: {
                    products: [this.getGAItem(product)],
                },
            },
        });
    }
    productDetailsView(product) {
        if (!this.initialized)
            return;
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'productDetails',
            ecommerce: {
                currencyCode: 'EUR',
                detail: {
                    products: [this.getGAItem(product)],
                },
            },
        });
    }
    productRelatedProducts(product, relatedProducts) {
        if (!this.initialized)
            return;
        dataLayer.push({ ecommerce: null });
        const impressions = relatedProducts.map((prod, idx) => {
            return {
                position: idx + 1,
                name: prod.name,
                id: prod.sku,
                category: prod.category_label,
                price: prod.finalPrice ? prod.finalPrice : prod.price,
                brand: prod.option_text_brand,
                list: 'Related Products',
            };
        });
        dataLayer.push({
            event: 'productDetails',
            ecommerce: {
                currencyCode: 'EUR',
                impressions: impressions,
                detail: {
                    actionField: { list: '' },
                    products: [this.getGAItem(product)],
                },
            },
        });
    }
    productsCategoryList(products, category) {
        if (!this.initialized)
            return;
        dataLayer.push({ ecommerce: null });
        const impressions = products.map((prod, idx) => {
            return {
                ...this.getGAItem(prod),
                position: idx + 1,
                list: category && category.name ? category.name : 'Search results',
            };
        });
        dataLayer.push({
            event: 'productImpression',
            ecommerce: {
                currencyCode: 'EUR',
                impressions: impressions,
            },
        });
    }
    productAddedToCart(product) {
        if (!this.initialized)
            return;
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'addToCart',
            ecommerce: {
                currencyCode: 'EUR',
                add: {
                    products: [this.getGAItem(product)],
                },
            },
        });
    }
    productRemoveFromCart(row) {
        if (!this.initialized)
            return;
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'removeFromCart',
            ecommerce: {
                currencyCode: 'EUR',
                remove: {
                    products: [
                        this.getGAItem(row.extension_attributes.product, row.qty, row.extension_attributes.category_label, row.extension_attributes.brand),
                    ],
                },
            },
        });
    }
    beginCheckout(totals) {
        if (!totals || !totals.items || totals.items.length == 0)
            return;
        if (!this.initialized)
            return;
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                currencyCode: 'EUR',
                checkout: {
                    actionField: { step: 1 },
                    products: this.convertTotals(totals),
                },
            },
        });
    }
    checkoutTransport(totals, shippingMethod) {
        if (!this.initialized)
            return;
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                currencyCode: 'EUR',
                checkout: {
                    actionField: { step: 2, option: shippingMethod.carrier_title },
                    products: this.convertTotals(totals),
                },
            },
        });
    }
    checkoutPayment(totals, paymentMethod) {
        if (!this.initialized)
            return;
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                currencyCode: 'EUR',
                checkout: {
                    actionField: { step: 3, option: paymentMethod.title },
                    products: this.convertTotals(totals),
                },
            },
        });
    }
    purchase(incrementId, totals) {
        if (!this.initialized)
            return;
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            ecommerce: {
                currencyCode: totals['quote_currency_code'],
                purchase: {
                    actionField: {
                        id: incrementId, // Transaction ID. Required for purchases and refunds.
                        revenue: totals['grand_total'], // Total transaction value (incl. tax and shipping)
                        tax: totals['tax_amount'], // 2 decimal places
                        shipping: totals['shipping_amount'], // For free shipping 0
                        coupon: '', //
                    },
                    products: this.convertTotals(totals),
                },
            },
        });
    }
    convertTotals(totals) {
        const items = [];
        let product;
        totals.items.forEach((item) => {
            product = item['extension_attributes']['product'];
            items.push(this.getGAItem(product, item['qty'], item['extension_attributes']['category_label'], item['extension_attributes']['brand']));
        });
        return items;
    }
    getGAItem(product, qty = 1, category_label, brand) {
        return {
            name: product.name, // Name or ID is required.
            id: product.sku,
            price: product.finalPrice ? product.finalPrice : product['price'],
            brand: product.option_text_brand ? product.option_text_brand : brand,
            quantity: qty,
            category: product.category_label ? product.category_label : category_label,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GoogleAnalyticsService, deps: [{ token: ConfigService }, { token: ProductionService }, { token: EventsService }, { token: SpeedyCookieService }, { token: UrlService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GoogleAnalyticsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: GoogleAnalyticsService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ConfigService }, { type: ProductionService }, { type: EventsService }, { type: SpeedyCookieService }, { type: UrlService }] });

class PageService {
    constructor(storeService, configService, http) {
        this.storeService = storeService;
        this.configService = configService;
        this.http = http;
        this.pages = [];
    }
    setPages(pages) {
        this.pages = pages;
    }
    getPage(identifier) {
        const page = this.pages?.find((p) => Number.parseInt(p.store_id) === this.storeService.getCurrentStoreId() &&
            p.identifier === identifier);
        if (page) {
            return of(page);
        }
        const url = `${this.configService.expressApiUrl}cms/pages/identifier/${identifier}`;
        return this.http.get(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: PageService, deps: [{ token: StoreService }, { token: ConfigService }, { token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: PageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: PageService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: StoreService }, { type: ConfigService }, { type: i1$1.HttpClient }] });

class SeoService {
    constructor(doc, request, configService, storeService, productionService, meta) {
        this.doc = doc;
        this.request = request;
        this.configService = configService;
        this.storeService = storeService;
        this.productionService = productionService;
        this.meta = meta;
    }
    init(stores) {
        if (this.productionService.isServerMode()) {
            if (!this.isCmsPage()) {
                this.addHrefLangLinks(stores);
            }
            else {
                this.addHrefLangForStore(this.storeService.getCurrentStore());
                this.addHrefLangForStore(this.storeService.getCurrentStore(), true);
            }
            this.createLinkForCanonicalURL();
        }
    }
    isCmsPage() {
        return this.getUrl().indexOf('/page/') > -1;
    }
    createLinkForCanonicalURL(url = '') {
        const link = this.doc.createElement('link');
        this.doc.head.appendChild(link);
        link.setAttribute('rel', 'canonical');
        url = url ? url : this.getUrl();
        link.setAttribute('href', this.getCanonicalUrl(url));
    }
    getUrl() {
        return 'https' + '://' + 'mehka.ee' + this.request.originalUrl;
    }
    getCanonicalUrl(url) {
        url = url.toLowerCase();
        if (url.indexOf('?') > -1) {
            url = url.substring(0, url.indexOf('?'));
        }
        if (url.indexOf('#') > -1) {
            url = url.substring(0, url.indexOf('#'));
        }
        return url;
    }
    addHrefLangLinks(stores) {
        Object.keys(stores).find((key) => {
            if (stores[key].code === this.storeService.getDefaultStoreCode()) {
                this.addHrefLangForStore(stores[key], true);
                this.addHrefLangForStore(stores[key]);
            }
        });
    }
    addHrefLangForStore(store, defaultHrefLang = false) {
        const speedyUrl = this.configService.getSpeedyUrl();
        const locale = this.getLocale(store);
        let hrefLang = locale.substr(0, 2);
        if (defaultHrefLang) {
            hrefLang = 'x-default';
        }
        if (hrefLang) {
            const linkElement = this.doc.createElement('link');
            this.doc.head.appendChild(linkElement);
            let path = this.request.originalUrl;
            path = path.substring(1); // remove the first character (assuming it's a '/')
            const pathArray = path.split('/'); // split the path into an array
            // Remove the first element of the array (assuming you want to remove the first segment of the path)
            pathArray.shift();
            // Join the array back into a string with '/' as the separator
            path = pathArray.join('/');
            let hrefLangUrl = `${speedyUrl}/${store.code}/${path}`;
            hrefLangUrl = this.getCanonicalUrl(hrefLangUrl);
            linkElement.setAttribute('rel', 'alternate');
            linkElement.setAttribute('href', hrefLangUrl);
            linkElement.setAttribute('hrefLang', hrefLang);
        }
    }
    getLocale(store) {
        let locale = this.configService.getByScope('general/locale/code', 'stores', store.code);
        if (!locale) {
            const website = this.storeService.getWebsite();
            locale = this.configService.getByScope('general/locale/code', 'websites', website.code);
        }
        if (!locale) {
            locale = this.configService.getConfig('general/locale/code');
        }
        return locale;
    }
    setLangTag() {
        const locale = this.configService.getConfig('general/locale/code');
        const lang = locale.substr(0, 2);
        const html = this.doc.getElementsByTagName('html')[0];
        html.setAttribute('lang', lang);
        this.meta.addTag({ httpEquiv: 'content-language', content: lang });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SeoService, deps: [{ token: DOCUMENT }, { token: 'REQUEST', optional: true }, { token: ConfigService }, { token: StoreService }, { token: ProductionService }, { token: i1.Meta }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SeoService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SeoService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['REQUEST']
                }] }, { type: ConfigService }, { type: StoreService }, { type: ProductionService }, { type: i1.Meta }] });

class DataService {
    constructor() {
        this.configService = inject(ConfigService);
        this.storeService = inject(StoreService);
        this.attributeService = inject(AttributeService);
        this.translationService = inject(TranslationService);
        this.pageService = inject(PageService);
        this.blockService = inject(BlockService);
        this.http = inject(HttpClient);
        this.productionService = inject(ProductionService);
        this.seoService = inject(SeoService);
        this.customerService = inject(CustomerService);
        this.authService = inject(AuthService);
        this.cartService = inject(CartService);
        /**
         * block identifier or a wildcard pattern like footer_link_*
         */
        this.preLoadedBlocks = [
            'checkout_summary_field_label_*',
            'register_password_info',
            'checkout_success_text',
            'footer_links*',
            'top_menu_left_side_advertising_block',
            'services_contacts_*',
            'product_main_banner',
        ];
    }
    /** Main function to get all data and init all main services */
    initialize() {
        return this.http
            .get(this.configService.expressApiUrl + 'data', {
            params: {
                blocks: this.preLoadedBlocks.toString(),
            },
        })
            .pipe(filter$1((r) => !!r), tap$1((response) => this.bootstrap({ ...response })), catchError$1((error) => {
            if (error.status === HttpStatusCode.Unauthorized) {
                this.handleUnauthorizedError();
                return throwError(() => error.message);
            }
            return EMPTY;
        }), retry(2));
    }
    handleUnauthorizedError() {
        this.cartService.resetCart();
        this.authService.logout();
        this.customerService.logout(false);
        this.cartService.initCart();
    }
    bootstrap(response) {
        this.storeService.setStores(response['store']);
        this.storeService.setWebsites(response['website']);
        this.configService.setConfig(response['config']);
        this.attributeService.setAttributes(response['attribute']);
        this.translationService.setTranslations(response['translation']);
        this.pageService.setPages(response['page']);
        this.blockService.setBlocks(response['block']);
        this.seoService.init(this.storeService.getStores());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DataService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class ServerResponseService {
    constructor(routerService, response) {
        this.routerService = routerService;
        this.notFound = new BehaviorSubject(false);
        this.response = response;
    }
    getHeader(key) {
        return this.response.getHeader(key);
    }
    setHeader(key, value) {
        if (this.response) {
            this.response.header(key, value);
        }
        return this;
    }
    setStatus(code, message) {
        if (this.response) {
            this.response.statusCode = code;
            if (message) {
                this.response.statusMessage = message;
            }
        }
        return this;
    }
    setNotFound(message = 'not found') {
        if (this.response) {
            this.response.statusCode = 404;
            this.response.statusMessage = message;
        }
        this.notFound.next(true);
        this.routerService.routeNotFound();
        return this;
    }
    resetNotFound() {
        if (this.response) {
            this.response.statusCode = 200;
        }
        this.notFound.next(false);
    }
    setUnauthorized(message = 'Unauthorized') {
        if (this.response) {
            this.response.statusCode = 401;
            this.response.statusMessage = message;
        }
        return this;
    }
    setError(message = 'internal server error') {
        if (this.response) {
            this.response.statusCode = 500;
            this.response.statusMessage = message;
        }
        return this;
    }
    set301Redirect(newUrl) {
        if (this.response) {
            this.response.set('location', newUrl);
            this.response.status(301).send();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ServerResponseService, deps: [{ token: RouterService }, { token: 'RESPONSE', optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ServerResponseService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ServerResponseService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: RouterService }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['RESPONSE']
                }] }] });

class CategoryCache {
    constructor() {
        this.categories = {};
    }
    /**
     * Checks if categories exist for the specified store code.
     * @param storeCode The store code to check.
     * @returns True if categories exist, otherwise false.
     */
    hasCategories(storeCode) {
        return !!this.categories[storeCode]?.length;
    }
    /**
     * Retrieves the categories for the specified store code.
     * @param storeCode The store code to retrieve categories for.
     * @returns An array of Category objects.
     */
    getCategories(storeCode) {
        return this.categories[storeCode] || [];
    }
    /**
     * Sets the categories for the specified store code.
     * @param storeCode The store code to set categories for.
     * @param categories An array of Category objects.
     */
    setCategories(storeCode, categories) {
        this.categories[storeCode] = categories;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CategoryCache, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CategoryCache, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CategoryCache, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class CategoryApi {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
    }
    /**
     * Retrieves a list of categories.
     * @returns An Observable of an array of Category objects.
     */
    getCategories() {
        const url = `${this.configService.expressApiUrl}categories/menu`;
        return this.http.get(url);
    }
    /**
     * Retrieves a category by its ID.
     * @param categoryId - The ID of the category.
     * @returns An Observable of a Category object.
     */
    getCategoryById(categoryId) {
        const url = `${this.configService.expressApiUrl}categories/${categoryId}`;
        return this.http.get(url);
    }
    /**
     * Retrieves multiple categories by their IDs in a batch request.
     * @param ids - An array of category IDs.
     * @returns An Observable of an array of Category objects.
     */
    getCategoriesByIds(ids) {
        return this.http.get(`${this.configService.expressApiUrl}categories`, {
            params: {
                ids: ids.toString(),
            },
        });
    }
    /**
     * Retrieves a category by its URL key.
     * @param urlKey - The URL key of the category.
     * @returns An Observable of a Category object.
     */
    getCategoryByUrlKey(urlKey) {
        const url = `${this.configService.expressApiUrl}categories/url-key/${urlKey}`;
        return this.http.get(url);
    }
    /**
     * Retrieves a category by its URL path.
     * @param path - The URL path of the category.
     * @returns An Observable of a Category object.
     */
    getCategoryByUrlPath(path) {
        const url = `${this.configService.expressApiUrl}categories/url-path/${path}`;
        return this.http.get(url);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CategoryApi, deps: [{ token: i1$1.HttpClient }, { token: ConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CategoryApi, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CategoryApi, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: ConfigService }] });

class CategoryService {
    constructor() {
        this.categoryApi = inject(CategoryApi);
        this.categoryCache = inject(CategoryCache);
        this.storeService = inject(StoreService);
        this.productionService = inject(ProductionService);
    }
    /**
     * Retrieves a list of categories. If the categories are already cached, it returns the cached data.
     * Otherwise, it makes an API call to fetch the categories and caches the response.
     * @returns An Observable that emits the list of categories.
     */
    getCategories() {
        const storeCode = this.storeService.getCurrentStoreCode();
        if (this.categoryCache.hasCategories(storeCode)) {
            return of(this.categoryCache.getCategories(storeCode));
        }
        return this.categoryApi.getCategories().pipe(map((response) => {
            this.categoryCache.setCategories(storeCode, response);
            return response;
        }));
    }
    /**
     * Retrieves a single category by its ID.
     * @param categoryId The ID of the category to retrieve.
     * @returns An Observable that emits the category.
     */
    getCategoryById(categoryId) {
        return this.categoryApi.getCategoryById(categoryId);
    }
    /**
     * Retrieves multiple categories by their IDs in a batch request.
     * @param ids The IDs of the categories to retrieve.
     * @returns An Observable that emits the categories.
     */
    getCategoriesByIds(ids) {
        return this.categoryApi.getCategoriesByIds(ids);
    }
    /**
     * Retrieves a category by its URL key. If the category is already cached, it returns the cached data.
     * Otherwise, it makes an API call to fetch the category.
     * @param urlKey The URL key of the category to retrieve.
     * @returns An Observable that emits the category.
     */
    getCategoryByUrlKey(urlKey) {
        const storeCode = this.storeService.getCurrentStoreCode();
        if (this.categoryCache.hasCategories(storeCode)) {
            const searchedCategory = this.categoryCache
                .getCategories(storeCode)
                ?.find((category) => category.url_key === urlKey);
            if (searchedCategory) {
                this.attachParentCategory(searchedCategory, storeCode);
                return of(searchedCategory);
            }
        }
        return this.categoryApi.getCategoryByUrlKey(urlKey);
    }
    /**
     * Retrieves a category by its URL path. If the category is already cached, it returns the cached data.
     * Otherwise, it makes an API call to fetch the category.
     * @param path The URL path of the category to retrieve.
     * @returns An Observable that emits the category.
     */
    getCategoryByUrlPath(path) {
        const storeCode = this.storeService.getCurrentStoreCode();
        if (this.categoryCache.hasCategories(storeCode)) {
            const searchedCategory = this.categoryCache
                .getCategories(storeCode)
                ?.find((category) => category.url_path === path);
            if (searchedCategory) {
                this.attachParentCategory(searchedCategory, storeCode);
                return of(searchedCategory);
            }
        }
        return this.categoryApi.getCategoryByUrlPath(path);
    }
    /**
     * Attaches the parent category to a subcategory by finding the parent category in the cached categories.
     * @param subCategory The subcategory to attach the parent category to.
     * @param storeCode The store code.
     */
    attachParentCategory(subCategory, storeCode) {
        const parent = this.categoryCache
            .getCategories(storeCode)
            .find((category) => Number(subCategory.parent_id) === Number(category.id));
        if (parent) {
            subCategory.parent = parent;
        }
    }
    /**
     * Removes the last viewed category from session storage.
     */
    removeLastCategory() {
        if (this.productionService.isServerMode())
            return;
        this.lastCategory = undefined;
    }
    /**
     * Set the last viewed category to session storage.
     */
    setLastCategory(category) {
        if (this.productionService.isServerMode())
            return;
        this.lastCategory = category;
    }
    /**
     * Get the last viewed category from session storage.
     */
    getLastCategory() {
        if (this.productionService.isServerMode())
            return false;
        return this.lastCategory !== undefined ? this.lastCategory : false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CategoryService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CategoryService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CategoryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class LayeredService {
    constructor(attributeService, customerService, configService, productService, storeService, http) {
        this.attributeService = attributeService;
        this.customerService = customerService;
        this.configService = configService;
        this.productService = productService;
        this.storeService = storeService;
        this.http = http;
        this.defaultPageSize = 48;
        this.pageSize = this.defaultPageSize;
        this.currentPage = 1;
        this.sortField = 'price';
        this.sortDirection = 'asc';
        this.searchBySpareParts = false;
    }
    setCategory(category) {
        this.category = category;
    }
    setFilters(filters) {
        this.filters = filters;
    }
    setPageSize(pageSize) {
        this.pageSize = pageSize;
    }
    setCurrentPage(currentPage) {
        this.currentPage = currentPage;
    }
    setSortField(sortField) {
        this.sortField = sortField;
    }
    setSortDirection(sortDirection) {
        this.sortDirection = sortDirection;
    }
    setFromPrice(price) {
        this.fromPrice = price;
    }
    setToPrice(price) {
        this.toPrice = price;
    }
    setSearchQuery(searchQuery) {
        this.searchQuery = searchQuery;
    }
    resetPriceFilter() {
        this.toPrice = NaN;
        this.fromPrice = NaN;
    }
    reset() {
        this.category = {};
        this.pageSize = this.defaultPageSize;
        this.currentPage = 1;
        this.searchQuery = '';
        this.filters = {};
        this.resetPriceFilter();
    }
    setSearchBySpareParts(value) {
        this.searchBySpareParts = value;
    }
    query() {
        const payload = {
            filters: this.filters,
            attributes: this.attributeService.getFilterableAttributes(),
            from_price: this.fromPrice,
            to_price: this.toPrice,
            pageSize: this.pageSize,
            currentPage: this.currentPage,
            sortField: this.sortField,
            sortDirection: this.sortDirection,
            searchQuery: this.searchQuery,
            searchBySpareParts: this.searchBySpareParts,
        };
        if (this.category) {
            payload['categoryId'] = this.category?.id;
        }
        if (this.category && this.category?.positions && this.sortField === 'position') {
            payload['product_positions'] = this.category.positions;
        }
        return this.http
            .post(`${this.configService.expressApiUrl}layered`, payload)
            .pipe(map((layered) => {
            layered?.products.forEach((product) => {
                this.productService.setMedia(product);
            });
            return layered;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: LayeredService, deps: [{ token: AttributeService }, { token: CustomerService }, { token: ConfigService }, { token: ProductService }, { token: StoreService }, { token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: LayeredService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: LayeredService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: AttributeService }, { type: CustomerService }, { type: ConfigService }, { type: ProductService }, { type: StoreService }, { type: i1$1.HttpClient }] });

class FaviconService {
    constructor(document, configService) {
        this.document = document;
        this.configService = configService;
    }
    setFavicon() {
        if (!this.document) {
            return;
        }
        const faviconPath = this.configService.getConfig('design/head/shortcut_icon');
        if (faviconPath === undefined) {
            return;
        }
        const faviconUrl = this.configService.mediaUrl + 'favicon/' + faviconPath;
        const linkElement = this.document.getElementById('favicon');
        linkElement.type = 'image/x-icon';
        linkElement.rel = 'icon';
        linkElement.href = faviconUrl;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: FaviconService, deps: [{ token: DOCUMENT }, { token: ConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: FaviconService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: FaviconService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: ConfigService }] });

class MetaService {
    constructor() {
        this.titleService = inject(Title);
        this.meta = inject(Meta);
        this.TranslationService = inject(TranslationService);
        this.configService = inject(ConfigService);
        this.getTitleSuffix = () => this.configService.getTitleSuffix();
        this.getTitlePrefix = () => this.configService.getTitlePrefix();
    }
    /**
     * we take root route for cases when final route does not have a title or a breadcrumb
     *
     * @param route
     * @returns {any}
     */
    setMetaDataRecursive(route) {
        //get the child routes
        const children = route.children;
        //return if there are no more children
        if (children.length === 0) {
            this.setMetaData(route);
        }
        //iterate over each children
        for (const child of children) {
            //verify primary route
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }
            //recursive
            return this.setMetaDataRecursive(child);
        }
    }
    setMetaData(route) {
        this.resetMetaData();
        const data = route.snapshot.data;
        switch (data['breadcrumb']) {
            case 'product':
                if (data?.product) {
                    this.setMetaDataProduct(data['product']);
                }
                break;
            case 'category':
                if (data?.data?.category) {
                    this.setMetaDataCategory(data.data.category);
                }
                break;
            case 'page':
                if (data?.page) {
                    this.setMetaDataPage(data['page']);
                }
                break;
            case 'Post':
                if (data?.post) {
                    this.setMetaDataNewsPost(data['post']);
                }
                break;
            case 'home':
                if (data?.home?.homePage) {
                    this.setMetaDataHome(data.home.homePage);
                }
                break;
            default:
                this.setMetaDataDefault(data);
        }
    }
    setMetaDataHome(page) {
        const title = page.meta_title.length > 0 ? page.meta_title : page.title;
        const description = page.meta_description;
        const keywords = page.meta_keywords;
        this.setMetaTitle(title);
        if (description?.length) {
            this.meta.addTag({ name: 'description', content: description });
            this.meta.addTag({ name: 'og:description', content: description });
        }
        if (keywords?.length) {
            this.meta.addTag({ name: 'keywords', content: keywords });
        }
    }
    setMetaDataProduct(product) {
        let title = product?.meta_title;
        title = title && title.length > 0 ? title : product.name;
        const metaTitle = Array.isArray(title) ? title[0] : title;
        this.setMetaTitle(metaTitle);
        const metaDesc = Array.isArray(product?.meta_description)
            ? product?.meta_description[0]
            : product?.meta_description;
        if (metaDesc?.length > 0) {
            this.meta.addTag({ name: 'description', content: metaDesc });
            this.meta.addTag({ name: 'og:description', content: metaDesc });
        }
        else if (product['description']) {
            const productDesc = product['description'].replace(/<(.|\n)*?>/g, '');
            this.meta.addTag({ name: 'description', content: productDesc });
            this.meta.addTag({ name: 'og:description', content: productDesc });
        }
        const metaKeywords = Array.isArray(product?.meta_keyword)
            ? product?.meta_keyword[0]
            : product?.meta_keyword;
        if (metaKeywords && metaKeywords.length > 0) {
            this.meta.addTag({ name: 'keywords', content: metaKeywords });
        }
        this.meta.addTag({ name: 'og:title', content: title });
        this.meta.addTag({ name: 'og:image', content: product['image_small'] });
    }
    setMetaDataCategory(category) {
        let title = category?.meta_title;
        title = title && title.length > 0 ? title : category['name'];
        this.setMetaTitle(title);
        const metaDesc = category?.meta_description;
        if (metaDesc?.length > 0) {
            this.meta.addTag({ name: 'description', content: metaDesc });
        }
        else if (category?.description) {
            const description = category.description.replace(/<(.|\n)*?>/g, '');
            this.meta.addTag({ name: 'description', content: description });
        }
        const metaKeywords = category?.meta_keywords;
        if (metaKeywords && metaKeywords.length > 0) {
            this.meta.addTag({ name: 'keywords', content: metaKeywords });
        }
    }
    setMetaDataDefault(data) {
        if (data?.breadcrumb) {
            let title = data.breadcrumb.charAt(0).toUpperCase() + data['breadcrumb'].substr(1);
            title = this.TranslationService.translate(title);
            this.titleService.setTitle(title);
            this.setMetaTitle(title);
        }
    }
    resetMetaData() {
        this.meta.removeTag('name="og:description"');
        this.meta.removeTag('name="og:title"');
        this.meta.removeTag('name="og:image"');
        this.meta.removeTag('name="description"');
        this.meta.removeTag('name="keywords"');
    }
    setMetaDataPage(page) {
        let title = page.meta_title;
        title = title && title.length > 0 ? title : page['title'];
        this.setMetaTitle(title);
        const metaDesc = page.meta_description;
        if (metaDesc?.length > 0) {
            this.meta.addTag({ name: 'description', content: metaDesc });
        }
        else if (page.description) {
            const description = page.description.replace(/<(.|\n)*?>/g, '');
            this.meta.addTag({ name: 'description', content: description });
        }
        const metaKeywords = page.meta_keywords;
        if (metaKeywords?.length > 0) {
            this.meta.addTag({ name: 'keywords', content: metaKeywords });
        }
    }
    setMetaDataNewsPost(post) {
        let title = post?.meta_title;
        title = title && title.length > 0 ? title : post['name'];
        this.setMetaTitle(title);
        const metaDesc = post.meta_description;
        if (metaDesc?.length > 0) {
            this.meta.addTag({ name: 'description', content: metaDesc });
        }
        else if (post?.short_description) {
            const description = post.short_description.replace(/<(.|\n)*?>/g, '');
            this.meta.addTag({ name: 'description', content: description });
        }
        const metaKeywords = post['meta_keywords'];
        if (metaKeywords?.length > 0) {
            this.meta.addTag({ name: 'keywords', content: metaKeywords });
        }
    }
    setMetaTitle(baseTitle) {
        const suffix = this.getTitleSuffix();
        const prefix = this.getTitlePrefix();
        if (prefix) {
            baseTitle = prefix + baseTitle;
        }
        if (suffix) {
            baseTitle += suffix;
        }
        this.titleService.setTitle(baseTitle);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: MetaService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: MetaService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: MetaService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class ZendeskService {
    constructor() {
        this.productionService = inject(ProductionService);
        this.initialised = false;
    }
    init() {
        if (this.productionService.isServerMode())
            return;
        if (!this.initialised) {
            // this.appendScripts();
            this.initialised = true;
        }
    }
    appendScripts() {
        const scriptId = 'zen-desk';
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.setAttribute('defer', '');
        script.id = scriptId;
        script.innerText = `window.$zopim||(function(d,s){var z=$zopim=function(c){
                        z._.push(c)},$=z.s=
                        d.createElement(s),e=d.getElementsByTagName(s)[0];z.set=function(o){z.set.
                        _.push(o)};z._=[];z.set._=[];$.async=!0;$.setAttribute('charset','utf-8');
                        $.src='https://v2.zopim.com/?3dKwdWhovffkH2lIsHbaytIlsSyJZVPY';z.t=+new Date;$.
                        type='text/javascript';e.parentNode.insertBefore($,e)})(document,'script');`;
        document.body.appendChild(script);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ZendeskService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ZendeskService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ZendeskService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class SearchService {
    constructor(http, configService, layeredService, productService) {
        this.http = http;
        this.configService = configService;
        this.layeredService = layeredService;
        this.productService = productService;
        this.defaultPayload = {
            pageSize: 48,
            sortDirection: 'desc',
            sortField: '_score',
            currentPage: 1,
        };
    }
    search(keyword) {
        return this.http
            .get(`${this.configService.get('expressApiUrl')}search/autocomplete`, {
            params: {
                keyword,
            },
        })
            .pipe(map$1((data) => {
            data.products.forEach((item) => {
                this.productService.setMedia(item);
            });
            return data;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SearchService, deps: [{ token: i1$1.HttpClient }, { token: ConfigService }, { token: LayeredService }, { token: ProductService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SearchService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SearchService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: ConfigService }, { type: LayeredService }, { type: ProductService }] });

class TaxService {
    constructor(configService) {
        this.configService = configService;
        this.EXCLUDE_TAX = 1;
        this.INCLUDE_TAX = 2;
        this.EXCLUDE_INCLUDE_TAX = 3;
    }
    getRowTotal(row) {
        const taxPriceDisplay = this.getTaxPriceDisplay();
        if (taxPriceDisplay == this.EXCLUDE_TAX) {
            return row.row_total;
        }
        else {
            return row.row_total_incl_tax;
        }
    }
    getRowTotalWithoutDiscount(row) {
        return row.extension_attributes.product.price * row.qty;
    }
    calculateTotalDiscount(cart) {
        if (!cart)
            return NaN;
        let totalDiscount = 0;
        cart?.items?.map((item) => (totalDiscount =
            totalDiscount +
                Number.parseFloat(item.extension_attributes.product.price) * item.qty));
        return (totalDiscount = Number.parseFloat((totalDiscount - cart.base_grand_total).toFixed(2)));
    }
    getRowPrice(row) {
        const taxPriceDisplay = this.getTaxPriceDisplay();
        if (taxPriceDisplay == this.EXCLUDE_TAX) {
            return row.price;
        }
        else {
            return row.price_incl_tax;
        }
    }
    getTaxPriceDisplay() {
        return parseInt(this.configService.getConfig('tax/cart_display/price'));
    }
    getSubtotal(totals) {
        return this._getTotal(totals, 'subtotal');
    }
    getGrandTotal(totals) {
        return this._getTotal(totals, 'grand_total');
    }
    _getTotal(totals, code) {
        if (totals && totals.total_segments && totals.total_segments.length > 0) {
            const totalSegment = totals.total_segments.find((segment) => segment.code === code);
            if (totalSegment) {
                return totalSegment.value;
            }
        }
        return 0;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TaxService, deps: [{ token: ConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TaxService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TaxService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: ConfigService }] });

class CouponService {
    constructor(cartService, customerService, alertService, config, http) {
        this.cartService = cartService;
        this.customerService = customerService;
        this.alertService = alertService;
        this.config = config;
        this.http = http;
    }
    addCoupon(couponCode) {
        const url = this.customerService.isLoggedIn()
            ? `${this.config.getApiUrl()}carts/mine/speedycoupons/${couponCode}`
            : `${this.config.getApiUrl()}guest-carts/${this.cartService.getGuestCartId()}/speedycoupons/${couponCode}`;
        return this.http.put(url, {}).pipe(map((response) => {
            this.alertService.success('The coupon was applied');
            this.cartService.refreshCart(response.totals);
            return response;
        }), catchError$1((error) => {
            this.alertService.error(error?.error?.message ?? 'There was a problem applying the coupon');
            return EMPTY;
        }));
    }
    removeCoupon(couponCode) {
        const url = this.customerService.isLoggedIn()
            ? `${this.config.getApiUrl()}carts/mine/speedycoupons/${couponCode}`
            : `${this.config.getApiUrl()}guest-carts/${this.cartService.getGuestCartId()}/speedycoupons/${couponCode}`;
        return this.http.delete(url, {}).pipe(map((response) => {
            this.alertService.success('The coupon was deleted');
            this.cartService.refreshCart(response.totals);
            return response;
        }), catchError$1((error) => {
            this.alertService.error(error?.error?.message ?? 'There was a problem applying the coupon');
            return EMPTY;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CouponService, deps: [{ token: CartService }, { token: CustomerService }, { token: i3.ToastrService }, { token: ConfigService }, { token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CouponService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CouponService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: CartService }, { type: CustomerService }, { type: i3.ToastrService }, { type: ConfigService }, { type: i1$1.HttpClient }] });

class NewsletterService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
    }
    subscribeToNewsletter(email) {
        return this.http.post(`${this.config.getApiUrl()}newsletter/subscribe/${email}`, {});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NewsletterService, deps: [{ token: i1$1.HttpClient }, { token: ConfigService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NewsletterService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NewsletterService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: ConfigService }] });

class UrlRewriteService {
    constructor() {
        this.http = inject(HttpClient);
        this.config = inject(ConfigService);
    }
    getProductUrlRewrite(requestPath) {
        const url = `${this.config.get('expressApiUrl')}url-rewrite/product/get`;
        return this.http.post(url, { request_path: requestPath });
    }
    getCategoryUrlRewrite(requestPath) {
        const url = `${this.config.get('expressApiUrl')}url-rewrite/category/get`;
        return this.http.post(url, { request_path: requestPath });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: UrlRewriteService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: UrlRewriteService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: UrlRewriteService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class InbankService {
    constructor(http, configService, alertService, customerService, cartService) {
        this.http = http;
        this.configService = configService;
        this.alertService = alertService;
        this.customerService = customerService;
        this.cartService = cartService;
        this.inbankForm = new BehaviorSubject(null);
        this.configData = new BehaviorSubject(null);
        this.calculationsData = new BehaviorSubject(null);
        this.offer = { uuid: null };
        this.contract = { uuid: null, link: null };
    }
    async getInbankConfigData() {
        try {
            return await lastValueFrom(this.http.get(this.configService.getApiUrl() + 'inbank/config'));
        }
        catch (e) {
            this.alertService.error(e.error.error ? e.error.error : e.message);
            return e;
        }
    }
    async getInbankCalculatorData(params) {
        try {
            return await lastValueFrom(this.http.post(this.configService.getApiUrl() + 'inbank/calculate', params));
        }
        catch (e) {
            this.alertService.error(e.error ? e.error.error : e.message);
            return e;
        }
    }
    async getCreditPdf(id) {
        try {
            return await lastValueFrom(this.http.get(this.configService.getApiUrl() + `inbank/applications/printout/pdf/${id}/offer`, {
                responseType: 'text',
            }));
        }
        catch (e) {
            console.error(e);
            this.alertService.error(e.error.error ? e.error.error : e.error.message);
            return e;
        }
    }
    async acceptOffer(billingAddress) {
        const payload = {
            paymentMethod: { method: 'inbank' },
            billing_address: billingAddress,
            country: billingAddress['country_id'].toLowerCase(),
        };
        if (!this.customerService.isLoggedIn()) {
            payload.email = billingAddress['email'];
            payload.cartId = this.cartService.customerCartId;
        }
        try {
            const apiUrl = this.configService.getApiUrl();
            const offerUuid = this.offer.uuid;
            const guestCartId = this.cartService.getGuestCartId();
            if (this.customerService.isLoggedIn()) {
                return await lastValueFrom(this.http.get(`${apiUrl}inbank/application/accept/${offerUuid}`));
            }
            else {
                return await lastValueFrom(this.http.post(`${apiUrl}inbank/guest/${guestCartId}/application/accept/${offerUuid}`, payload));
            }
        }
        catch (error) {
            console.error(error);
            const errorMessage = error.error?.error || error.error?.message;
            this.alertService.error(errorMessage);
            return error;
        }
    }
    async cancelApplication(applicationId) {
        try {
            return await lastValueFrom(this.http.get(this.configService.getApiUrl() + `inbank/application/cancel/${applicationId}`));
        }
        catch (e) {
            console.error(e);
            this.alertService.error(e.error.error ? e.error.error : e.error.message);
            return e;
        }
    }
    async downPaymentLinkRetrieval(contract_uuid) {
        try {
            return await lastValueFrom(this.http.get(`${this.configService.getApiUrl()}inbank/contracts/payment/link/${contract_uuid}`));
        }
        catch (e) {
            console.error(e);
            this.alertService.error(e.error.error ? e.error.error : e.error.message);
            return e;
        }
    }
    async cancelOrder(orderId) {
        try {
            return await lastValueFrom(this.http.get(this.configService.getApiUrl() + `inbank/contract/cancel/${orderId}`));
        }
        catch (e) {
            console.error(e);
            this.alertService.error(e.error.error ? e.error.error : e.error.message);
            return e;
        }
    }
    async getContractPdf(id) {
        try {
            return await lastValueFrom(this.http.get(this.configService.getApiUrl() + 'inbank/contracts/printout/pdf/' + id));
        }
        catch (e) {
            console.error(e);
            this.alertService.error(e.error.error ? e.error.error : e.error.message);
            return e;
        }
    }
    async getCreditData(id) {
        try {
            return await lastValueFrom(this.http.get(this.configService.getApiUrl() + 'inbank/application/info/' + id));
        }
        catch (e) {
            console.error(e);
            this.alertService.error(e.error.error ? e.error.error : e.error.message);
            return e;
        }
    }
    async getDokobitUrl(contract_id) {
        try {
            return await lastValueFrom(this.http.get(this.configService.getApiUrl() + `inbank/contracts/signings/${contract_id}`));
        }
        catch (e) {
            console.error(e);
            this.alertService.error(e.error.error ? e.error.error : e.error.message);
            return e;
        }
    }
    async getOrderPaymentInformation(orderId) {
        try {
            let url = '';
            if (this.customerService.isLoggedIn()) {
                url = this.configService.getApiUrl() + 'inbank/order/info/' + orderId;
            }
            else {
                url =
                    this.configService.getApiUrl() +
                        `inbank/guest/${this.cartService.getGuestCartId()}/order/info`;
            }
            return await lastValueFrom(this.http.get(url));
        }
        catch (e) {
            console.error(e);
            this.alertService.error(e.error.error ? e.error.error : e.error.message);
            return e;
        }
    }
    placeInbankOrder(billingAddress, contract_id, status) {
        let url = '';
        if (this.customerService.isLoggedIn()) {
            url = `${this.configService.getApiUrl()}carts/mine/payment-information`;
        }
        else {
            url = `${this.configService.getApiUrl()}guest-carts/${this.cartService.getGuestCartId()}/payment-information`;
        }
        const payload = this.convertFormToPayload(billingAddress, contract_id, status);
        return this.http.post(url, payload);
    }
    dokobitAuth() {
        const form = this.inbankForm.value.value;
        return this.http
            .post(`${this.configService.getApiUrl()}dokobit/authentication/create`, {
            code: form.financialData.identity_code,
            phone: form.contactData.telephone,
            country_code: 'ee',
            origin_host: `${window.location.origin}`,
        })
            .pipe(map((resp) => resp[0]));
    }
    async createApplication(inbankData) {
        const params = { data: this.convertFormToApplicationPayload(inbankData) };
        try {
            return await lastValueFrom(this.http.post(this.configService.getApiUrl() + 'inbank/application/create', params));
        }
        catch (e) {
            console.error(e);
            this.alertService.error(e.error.error ? e.error.error : e.error.message);
        }
        return false;
    }
    convertFormToApplicationPayload(data) {
        const form = data.form;
        const financialData = form.financialData;
        const contactData = form.contactData;
        const cartData = data.cart;
        // const street = contactData.street.match(/[0-9]+[a-zA-Z]?/g);
        const emta_agree_text = `Kiirendamaks taotluse protsessi, luban Inbankil teha minu nimel Maksu- ja Tolliametile päring minu sissetuleku ja töökoha andmete kohta.`;
        const consents = [
            {
                type: 'EMTA_REGISTRY_QUERY',
                text: emta_agree_text,
                value: true,
            },
        ];
        const requestData = {
            credit_application: {
                down_payment_amount: form.down_payment ? form.down_payment : undefined,
                amount: data.amount,
                period: data.period,
                monthly_income: financialData?.monthly_income?.toString(),
                monthly_financial_obligations: financialData?.monthly_financial_obligations?.toString(),
            },
            customer: {
                identity_code: financialData.identity_code,
                first_name: financialData.firstname,
                last_name: financialData.lastname,
            },
            customer_addresses: {
                type: 'legal',
                country: contactData.country,
                street: contactData.street,
                zip_code: contactData.postcode,
                house: contactData.house ? contactData.house : undefined,
                apartment: contactData.apartment ? contactData.apartment : undefined,
            },
            customer_contact: {
                phone: contactData.telephone,
                email: contactData.email,
            },
            customer_identification: {
                document_type: 'id_card',
                document_number: financialData.document_number,
            },
            purchase: {
                purchase_reference: `${this.cartService.customerCartId || this.cartService.getGuestCartId()}`,
                description: `${cartData.items.map((item) => item.name)}`,
                items: cartData.items.map((item) => {
                    return {
                        type: 'product',
                        description: item.name,
                        quantity: item.qty,
                        amount: item.row_total_incl_tax,
                        item_reference: item.extension_attributes.product.sku,
                        url: item.url_key,
                    };
                }),
            },
        };
        // if (form.emta_agree) {
        //   requestData['consents'] = consents;
        // }
        return requestData;
    }
    convertFormToPayload(billingAddress, contract_id, status) {
        const emta_agree = `Kiirendamaks taotluse protsessi, luban Inbankil teha minu nimel Maksu- ja Tolliametile päring minu sissetuleku ja töökoha andmete kohta.`;
        const requestData = {
            paymentMethod: {
                method: 'inbank',
                additional_data: {
                    emta_agree,
                    contract_id: contract_id,
                    status: status ? status : undefined,
                },
            },
            billing_address: billingAddress,
            email: billingAddress.email,
        };
        return requestData;
    }
    safePdf(fileName) {
        if (window.navigator.msSaveOrOpenBlob) {
            // IE specific download.
            navigator.msSaveBlob(this.inbankOfferPdf, fileName);
        }
        else {
            const downloadLink = document.createElement('a');
            downloadLink.style.display = 'none';
            document.body.appendChild(downloadLink);
            downloadLink.setAttribute('href', this.inbankOfferPdf);
            downloadLink.setAttribute('target', '_blank');
            downloadLink.setAttribute('download', fileName);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }
    printPdf() {
        window.open(this.inbankOfferPdf).print();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: InbankService, deps: [{ token: i1$1.HttpClient }, { token: ConfigService }, { token: i3.ToastrService }, { token: CustomerService }, { token: CartService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: InbankService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: InbankService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: i1$1.HttpClient }, { type: ConfigService }, { type: i3.ToastrService }, { type: CustomerService }, { type: CartService }] });

class CountryService {
    constructor() {
        this.configService = inject(ConfigService);
        this.http = inject(HttpClient);
        this.countries$ = new BehaviorSubject([]);
    }
    getDefaultCountry() {
        return this.configService.getConfig('general/store_information/country_id');
    }
    getCountryById(id) {
        return this.countries$.getValue().find((country) => country.id === id);
    }
    getCountries() {
        if (this.countries$.getValue() && this.countries$.getValue().length) {
            return this.countries$;
        }
        return this.http
            .get(`${this.configService.getApiUrl()}directory/countries`)
            .pipe(tap$1((countries) => this.countries$.next(countries)));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CountryService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CountryService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CountryService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class BestSellingService {
    constructor(configService, http) {
        this.configService = configService;
        this.http = http;
    }
    getBestSellingProducts() {
        return this.http.get(`${this.configService.expressApiUrl}bestsellers`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: BestSellingService, deps: [{ token: ConfigService }, { token: i1$1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: BestSellingService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: BestSellingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: ConfigService }, { type: i1$1.HttpClient }] });

const WISH_LIST_CODE = 'saved_wish_list_items';
class WishListApiService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(ConfigService);
        this.translationService = inject(TranslationService);
        this.alertService = inject(ToastrService);
        this.routerService = inject(RouterService);
    }
    getWishList() {
        const url = `${this.configService.getApiUrl()}wishlist`;
        return this.http.get(url);
    }
    addToWishList(productId) {
        const url = `${this.configService.getApiUrl()}wishlist/${productId}`;
        return this.http.post(url, {});
    }
    deleteFromWishList(productId) {
        const url = `${this.configService.getApiUrl()}wishlist/${productId}`;
        return this.http.delete(url);
    }
    saveItemToWishList(productId) {
        const existingIds = this.getExistingStoredIds();
        // Add the new product ID to the array
        existingIds.push(productId);
        // Store the updated array back to local storage
        localStorage.setItem(WISH_LIST_CODE, JSON.stringify(existingIds));
    }
    notifyUserToLogIn() {
        const messageText = 'You must log in or register to add items to your wishlist.';
        const translated = this.translationService.translate(messageText);
        const message = translated ? translated : messageText;
        this.alertService.warning(message, '', {
            closeButton: true,
            disableTimeOut: true,
            positionClass: 'toast-top-right',
        });
        this.routerService.navigate('auth/login');
    }
    removeExistingStoredIds() {
        localStorage.removeItem(WISH_LIST_CODE);
    }
    getExistingStoredIds() {
        const storedValue = localStorage.getItem(WISH_LIST_CODE);
        const existingIds = storedValue ? JSON.parse(storedValue) : [];
        return existingIds;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: WishListApiService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: WishListApiService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: WishListApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class WishListConfigService {
    constructor() {
        this.configService = inject(ConfigService);
    }
    isShowWishList() {
        return this.configService.getConfig('wishlist/general/show_in_sidebar');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: WishListConfigService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: WishListConfigService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: WishListConfigService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

const DEFAULT_CURRENCY = 'EUR';
const CURRENCIES = 'currencies';
const CURRENT_CURRENCY = 'current_currency';
class CurrencyService {
    constructor() {
        this.configService = inject(ConfigService);
        this.http = inject(HttpClient);
        this.productionService = inject(ProductionService);
        this.currenciesData$ = new BehaviorSubject(null);
        this.currentCurrency$ = new BehaviorSubject('');
        this.exchangeRates$ = new BehaviorSubject(null);
    }
    getCurrencies() {
        const currencies = this.productionService.getDataFromTransferState(CURRENCIES);
        if (currencies) {
            this.currenciesData$.next(currencies);
            this.exchangeRates$.next(currencies.exchange_rates);
            return of(currencies);
        }
        if (this.currenciesData$.value !== null) {
            return this.currenciesData$.asObservable();
        }
        return this.http
            .get(`${this.configService.getApiUrl()}directory/currency`)
            .pipe(tap$1((data) => {
            if (this.productionService.isServerMode()) {
                this.productionService.setDataToTransferState(CURRENCIES, data);
            }
            this.currenciesData$.next(data);
            this.exchangeRates$.next(data.exchange_rates);
        }), catchError$1(() => EMPTY));
    }
    setCurrency(currency) {
        return this.http
            .post(`${this.configService.get('m2url')}rest/V1/currency/${currency.toUpperCase()}`, {})
            .pipe(take$1(1), tap$1((data) => {
            this.setCurrentCurrency(data.current_currency_code);
        }), catchError$1(() => of(DEFAULT_CURRENCY)));
    }
    getCurrentCurrency() {
        const currentCurrencyTS = this.productionService.getDataFromTransferState(CURRENT_CURRENCY);
        if (currentCurrencyTS) {
            return of(currentCurrencyTS);
        }
        if (this.currentCurrency$.value.length > 0) {
            return this.currentCurrency$.asObservable();
        }
        if (this.productionService.isBrowserMode()) {
            const currentCurrency = localStorage.getItem('current_currency_code');
            if (currentCurrency && currentCurrency?.length > 0) {
                this.currentCurrency$.next(currentCurrency);
                return this.currentCurrency$.asObservable();
            }
        }
        return this.http
            .get(`${this.configService.getApiUrl()}currency/current`, {})
            .pipe(take$1(1), tap$1((data) => {
            this.setCurrentCurrency(data.current_currency_code);
        }), map((data) => data.current_currency_code), catchError$1(() => of(DEFAULT_CURRENCY)));
    }
    setCurrentCurrency(currency) {
        this.currentCurrency$.next(currency);
        if (this.productionService.isServerMode()) {
            this.productionService.setDataToTransferState(CURRENT_CURRENCY, currency);
        }
        else {
            localStorage.setItem('current_currency_code', currency);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CurrencyService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CurrencyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CurrencyService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class ContactFormService {
    constructor() {
        this.http = inject(HttpClient);
        this.configService = inject(ConfigService);
    }
    sendContactForm(data) {
        const url = `${this.configService.getApiUrl()}contact`;
        return this.http.post(url, { data });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ContactFormService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ContactFormService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ContactFormService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class ProductStockService {
    constructor() {
        this.configService = inject(ConfigService);
        this.loadConfigValues();
    }
    /**
     * Checks if a product is out of stock based on certain conditions.
     * @param product - The product object to check if it is out of stock.
     * @returns True if the product is out of stock, false otherwise.
     */
    isProductOutOfStock(product) {
        const isDisplayOutOfStockValue = this.displayOutOfStockVale === '1';
        const noBackorders = this.backOrdersValue === false;
        const allowBackOrderQtyBelowZero = this.backOrdersValue === '1';
        const isProductOutOfStockStatus = product.stock?.is_in_stock === false;
        if (isProductOutOfStockStatus) {
            return true;
        }
        return (isDisplayOutOfStockValue &&
            isProductOutOfStockStatus &&
            (noBackorders || !allowBackOrderQtyBelowZero));
    }
    getConfigValue(configPath) {
        return this.configService.getConfig(configPath);
    }
    loadConfigValues() {
        this.displayOutOfStockVale = this.getConfigValue('cataloginventory/options/show_out_of_stock');
        this.backOrdersValue = this.getConfigValue('cataloginventory/item_options/backorders');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ProductStockService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ProductStockService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: ProductStockService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

class CookieConsentService {
    constructor() {
        this.configService = inject(ConfigService);
        this.productionService = inject(ProductionService);
    }
    init() {
        if (this.productionService.isServerMode())
            return;
        const customEvent = new CustomEvent('CookiesConsent', {});
        const scripts = this.configService.getConfig('speedy/cookie/gdpr2');
        if (!scripts)
            return;
        const callback = () => {
            this.appendCookieScript(scripts, customEvent);
        };
        this.appendCookieConsentJs(scripts, callback.bind(this));
    }
    appendCookieConsentJs(scripts, callback) {
        const regex = /<script[^>]*\ssrc\s*=\s*(['"])(.*?)\1[^>]*>/;
        const match = scripts.match(regex);
        const srcAttribute = match ? match[2] : null;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.setAttribute('defer', '');
        script.setAttribute('src', srcAttribute);
        script.onload = callback;
        document.body.appendChild(script);
    }
    appendCookieScript(scripts, customEvent) {
        const scriptRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/gm;
        const scriptContents = [];
        let matches;
        while ((matches = scriptRegex.exec(scripts)) !== null) {
            scriptContents.push(matches[1]);
        }
        if (scriptContents.length) {
            scriptContents
                .filter((c) => c && c.length)
                .forEach((content) => {
                content = content.replace('DOMContentLoaded', 'CookiesConsent');
                eval(content);
            });
        }
        document.dispatchEvent(customEvent);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CookieConsentService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CookieConsentService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CookieConsentService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

class TranslatePipe {
    constructor() {
        this.translationService = inject(TranslationService);
        this.storeService = inject(StoreService);
    }
    transform(value) {
        return this.storeService.store$.pipe(startWith({}), switchMap(() => {
            const translated = this.translationService.translate(value);
            return translated ? of(translated) : of(value);
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TranslatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: TranslatePipe, isStandalone: true, name: "translate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TranslatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'translate',
                    standalone: true,
                }]
        }] });

class NoCommaPipe {
    transform(val) {
        if (val !== undefined && val !== null) {
            const parsedValue = parseFloat(val.toString());
            if (Number.isInteger(parsedValue)) {
                return parsedValue.toFixed(0);
            }
            return parsedValue.toFixed(2).replace(',', '');
        }
        return '';
    }
    isInteger(x) {
        return Math.round(x) === x;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NoCommaPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: NoCommaPipe, isStandalone: true, name: "noComma" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NoCommaPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'noComma',
                    standalone: true,
                }]
        }] });

const pipes$2 = [NoCommaPipe];
class NoCommaPipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NoCommaPipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: NoCommaPipeModule, imports: [CommonModule, NoCommaPipe], exports: [NoCommaPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NoCommaPipeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NoCommaPipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ...pipes$2],
                    exports: [...pipes$2],
                }]
        }] });

class PricePipe {
    transform(value) {
        if (value == null) {
            return Number(0).toFixed(2);
        }
        return Number(value).toFixed(2);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: PricePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: PricePipe, isStandalone: true, name: "price" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: PricePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'price',
                    standalone: true,
                }]
        }] });

const pipes$1 = [PricePipe];
class PricePipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: PricePipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: PricePipeModule, imports: [CommonModule, PricePipe], exports: [PricePipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: PricePipeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: PricePipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ...pipes$1],
                    exports: [...pipes$1],
                }]
        }] });

class JsonParsePipe {
    transform(value) {
        return typeof value === 'string' ? JSON.parse(value) : value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: JsonParsePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: JsonParsePipe, isStandalone: true, name: "jsonParse" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: JsonParsePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'jsonParse',
                    standalone: true,
                }]
        }] });

const pipes = [JsonParsePipe];
class JsonParsePipeModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: JsonParsePipeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: JsonParsePipeModule, imports: [CommonModule, JsonParsePipe], exports: [JsonParsePipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: JsonParsePipeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: JsonParsePipeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, ...pipes],
                    exports: [...pipes],
                }]
        }] });

class DebounceClickDirective {
    constructor() {
        this.debounceTime = 500;
        this.debounceClick = new EventEmitter();
        this.clicks = new Subject();
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.clicks
            .pipe(debounceTime(this.debounceTime), takeUntil(this.destroy$))
            .subscribe((e) => this.debounceClick.emit(e));
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    clickEvent(event) {
        event.preventDefault();
        event.stopPropagation();
        this.clicks.next(event);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DebounceClickDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: DebounceClickDirective, isStandalone: true, selector: "[appDebounceClick]", inputs: { debounceTime: "debounceTime" }, outputs: { debounceClick: "debounceClick" }, host: { listeners: { "click": "clickEvent($event)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: DebounceClickDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appDebounceClick]',
                    standalone: true,
                }]
        }], propDecorators: { debounceTime: [{
                type: Input
            }], debounceClick: [{
                type: Output
            }], clickEvent: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class MouseoverDirective {
    set cssClass(value) {
        this._cssClasses = value.split(/\s+/);
    }
    constructor(elRef, renderer, productionService) {
        this.renderer = renderer;
        this.productionService = productionService;
        this.cssClassCleanup = false;
        this._cssClasses = [];
        this.mouseoverDelay = 0;
        this.mouseoverDelayed = new EventEmitter();
        this.html = !this.productionService.isServerMode()
            ? document.getElementsByTagName('html')[0]
            : null;
        this.destroy$ = new Subject();
        this.el = elRef.nativeElement;
    }
    ngAfterViewInit() {
        const mouseover$ = fromEvent(this.el, 'mouseover'), mouseout$ = fromEvent(this.el, 'mouseleave');
        mouseout$
            .pipe(filter(() => this.cssClassCleanup), share(), takeUntil(this.destroy$))
            .subscribe(() => {
            if (this.html) {
                this.renderer.removeClass(this.html, 'sub-nav-open');
                this.el.classList.remove(...this._cssClasses);
            }
        });
        mouseover$
            .pipe(filter(() => this.mouseoverDelay > 0), mergeMap((e) => of(e).pipe(delay(this.mouseoverDelay), takeUntil(mouseout$))), takeUntil(this.destroy$))
            .subscribe((event) => {
            if (this.html) {
                this.mouseoverDelayed.emit(event);
                this.renderer.addClass(this.html, 'sub-nav-open');
                this.el.classList.add(...this._cssClasses);
            }
        });
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: MouseoverDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: ProductionService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: MouseoverDirective, isStandalone: true, selector: "[appMouseover]", inputs: { cssClassCleanup: "cssClassCleanup", cssClass: "cssClass", mouseoverDelay: "mouseoverDelay" }, outputs: { mouseoverDelayed: "mouseoverDelayed" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: MouseoverDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appMouseover]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: ProductionService }], propDecorators: { cssClassCleanup: [{
                type: Input
            }], cssClass: [{
                type: Input
            }], mouseoverDelay: [{
                type: Input
            }], mouseoverDelayed: [{
                type: Output
            }] } });

class SRouterLinkActiveDirective extends RouterLinkActive {
    constructor(_route, _locationStrategy, _router, _element, _renderer, _cdr, storeService) {
        super(_router, _element, _renderer, _cdr);
        this._route = _route;
        this._locationStrategy = _locationStrategy;
        this._router = _router;
        this._element = _element;
        this._renderer = _renderer;
        this._cdr = _cdr;
        this.storeService = storeService;
        this.destroyRef = inject(DestroyRef);
        this._init();
    }
    _init() {
        this.storeService.getCurrentStore();
        this.storeService.store$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((store) => {
            this.store = store;
        });
    }
    set sRouterLinkActive(className) {
        this.storedClassName = className;
    }
    set sRouterLinkActiveOptions(options) {
        this.options = options;
    }
    setClass(className, navigationUrl) {
        this._renderer.removeClass(this._element.nativeElement, className);
        const href = decodeURIComponent(this._element.nativeElement.getAttribute('href'));
        const href_without_lang = href.slice(3);
        const url = navigationUrl
            ? navigationUrl
            : this._route.snapshot['_routerState'].url;
        if (this.options?.exact) {
            if (url === href) {
                this._renderer.addClass(this._element.nativeElement, className);
            }
        }
        else {
            if (url.includes(href_without_lang)) {
                this._renderer.addClass(this._element.nativeElement, className);
            }
        }
    }
    ngAfterViewInit() {
        this.setClass(this.storedClassName);
        this._router.events
            .pipe(filter((event) => event instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef))
            .subscribe((changes) => {
            this.setClass(this.storedClassName, changes.url);
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SRouterLinkActiveDirective, deps: [{ token: i1$2.ActivatedRoute }, { token: i2.LocationStrategy }, { token: i1$2.Router }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: StoreService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: SRouterLinkActiveDirective, isStandalone: true, selector: "a[sRouterLinkActive]", inputs: { sRouterLinkActive: "sRouterLinkActive", sRouterLinkActiveOptions: "sRouterLinkActiveOptions" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SRouterLinkActiveDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'a[sRouterLinkActive]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1$2.ActivatedRoute }, { type: i2.LocationStrategy }, { type: i1$2.Router }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: StoreService }], propDecorators: { sRouterLinkActive: [{
                type: Input
            }], sRouterLinkActiveOptions: [{
                type: Input
            }] } });

class SRouterLinkWithHrefDirective extends RouterLink {
    constructor(router, route, locationStrategy, render2, elementRef, storeService) {
        super(router, route, null, render2, elementRef, locationStrategy);
        this.render2 = render2;
        this.elementRef = elementRef;
        this.storeService = storeService;
        this.init();
    }
    init() {
        this.store = this.storeService.getCurrentStore();
        this.storeService.store$.subscribe((store) => {
            this.store = store;
            this.mutateUrl(this.storedUrl);
        });
    }
    /**
     * Setter method for the sRouterLink input property.
     * Sets the storedUrl property to the provided URL and calls the mutateUrl() method with the URL.
     * @param url - The URL to be mutated.
     */
    set sRouterLink(url) {
        this.storedUrl = url;
        this.mutateUrl(url);
    }
    /**
     * Modifies the URL based on the provided input. It adds a prefix storeCode to the URL and ensures that it is in the correct format.
     * @param url - The URL to be mutated.
     */
    mutateUrl(url) {
        if (!url)
            return;
        const prefix = [`/${this.store.code}`];
        let value = typeof url === 'string' ? `${url}` : [...url];
        if (value.length == 0) {
            value = prefix;
        }
        else if (typeof value === 'string') {
            if (value.charAt(0) == '/') {
                value = value.slice(1);
            }
            value = value.split('/');
            value = prefix.concat(value);
        }
        else {
            value.unshift('/' + this.store.code);
        }
        this.routerLink = value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SRouterLinkWithHrefDirective, deps: [{ token: i1$2.Router }, { token: i1$2.ActivatedRoute }, { token: i2.LocationStrategy }, { token: i0.Renderer2 }, { token: i0.ElementRef }, { token: StoreService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: SRouterLinkWithHrefDirective, isStandalone: true, selector: "a[sRouterLink]", inputs: { sRouterLink: "sRouterLink" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SRouterLinkWithHrefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'a[sRouterLink]',
                    standalone: true,
                }]
        }], ctorParameters: () => [{ type: i1$2.Router }, { type: i1$2.ActivatedRoute }, { type: i2.LocationStrategy }, { type: i0.Renderer2 }, { type: i0.ElementRef }, { type: StoreService }], propDecorators: { sRouterLink: [{
                type: Input
            }] } });

class TranslateDirective {
    constructor() {
        this.el = inject(ElementRef);
        this.translationService = inject(TranslationService);
        this.storeService = inject(StoreService);
        this.renderer = inject(Renderer2);
    }
    ngAfterViewInit() {
        this.storeService.store$.pipe(startWith({})).subscribe(() => {
            this.translate();
        });
    }
    translate() {
        const originalValue = this.getOriginalValue();
        const value = originalValue ? originalValue : this.el.nativeElement.innerText.trim();
        const translated = this.translationService.translate(value);
        if (translated && translated !== value) {
            this.setOriginalValue(value);
            this.setElementText(translated);
        }
        else if (originalValue) {
            this.setElementText(originalValue);
        }
    }
    getOriginalValue() {
        return this.el.nativeElement.getAttribute('data-text');
    }
    setOriginalValue(value) {
        this.renderer.setAttribute(this.el.nativeElement, 'data-text', value);
    }
    setElementText(text) {
        this.renderer.setProperty(this.el.nativeElement, 'innerHTML', text);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TranslateDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: TranslateDirective, isStandalone: true, selector: "[translate]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: TranslateDirective, decorators: [{
            type: Directive,
            args: [{
                    standalone: true,
                    selector: '[translate]',
                }]
        }] });

class SwiperDirective {
    constructor() {
        this.elRef = inject(ElementRef);
        this.productionService = inject(ProductionService);
    }
    ngAfterViewInit() {
        if (this.productionService.isServerMode())
            return;
        Object.assign(this.elRef.nativeElement, this.config);
        this.elRef.nativeElement.initialize();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SwiperDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.1.3", type: SwiperDirective, isStandalone: true, selector: "[appSwiper]", inputs: { config: "config" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SwiperDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[appSwiper]',
                    standalone: true,
                }]
        }], propDecorators: { config: [{
                type: Input
            }] } });

class AccessGuard {
    constructor(customerService, router, toastr) {
        this.customerService = customerService;
        this.router = router;
        this.toastr = toastr;
    }
    canActivate(route, state) {
        if (this.customerService.isLoggedIn()) {
            return true;
        }
        this.toastr.error(`You're not permitted to this URL`, 'Uuuuupppssss!');
        this.router.navigate(['auth', 'register']);
        return false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: AccessGuard, deps: [{ token: CustomerService }, { token: i1$2.Router }, { token: i3.ToastrService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: AccessGuard, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: AccessGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: CustomerService }, { type: i1$2.Router }, { type: i3.ToastrService }] });

const authInterceptor = (req, next) => {
    const authService = inject(AuthService);
    const router = inject(RouterService);
    const token = authService.getToken();
    if (token && token !== 'false') {
        req = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });
    }
    return next(req).pipe(catchError$1((error) => {
        const browseHistory = [...router.browseHistory];
        const lastRoute = browseHistory[browseHistory.length - 1];
        console.error(error);
        if (!lastRoute?.includes('auth/login') &&
            error.status === HttpStatusCode.Unauthorized) {
            // Redirect to logout page
            router.navigate('auth/logout');
        }
        console.log(error);
        return throwError(() => error);
    }));
};

const storeInterceptor = (req, next) => {
    const storeService = inject(StoreService);
    const config = inject(ConfigService);
    const storeCode = storeService.getCurrentStoreCode();
    const isApiRequest = (req, config) => {
        return (req.url.includes(config.expressApiUrl) ||
            req.url.includes(config.get('expressApiUrlServer')));
    };
    if (storeCode && isApiRequest(req, config)) {
        req = req.clone({
            setParams: {
                store_code: storeCode,
            },
        });
        return next(req);
    }
    return next(req);
};

const credentialsInterceptor = (req, next) => {
    const config = inject(ConfigService);
    const isMagentoRequest = (request, config) => {
        return request.url.includes(config.get('m2url'));
    };
    if (isMagentoRequest(req, config)) {
        req = req.clone({
            withCredentials: true,
        });
        return next(req);
    }
    return next(req);
};

var CategoryDisplayMode;
(function (CategoryDisplayMode) {
    CategoryDisplayMode["PRODUCTS"] = "PRODUCTS";
    CategoryDisplayMode["SUBCATEGORIES"] = "SUBCATEGORIES";
})(CategoryDisplayMode || (CategoryDisplayMode = {}));

class StoreResolver {
    constructor(storeService, router, serverResponseService, seoService, cartService) {
        this.storeService = storeService;
        this.router = router;
        this.serverResponseService = serverResponseService;
        this.seoService = seoService;
        this.cartService = cartService;
    }
    resolve(route) {
        const storeCode = route.params['store'];
        const store = this.getStoreByCode(storeCode);
        if (!store) {
            this.handleStoreNotFound();
            return of(null);
        }
        const storeId = store.store_id;
        this.cartService.changeQuoteStore(storeId);
        this.storeService.setCurrentStoreByCode(storeCode);
        this.seoService.setLangTag();
        return of(null);
    }
    handleStoreNotFound() {
        const stores = this.storeService.getStores();
        const key = Object.keys(stores)[0];
        const newStore = stores[key];
        if (newStore) {
            this.changeUrlStoreCode(newStore.code);
        }
        else {
            this.serverResponseService.setNotFound();
        }
    }
    changeUrlStoreCode(code) {
        const url = this.currentUrl;
        const urlParts = url.split('/');
        urlParts[1] = code;
        const newUrl = urlParts.join('/');
        this.router.navigate([newUrl]);
    }
    getStoreByCode(storeCode) {
        return this.storeService.getStoreByCode(storeCode);
    }
    get currentUrl() {
        return this.router.routerState.snapshot.url;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: StoreResolver, deps: [{ token: StoreService }, { token: i1$2.Router }, { token: ServerResponseService }, { token: SeoService }, { token: CartService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: StoreResolver, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: StoreResolver, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: () => [{ type: StoreService }, { type: i1$2.Router }, { type: ServerResponseService }, { type: SeoService }, { type: CartService }] });

function passwordConfirmationValidator(control, passwordControlName, confirmationControlName) {
    const password = control.parent?.get(passwordControlName);
    const confirmation = control.parent?.get(confirmationControlName);
    if (!password || !confirmation) {
        return null;
    }
    if (password.value !== confirmation.value) {
        return { passwordMismatch: true };
    }
    return null;
}

const dateValidator = (control) => {
    const start = control.get('from');
    const end = control.get('to');
    if (start?.value !== null &&
        end?.value !== null &&
        new Date(start?.value) < new Date(end?.value)) {
        control.get('from')?.setErrors(null);
        control.get('to')?.setErrors(null);
        control.get('from')?.setValidators(Validators.required);
        control.get('to')?.setValidators(Validators.required);
        return null;
    }
    else {
        if (start?.value && end?.value) {
            control.get('from')?.setErrors({ test: true });
            control.get('to')?.setErrors({ test: true });
            return { startDateBiggerThanEndDate: true };
        }
        else {
            return null;
        }
    }
};

/**
 * "Nil" means either `null` or `undefined`.
 */
function typedIsNotNil(value) {
    return value !== null && value !== undefined;
}

function filterNil() {
    return (source) => source.pipe(filter$1((value) => typedIsNotNil(value)));
}

const currencySigns = {
    USD: '&dollar;',
    EUR: '&euro;',
    GBP: '&pound;',
    JPY: '&yen;',
    AUD: '&#36;', // Australian Dollar
    CAD: '&#36;', // Canadian Dollar
    CHF: '&chf;', // Swiss Franc
    CNY: '&cny;', // Chinese Yuan
    HKD: '&#36;', // Hong Kong Dollar
    NZD: '&#36;', // New Zealand Dollar
    SGD: '&#36;', // Singapore Dollar
    SEK: '&#107;&#114;', // Swedish Krona
    NOK: '&#107;&#114;', // Norwegian Krone
    MXN: '&#36;', // Mexican Peso
    INR: '&#8377;', // Indian Rupee
    BRL: '&#82;&#36;', // Brazilian Real
    RUB: '&#1088;&#1091;&#1073;', // Russian Ruble
    ZAR: '&#82;', // South African Rand
};

class SVGMatIconModule {
    constructor(matIconRegistry, domSanitizer) {
        this.matIconRegistry = matIconRegistry;
        this.domSanitizer = domSanitizer;
        this.matIconRegistry.addSvgIcon('arrow-left', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/arrow-left.svg'));
        this.matIconRegistry.addSvgIcon('arrow-right', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/arrow-right.svg'));
        this.matIconRegistry.addSvgIcon('swiper-underline', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/swiper-underline.svg'));
        this.matIconRegistry.addSvgIcon('basket-plus-outline', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/basket-plus-outline.svg'));
        this.matIconRegistry.addSvgIcon('heart-outline', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/heart-outline.svg'));
        this.matIconRegistry.addSvgIcon('cart-outline', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/cart-outline.svg'));
        this.matIconRegistry.addSvgIcon('magnify', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/magnify.svg'));
        this.matIconRegistry.addSvgIcon('account-outline', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/account-outline.svg'));
        this.matIconRegistry.addSvgIcon('offer-outline', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/offer-outline.svg'));
        this.matIconRegistry.addSvgIcon('bottle-wine', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/bottle-wine.svg'));
        this.matIconRegistry.addSvgIcon('filters', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/tune-vertical-variant.svg'));
        this.matIconRegistry.addSvgIcon('facebook', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/icons/facebook.svg'));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SVGMatIconModule, deps: [{ token: i1$3.MatIconRegistry }, { token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: SVGMatIconModule, imports: [MatIconModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SVGMatIconModule, imports: [MatIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: SVGMatIconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [MatIconModule],
                }]
        }], ctorParameters: () => [{ type: i1$3.MatIconRegistry }, { type: i1.DomSanitizer }] });

class NgxGalleryService {
    constructor(renderer) {
        this.renderer = renderer;
        this.swipeHandlers = new Map();
    }
    manageSwipe(status, element, id, nextHandler, prevHandler) {
        const handlers = this.getSwipeHandlers(id);
        // swipeleft and swiperight are available only if hammerjs is included
        try {
            if (status && !handlers) {
                this.swipeHandlers.set(id, [
                    this.renderer.listen(element.nativeElement, 'swipeleft', () => nextHandler()),
                    this.renderer.listen(element.nativeElement, 'swiperight', () => prevHandler()),
                ]);
            }
            else if (!status && handlers) {
                handlers.map((handler) => handler());
                this.removeSwipeHandlers(id);
            }
        }
        catch (e) { }
    }
    validateUrl(url) {
        if (url.replace) {
            return url
                .replace(new RegExp(' ', 'g'), '%20')
                .replace(new RegExp("'", 'g'), '%27');
        }
        else {
            return url;
        }
    }
    getBackgroundUrl(image) {
        return "url('" + this.validateUrl(image) + "')";
    }
    getFileType(fileSource) {
        const fileExtension = fileSource.split('.').pop().toLowerCase();
        if (fileExtension === 'avi' ||
            fileExtension === 'flv' ||
            fileExtension === 'wmv' ||
            fileExtension === 'mov' ||
            fileExtension === 'mp4') {
            return 'video';
        }
        return 'image';
    }
    getSwipeHandlers(id) {
        return this.swipeHandlers.get(id);
    }
    removeSwipeHandlers(id) {
        this.swipeHandlers.delete(id);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryService, deps: [{ token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }] });

class NgxGalleryBulletsComponent {
    constructor() {
        this.active = 0;
        this.bulletChange = new EventEmitter();
    }
    getBullets() {
        return Array(this.count);
    }
    handleChange(event, index) {
        this.bulletChange.emit(index);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryBulletsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.1.3", type: NgxGalleryBulletsComponent, isStandalone: true, selector: "ngx-gallery-bullets", inputs: { count: "count", active: "active" }, outputs: { bulletChange: "bulletChange" }, ngImport: i0, template: "@for (bullet of getBullets(); track bullet; let i = $index) {\n  <div\n    class=\"ngx-gallery-bullet\"\n    (click)=\"handleChange($event, i)\"\n    [ngClass]=\"{ 'ngx-gallery-active': i === active }\"\n  ></div>\n}\n", styles: [":host{position:absolute;z-index:2000;display:inline-flex;left:50%;transform:translate(-50%);bottom:0;padding:10px}.ngx-gallery-bullet{width:10px;height:10px;border-radius:50%;cursor:pointer;background:#fff}.ngx-gallery-bullet:not(:first-child){margin-left:5px}.ngx-gallery-bullet:hover,.ngx-gallery-bullet.ngx-gallery-active{background:#000}\n"], dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryBulletsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-gallery-bullets', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [NgClass], template: "@for (bullet of getBullets(); track bullet; let i = $index) {\n  <div\n    class=\"ngx-gallery-bullet\"\n    (click)=\"handleChange($event, i)\"\n    [ngClass]=\"{ 'ngx-gallery-active': i === active }\"\n  ></div>\n}\n", styles: [":host{position:absolute;z-index:2000;display:inline-flex;left:50%;transform:translate(-50%);bottom:0;padding:10px}.ngx-gallery-bullet{width:10px;height:10px;border-radius:50%;cursor:pointer;background:#fff}.ngx-gallery-bullet:not(:first-child){margin-left:5px}.ngx-gallery-bullet:hover,.ngx-gallery-bullet.ngx-gallery-active{background:#000}\n"] }]
        }], ctorParameters: () => [], propDecorators: { count: [{
                type: Input
            }], active: [{
                type: Input
            }], bulletChange: [{
                type: Output
            }] } });

class NgxGalleryActionComponent {
    constructor() {
        this.disabled = false;
        this.titleText = '';
        this.closeClick = new EventEmitter();
    }
    handleClick(event) {
        if (!this.disabled) {
            this.closeClick.emit(event);
        }
        event.stopPropagation();
        event.preventDefault();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryActionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: NgxGalleryActionComponent, isStandalone: true, selector: "ngx-gallery-action", inputs: { icon: "icon", disabled: "disabled", titleText: "titleText" }, outputs: { closeClick: "closeClick" }, ngImport: i0, template: "<div\n  class=\"ngx-gallery-icon\"\n  [class.ngx-gallery-icon-disabled]=\"disabled\"\n  aria-hidden=\"true\"\n  title=\"{{ titleText }}\"\n  (click)=\"handleClick($event)\"\n>\n  <i class=\"ngx-gallery-icon-content {{ icon }}\"></i>\n</div>\n", styles: [".ngx-gallery-icon{color:#fff;font-size:25px;position:absolute;z-index:2000;display:inline-block}.ngx-gallery-icon{position:relative;margin-right:10px;margin-top:10px;font-size:25px;cursor:pointer;text-decoration:none}.ngx-gallery-icon .ngx-gallery-icon-content{display:block}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryActionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-gallery-action', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, template: "<div\n  class=\"ngx-gallery-icon\"\n  [class.ngx-gallery-icon-disabled]=\"disabled\"\n  aria-hidden=\"true\"\n  title=\"{{ titleText }}\"\n  (click)=\"handleClick($event)\"\n>\n  <i class=\"ngx-gallery-icon-content {{ icon }}\"></i>\n</div>\n", styles: [".ngx-gallery-icon{color:#fff;font-size:25px;position:absolute;z-index:2000;display:inline-block}.ngx-gallery-icon{position:relative;margin-right:10px;margin-top:10px;font-size:25px;cursor:pointer;text-decoration:none}.ngx-gallery-icon .ngx-gallery-icon-content{display:block}\n"] }]
        }], ctorParameters: () => [], propDecorators: { icon: [{
                type: Input
            }], disabled: [{
                type: Input
            }], titleText: [{
                type: Input
            }], closeClick: [{
                type: Output
            }] } });

class NgxGalleryArrowsComponent {
    constructor() {
        this.prevClick = new EventEmitter();
        this.nextClick = new EventEmitter();
    }
    handlePrevClick() {
        this.prevClick.emit();
    }
    handleNextClick() {
        this.nextClick.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryArrowsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.1.3", type: NgxGalleryArrowsComponent, isStandalone: true, selector: "ngx-gallery-arrows", inputs: { prevDisabled: "prevDisabled", nextDisabled: "nextDisabled", arrowPrevIcon: "arrowPrevIcon", arrowNextIcon: "arrowNextIcon" }, outputs: { prevClick: "prevClick", nextClick: "nextClick" }, ngImport: i0, template: "<div class=\"ngx-gallery-arrows-wrapper ngx-gallery-arrow-left\">\n  <div\n    class=\"ngx-gallery-icon ngx-gallery-arrow\"\n    aria-hidden=\"true\"\n    (click)=\"handlePrevClick()\"\n    [class.ngx-gallery-disabled]=\"prevDisabled\"\n  >\n    <i class=\"ngx-gallery-icon-content {{ arrowPrevIcon }}\"></i>\n  </div>\n</div>\n<div class=\"ngx-gallery-arrows-wrapper ngx-gallery-arrow-right\">\n  <div\n    class=\"ngx-gallery-icon ngx-gallery-arrow\"\n    aria-hidden=\"true\"\n    (click)=\"handleNextClick()\"\n    [class.ngx-gallery-disabled]=\"nextDisabled\"\n  >\n    <i class=\"ngx-gallery-icon-content {{ arrowNextIcon }}\"></i>\n  </div>\n</div>\n", styles: [".ngx-gallery-arrow-wrapper{position:absolute;height:100%;width:1px;display:table;table-layout:fixed}.ngx-gallery-preview-img-wrapper .ngx-gallery-arrow-wrapper{z-index:10001}.ngx-gallery-arrow-left{left:0}.ngx-gallery-arrow-right{right:0}.ngx-gallery-arrow{top:50%;transform:translateY(-50%);cursor:pointer}.ngx-gallery-arrow.ngx-gallery-disabled{opacity:.6;cursor:default}.ngx-gallery-arrow-left .ngx-gallery-arrow{left:10px}.ngx-gallery-arrow-right .ngx-gallery-arrow{right:10px}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryArrowsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-gallery-arrows', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, template: "<div class=\"ngx-gallery-arrows-wrapper ngx-gallery-arrow-left\">\n  <div\n    class=\"ngx-gallery-icon ngx-gallery-arrow\"\n    aria-hidden=\"true\"\n    (click)=\"handlePrevClick()\"\n    [class.ngx-gallery-disabled]=\"prevDisabled\"\n  >\n    <i class=\"ngx-gallery-icon-content {{ arrowPrevIcon }}\"></i>\n  </div>\n</div>\n<div class=\"ngx-gallery-arrows-wrapper ngx-gallery-arrow-right\">\n  <div\n    class=\"ngx-gallery-icon ngx-gallery-arrow\"\n    aria-hidden=\"true\"\n    (click)=\"handleNextClick()\"\n    [class.ngx-gallery-disabled]=\"nextDisabled\"\n  >\n    <i class=\"ngx-gallery-icon-content {{ arrowNextIcon }}\"></i>\n  </div>\n</div>\n", styles: [".ngx-gallery-arrow-wrapper{position:absolute;height:100%;width:1px;display:table;table-layout:fixed}.ngx-gallery-preview-img-wrapper .ngx-gallery-arrow-wrapper{z-index:10001}.ngx-gallery-arrow-left{left:0}.ngx-gallery-arrow-right{right:0}.ngx-gallery-arrow{top:50%;transform:translateY(-50%);cursor:pointer}.ngx-gallery-arrow.ngx-gallery-disabled{opacity:.6;cursor:default}.ngx-gallery-arrow-left .ngx-gallery-arrow{left:10px}.ngx-gallery-arrow-right .ngx-gallery-arrow{right:10px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { prevDisabled: [{
                type: Input
            }], nextDisabled: [{
                type: Input
            }], arrowPrevIcon: [{
                type: Input
            }], arrowNextIcon: [{
                type: Input
            }], prevClick: [{
                type: Output
            }], nextClick: [{
                type: Output
            }] } });

class NgxGalleryPreviewComponent {
    constructor(sanitization, elementRef, helperService, renderer, changeDetectorRef) {
        this.sanitization = sanitization;
        this.elementRef = elementRef;
        this.helperService = helperService;
        this.renderer = renderer;
        this.changeDetectorRef = changeDetectorRef;
        this.showSpinner = false;
        this.positionLeft = 0;
        this.positionTop = 0;
        this.zoomValue = 1;
        this.loading = false;
        this.rotateValue = 0;
        this.index = 0;
        this.previewOpen = new EventEmitter();
        this.previewClose = new EventEmitter();
        this.activeChange = new EventEmitter();
        this.isOpen = false;
        this.initialX = 0;
        this.initialY = 0;
        this.initialLeft = 0;
        this.initialTop = 0;
        this.isMove = false;
    }
    ngOnInit() {
        if (this.arrows && this.arrowsAutoHide) {
            this.arrows = false;
        }
    }
    ngOnChanges(changes) {
        if (changes['swipe']) {
            this.helperService.manageSwipe(this.swipe, this.elementRef, 'preview', () => this.showNext(), () => this.showPrev());
        }
    }
    ngOnDestroy() {
        if (this.keyDownListener) {
            this.keyDownListener();
        }
    }
    onMouseEnter() {
        if (this.arrowsAutoHide && !this.arrows) {
            this.arrows = true;
        }
    }
    onMouseLeave() {
        if (this.arrowsAutoHide && this.arrows) {
            this.arrows = false;
        }
    }
    onKeyDown(e) {
        if (this.isOpen) {
            if (this.keyboardNavigation) {
                if (this.isKeyboardPrev(e)) {
                    this.showPrev();
                }
                else if (this.isKeyboardNext(e)) {
                    this.showNext();
                }
            }
            if (this.closeOnEsc && this.isKeyboardEsc(e)) {
                this.close();
            }
        }
    }
    open(index) {
        this.previewOpen.emit();
        this.index = index;
        this.isOpen = true;
        this.show(true);
        if (this.forceFullscreen) {
            this.manageFullscreen();
        }
        this.keyDownListener = this.renderer.listen('window', 'keydown', (e) => this.onKeyDown(e));
    }
    close() {
        this.isOpen = false;
        const video = this.previewImage.nativeElement;
        if (video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2) {
            video.pause();
        }
        this.closeFullscreen();
        this.previewClose.emit();
        this.stopAutoPlay();
        if (this.keyDownListener) {
            this.keyDownListener();
        }
    }
    imageMouseEnter() {
        if (this.autoPlay && this.autoPlayPauseOnHover) {
            this.stopAutoPlay();
        }
    }
    imageMouseLeave() {
        if (this.autoPlay && this.autoPlayPauseOnHover) {
            this.startAutoPlay();
        }
    }
    startAutoPlay() {
        if (this.autoPlay) {
            this.stopAutoPlay();
            this.timer = setTimeout(() => {
                if (!this.showNext()) {
                    this.index = -1;
                    this.showNext();
                }
            }, this.autoPlayInterval);
        }
    }
    stopAutoPlay() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
    showAtIndex(index) {
        this.index = index;
        this.show();
    }
    showNext() {
        if (this.canShowNext()) {
            this.index++;
            if (this.index === this.images.length) {
                this.index = 0;
            }
            this.show();
            return true;
        }
        else {
            return false;
        }
    }
    showPrev() {
        if (this.canShowPrev()) {
            this.index--;
            if (this.index < 0) {
                this.index = this.images.length - 1;
            }
            this.show();
        }
    }
    canShowNext() {
        if (this.loading) {
            return false;
        }
        else if (this.images) {
            return this.infinityMove || this.index < this.images.length - 1;
        }
        else {
            return false;
        }
    }
    canShowPrev() {
        if (this.loading) {
            return false;
        }
        else if (this.images) {
            return this.infinityMove || this.index > 0;
        }
        else {
            return false;
        }
    }
    manageFullscreen() {
        if (this.fullscreen || this.forceFullscreen) {
            const doc = document;
            if (!doc.fullscreenElement &&
                !doc.mozFullScreenElement &&
                !doc.webkitFullscreenElement &&
                !doc.msFullscreenElement) {
                this.openFullscreen();
            }
            else {
                this.closeFullscreen();
            }
        }
    }
    getSafeUrl(image) {
        return this.sanitization.bypassSecurityTrustUrl(image);
    }
    getFileType(fileSource) {
        return this.helperService.getFileType(fileSource);
    }
    zoomIn() {
        if (this.canZoomIn()) {
            this.zoomValue += this.zoomStep;
            if (this.zoomValue > this.zoomMax) {
                this.zoomValue = this.zoomMax;
            }
        }
    }
    zoomOut() {
        if (this.canZoomOut()) {
            this.zoomValue -= this.zoomStep;
            if (this.zoomValue < this.zoomMin) {
                this.zoomValue = this.zoomMin;
            }
            if (this.zoomValue <= 1) {
                this.resetPosition();
            }
        }
    }
    rotateLeft() {
        this.rotateValue -= 90;
    }
    rotateRight() {
        this.rotateValue += 90;
    }
    getTransform() {
        return this.sanitization.bypassSecurityTrustStyle('scale(' + this.zoomValue + ') rotate(' + this.rotateValue + 'deg)');
    }
    canZoomIn() {
        return this.zoomValue < this.zoomMax;
    }
    canZoomOut() {
        return this.zoomValue > this.zoomMin;
    }
    canDragOnZoom() {
        return this.zoom && this.zoomValue > 1;
    }
    mouseDownHandler(e) {
        if (this.canDragOnZoom()) {
            this.initialX = this.getClientX(e);
            this.initialY = this.getClientY(e);
            this.initialLeft = this.positionLeft;
            this.initialTop = this.positionTop;
            this.isMove = true;
            e.preventDefault();
        }
    }
    mouseUpHandler() {
        this.isMove = false;
    }
    mouseMoveHandler(e) {
        if (this.isMove) {
            this.positionLeft = this.initialLeft + (this.getClientX(e) - this.initialX);
            this.positionTop = this.initialTop + (this.getClientY(e) - this.initialY);
        }
    }
    getClientX(e) {
        return e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;
    }
    getClientY(e) {
        return e.touches && e.touches.length ? e.touches[0].clientY : e.clientY;
    }
    resetPosition() {
        if (this.zoom) {
            this.positionLeft = 0;
            this.positionTop = 0;
        }
    }
    isKeyboardNext(e) {
        return e.keyCode === 39;
    }
    isKeyboardPrev(e) {
        return e.keyCode === 37;
    }
    isKeyboardEsc(e) {
        return e.keyCode === 27;
    }
    openFullscreen() {
        const element = document.documentElement;
        if (element.requestFullscreen) {
            element.requestFullscreen();
        }
        else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        }
        else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        }
        else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        }
    }
    closeFullscreen() {
        if (this.isFullscreen()) {
            const doc = document;
            if (doc.exitFullscreen) {
                doc.exitFullscreen();
            }
            else if (doc.msExitFullscreen) {
                doc.msExitFullscreen();
            }
            else if (doc.mozCancelFullScreen) {
                doc.mozCancelFullScreen();
            }
            else if (doc.webkitExitFullscreen) {
                doc.webkitExitFullscreen();
            }
        }
    }
    isFullscreen() {
        const doc = document;
        return (doc.fullscreenElement ||
            doc.webkitFullscreenElement ||
            doc.mozFullScreenElement ||
            doc.msFullscreenElement);
    }
    show(first = false) {
        this.loading = true;
        this.stopAutoPlay();
        this.activeChange.emit(this.index);
        if (first || !this.animation) {
            this._show();
        }
        else {
            setTimeout(() => this._show(), 600);
        }
    }
    _show() {
        this.zoomValue = 1;
        this.rotateValue = 0;
        this.resetPosition();
        this.src = this.getSafeUrl(this.images[this.index]);
        this.type = this.getFileType(this.images[this.index]);
        this.srcIndex = this.index;
        this.description = this.descriptions[this.index];
        this.changeDetectorRef.markForCheck();
        setTimeout(() => {
            if (this.isLoaded(this.previewImage.nativeElement) || this.type === 'video') {
                this.loading = false;
                this.startAutoPlay();
                this.changeDetectorRef.markForCheck();
            }
            else if (this.type === 'video') {
            }
            else {
                setTimeout(() => {
                    if (this.loading) {
                        this.showSpinner = true;
                        this.changeDetectorRef.markForCheck();
                    }
                });
                this.previewImage.nativeElement.onload = () => {
                    this.loading = false;
                    this.showSpinner = false;
                    this.previewImage.nativeElement.onload = null;
                    this.startAutoPlay();
                    this.changeDetectorRef.markForCheck();
                };
            }
        }, 200);
    }
    isLoaded(img) {
        if (!img.complete) {
            return false;
        }
        return !(typeof img.naturalWidth !== 'undefined' && img.naturalWidth === 0);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryPreviewComponent, deps: [{ token: i1.DomSanitizer }, { token: i0.ElementRef }, { token: NgxGalleryService }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.1.3", type: NgxGalleryPreviewComponent, isStandalone: true, selector: "ngx-gallery-preview", inputs: { images: "images", descriptions: "descriptions", showDescription: "showDescription", arrows: "arrows", arrowsAutoHide: "arrowsAutoHide", swipe: "swipe", fullscreen: "fullscreen", forceFullscreen: "forceFullscreen", closeOnClick: "closeOnClick", closeOnEsc: "closeOnEsc", keyboardNavigation: "keyboardNavigation", arrowPrevIcon: "arrowPrevIcon", arrowNextIcon: "arrowNextIcon", closeIcon: "closeIcon", fullscreenIcon: "fullscreenIcon", spinnerIcon: "spinnerIcon", autoPlay: "autoPlay", autoPlayInterval: "autoPlayInterval", autoPlayPauseOnHover: "autoPlayPauseOnHover", infinityMove: "infinityMove", zoom: "zoom", zoomStep: "zoomStep", zoomMax: "zoomMax", zoomMin: "zoomMin", zoomInIcon: "zoomInIcon", zoomOutIcon: "zoomOutIcon", animation: "animation", actions: "actions", rotate: "rotate", rotateLeftIcon: "rotateLeftIcon", rotateRightIcon: "rotateRightIcon", download: "download", downloadIcon: "downloadIcon", bullets: "bullets" }, outputs: { previewOpen: "previewOpen", previewClose: "previewClose", activeChange: "activeChange" }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()" } }, viewQueries: [{ propertyName: "previewImage", first: true, predicate: ["previewImage"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "@if (arrows) {\n  <ngx-gallery-arrows\n    (prevClick)=\"showPrev()\"\n    (nextClick)=\"showNext()\"\n    [prevDisabled]=\"!canShowPrev()\"\n    [nextDisabled]=\"!canShowNext()\"\n    [arrowPrevIcon]=\"arrowPrevIcon\"\n    [arrowNextIcon]=\"arrowNextIcon\"\n  ></ngx-gallery-arrows>\n}\n<div class=\"ngx-gallery-preview-top\">\n  <div class=\"ngx-gallery-preview-icons\">\n    @for (action of actions; track action) {\n      <ngx-gallery-action\n        [icon]=\"action.icon\"\n        [disabled]=\"action.disabled\"\n        [titleText]=\"action.titleText\"\n        (closeClick)=\"action.onClick($event, index)\"\n      ></ngx-gallery-action>\n    }\n    @if (download && src) {\n      <a [href]=\"src\" class=\"ngx-gallery-icon\" aria-hidden=\"true\" download>\n        <i class=\"ngx-gallery-icon-content {{ downloadIcon }}\"></i>\n      </a>\n    }\n    @if (zoom) {\n      <ngx-gallery-action\n        [icon]=\"zoomOutIcon\"\n        [disabled]=\"!canZoomOut()\"\n        (closeClick)=\"zoomOut()\"\n      ></ngx-gallery-action>\n    }\n    @if (zoom) {\n      <ngx-gallery-action\n        [icon]=\"zoomInIcon\"\n        [disabled]=\"!canZoomIn()\"\n        (closeClick)=\"zoomIn()\"\n      ></ngx-gallery-action>\n    }\n    @if (rotate) {\n      <ngx-gallery-action\n        [icon]=\"rotateLeftIcon\"\n        (closeClick)=\"rotateLeft()\"\n      ></ngx-gallery-action>\n    }\n    @if (rotate) {\n      <ngx-gallery-action\n        [icon]=\"rotateRightIcon\"\n        (closeClick)=\"rotateRight()\"\n      ></ngx-gallery-action>\n    }\n    @if (fullscreen) {\n      <ngx-gallery-action\n        [icon]=\"'ngx-gallery-fullscreen ' + fullscreenIcon\"\n        (closeClick)=\"manageFullscreen()\"\n      ></ngx-gallery-action>\n    }\n    <ngx-gallery-action\n      [icon]=\"'ngx-gallery-close ' + closeIcon\"\n      (closeClick)=\"close()\"\n    ></ngx-gallery-action>\n  </div>\n</div>\n<div\n  class=\"ngx-spinner-wrapper ngx-gallery-center\"\n  [class.ngx-gallery-active]=\"showSpinner\"\n>\n  <i\n    class=\"ngx-gallery-icon ngx-gallery-spinner {{ spinnerIcon }}\"\n    aria-hidden=\"true\"\n  ></i>\n</div>\n<div\n  class=\"ngx-gallery-preview-wrapper\"\n  (click)=\"closeOnClick && close()\"\n  (mouseup)=\"mouseUpHandler()\"\n  (mousemove)=\"mouseMoveHandler($event)\"\n  (touchend)=\"mouseUpHandler()\"\n  (touchmove)=\"mouseMoveHandler($event)\"\n>\n  <div class=\"ngx-gallery-preview-img-wrapper\">\n    @if (src && type === 'image') {\n      <img\n        #previewImage\n        class=\"ngx-gallery-preview-img ngx-gallery-center\"\n        [src]=\"src\"\n        (click)=\"$event.stopPropagation()\"\n        (mouseenter)=\"imageMouseEnter()\"\n        (mouseleave)=\"imageMouseLeave()\"\n        (mousedown)=\"mouseDownHandler($event)\"\n        (touchstart)=\"mouseDownHandler($event)\"\n        [class.ngx-gallery-active]=\"!loading\"\n        [class.animation]=\"animation\"\n        [class.ngx-gallery-grab]=\"canDragOnZoom()\"\n        [style.transform]=\"getTransform()\"\n        [style.left]=\"positionLeft + 'px'\"\n        [style.top]=\"positionTop + 'px'\"\n      />\n    }\n    @if (src && type === 'video') {\n      <video\n        #previewImage\n        controls\n        style=\"width: 100%; height: 100%\"\n        class=\"ngx-gallery-preview-img ngx-gallery-center\"\n        (click)=\"$event.stopPropagation()\"\n        (mouseenter)=\"imageMouseEnter()\"\n        (mouseleave)=\"imageMouseLeave()\"\n        (mousedown)=\"mouseDownHandler($event)\"\n        (touchstart)=\"mouseDownHandler($event)\"\n        [class.ngx-gallery-active]=\"!loading\"\n        [class.animation]=\"animation\"\n        [class.ngx-gallery-grab]=\"canDragOnZoom()\"\n        [style.transform]=\"getTransform()\"\n        [style.left]=\"positionLeft + 'px'\"\n        [style.top]=\"positionTop + 'px'\"\n      >\n        <source [src]=\"src\" />\n        Your browser does not support the video tag.\n      </video>\n    }\n    @if (bullets) {\n      <ngx-gallery-bullets\n        [count]=\"images.length\"\n        [active]=\"index\"\n        (bulletChange)=\"showAtIndex($event)\"\n      ></ngx-gallery-bullets>\n    }\n  </div>\n  @if (showDescription && description) {\n    <div\n      class=\"ngx-gallery-preview-text\"\n      [innerHTML]=\"description\"\n      (click)=\"$event.stopPropagation()\"\n    ></div>\n  }\n</div>\n", styles: [":host.ngx-gallery-active{width:100%;height:100%;position:fixed;left:0;top:0;background:#000000b3;z-index:10000;display:inline-block;font-size:50px!important}:host{display:none;font-size:50px!important}:host .ngx-gallery-arrow{font-size:50px!important}ngx-gallery-bullets{height:5%;align-items:center;padding:0}.ngx-gallery-preview-img{opacity:0;max-width:90%;max-height:90%;-webkit-user-select:none;user-select:none;transition:transform .5s}.ngx-gallery-preview-img.animation{transition:opacity .5s linear,transform .5s}.ngx-gallery-preview-img.ngx-gallery-active{opacity:1}.ngx-gallery-preview-img.ngx-gallery-grab{cursor:grab}.ngx-gallery-icon.ngx-gallery-spinner{font-size:50px;left:0;display:inline-block}:host .ngx-gallery-preview-top{position:absolute;width:100%;-webkit-user-select:none;user-select:none;font-size:25px}.ngx-gallery-preview-icons{float:right}.ngx-gallery-preview-icons .ngx-gallery-icon{position:relative;margin-right:10px;margin-top:10px;font-size:25px;cursor:pointer;text-decoration:none}.ngx-gallery-preview-icons .ngx-gallery-icon.ngx-gallery-icon-disabled{cursor:default;opacity:.4}.ngx-spinner-wrapper{width:50px;height:50px;display:none}.ngx-spinner-wrapper.ngx-gallery-active{display:inline-block}.ngx-gallery-center{position:absolute;inset:0;margin:auto}.ngx-gallery-preview-text{width:100%;background:#000000b3;padding:10px;text-align:center;color:#fff;font-size:16px;flex:0 1 auto;z-index:10}.ngx-gallery-preview-wrapper{width:100%;height:100%;display:flex;flex-flow:column}.ngx-gallery-preview-img-wrapper{flex:1 1 auto;position:relative}\n"], dependencies: [{ kind: "component", type: NgxGalleryArrowsComponent, selector: "ngx-gallery-arrows", inputs: ["prevDisabled", "nextDisabled", "arrowPrevIcon", "arrowNextIcon"], outputs: ["prevClick", "nextClick"] }, { kind: "component", type: NgxGalleryActionComponent, selector: "ngx-gallery-action", inputs: ["icon", "disabled", "titleText"], outputs: ["closeClick"] }, { kind: "component", type: NgxGalleryBulletsComponent, selector: "ngx-gallery-bullets", inputs: ["count", "active"], outputs: ["bulletChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryPreviewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-gallery-preview', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        NgxGalleryArrowsComponent,
                        NgxGalleryActionComponent,
                        NgxGalleryBulletsComponent,
                    ], template: "@if (arrows) {\n  <ngx-gallery-arrows\n    (prevClick)=\"showPrev()\"\n    (nextClick)=\"showNext()\"\n    [prevDisabled]=\"!canShowPrev()\"\n    [nextDisabled]=\"!canShowNext()\"\n    [arrowPrevIcon]=\"arrowPrevIcon\"\n    [arrowNextIcon]=\"arrowNextIcon\"\n  ></ngx-gallery-arrows>\n}\n<div class=\"ngx-gallery-preview-top\">\n  <div class=\"ngx-gallery-preview-icons\">\n    @for (action of actions; track action) {\n      <ngx-gallery-action\n        [icon]=\"action.icon\"\n        [disabled]=\"action.disabled\"\n        [titleText]=\"action.titleText\"\n        (closeClick)=\"action.onClick($event, index)\"\n      ></ngx-gallery-action>\n    }\n    @if (download && src) {\n      <a [href]=\"src\" class=\"ngx-gallery-icon\" aria-hidden=\"true\" download>\n        <i class=\"ngx-gallery-icon-content {{ downloadIcon }}\"></i>\n      </a>\n    }\n    @if (zoom) {\n      <ngx-gallery-action\n        [icon]=\"zoomOutIcon\"\n        [disabled]=\"!canZoomOut()\"\n        (closeClick)=\"zoomOut()\"\n      ></ngx-gallery-action>\n    }\n    @if (zoom) {\n      <ngx-gallery-action\n        [icon]=\"zoomInIcon\"\n        [disabled]=\"!canZoomIn()\"\n        (closeClick)=\"zoomIn()\"\n      ></ngx-gallery-action>\n    }\n    @if (rotate) {\n      <ngx-gallery-action\n        [icon]=\"rotateLeftIcon\"\n        (closeClick)=\"rotateLeft()\"\n      ></ngx-gallery-action>\n    }\n    @if (rotate) {\n      <ngx-gallery-action\n        [icon]=\"rotateRightIcon\"\n        (closeClick)=\"rotateRight()\"\n      ></ngx-gallery-action>\n    }\n    @if (fullscreen) {\n      <ngx-gallery-action\n        [icon]=\"'ngx-gallery-fullscreen ' + fullscreenIcon\"\n        (closeClick)=\"manageFullscreen()\"\n      ></ngx-gallery-action>\n    }\n    <ngx-gallery-action\n      [icon]=\"'ngx-gallery-close ' + closeIcon\"\n      (closeClick)=\"close()\"\n    ></ngx-gallery-action>\n  </div>\n</div>\n<div\n  class=\"ngx-spinner-wrapper ngx-gallery-center\"\n  [class.ngx-gallery-active]=\"showSpinner\"\n>\n  <i\n    class=\"ngx-gallery-icon ngx-gallery-spinner {{ spinnerIcon }}\"\n    aria-hidden=\"true\"\n  ></i>\n</div>\n<div\n  class=\"ngx-gallery-preview-wrapper\"\n  (click)=\"closeOnClick && close()\"\n  (mouseup)=\"mouseUpHandler()\"\n  (mousemove)=\"mouseMoveHandler($event)\"\n  (touchend)=\"mouseUpHandler()\"\n  (touchmove)=\"mouseMoveHandler($event)\"\n>\n  <div class=\"ngx-gallery-preview-img-wrapper\">\n    @if (src && type === 'image') {\n      <img\n        #previewImage\n        class=\"ngx-gallery-preview-img ngx-gallery-center\"\n        [src]=\"src\"\n        (click)=\"$event.stopPropagation()\"\n        (mouseenter)=\"imageMouseEnter()\"\n        (mouseleave)=\"imageMouseLeave()\"\n        (mousedown)=\"mouseDownHandler($event)\"\n        (touchstart)=\"mouseDownHandler($event)\"\n        [class.ngx-gallery-active]=\"!loading\"\n        [class.animation]=\"animation\"\n        [class.ngx-gallery-grab]=\"canDragOnZoom()\"\n        [style.transform]=\"getTransform()\"\n        [style.left]=\"positionLeft + 'px'\"\n        [style.top]=\"positionTop + 'px'\"\n      />\n    }\n    @if (src && type === 'video') {\n      <video\n        #previewImage\n        controls\n        style=\"width: 100%; height: 100%\"\n        class=\"ngx-gallery-preview-img ngx-gallery-center\"\n        (click)=\"$event.stopPropagation()\"\n        (mouseenter)=\"imageMouseEnter()\"\n        (mouseleave)=\"imageMouseLeave()\"\n        (mousedown)=\"mouseDownHandler($event)\"\n        (touchstart)=\"mouseDownHandler($event)\"\n        [class.ngx-gallery-active]=\"!loading\"\n        [class.animation]=\"animation\"\n        [class.ngx-gallery-grab]=\"canDragOnZoom()\"\n        [style.transform]=\"getTransform()\"\n        [style.left]=\"positionLeft + 'px'\"\n        [style.top]=\"positionTop + 'px'\"\n      >\n        <source [src]=\"src\" />\n        Your browser does not support the video tag.\n      </video>\n    }\n    @if (bullets) {\n      <ngx-gallery-bullets\n        [count]=\"images.length\"\n        [active]=\"index\"\n        (bulletChange)=\"showAtIndex($event)\"\n      ></ngx-gallery-bullets>\n    }\n  </div>\n  @if (showDescription && description) {\n    <div\n      class=\"ngx-gallery-preview-text\"\n      [innerHTML]=\"description\"\n      (click)=\"$event.stopPropagation()\"\n    ></div>\n  }\n</div>\n", styles: [":host.ngx-gallery-active{width:100%;height:100%;position:fixed;left:0;top:0;background:#000000b3;z-index:10000;display:inline-block;font-size:50px!important}:host{display:none;font-size:50px!important}:host .ngx-gallery-arrow{font-size:50px!important}ngx-gallery-bullets{height:5%;align-items:center;padding:0}.ngx-gallery-preview-img{opacity:0;max-width:90%;max-height:90%;-webkit-user-select:none;user-select:none;transition:transform .5s}.ngx-gallery-preview-img.animation{transition:opacity .5s linear,transform .5s}.ngx-gallery-preview-img.ngx-gallery-active{opacity:1}.ngx-gallery-preview-img.ngx-gallery-grab{cursor:grab}.ngx-gallery-icon.ngx-gallery-spinner{font-size:50px;left:0;display:inline-block}:host .ngx-gallery-preview-top{position:absolute;width:100%;-webkit-user-select:none;user-select:none;font-size:25px}.ngx-gallery-preview-icons{float:right}.ngx-gallery-preview-icons .ngx-gallery-icon{position:relative;margin-right:10px;margin-top:10px;font-size:25px;cursor:pointer;text-decoration:none}.ngx-gallery-preview-icons .ngx-gallery-icon.ngx-gallery-icon-disabled{cursor:default;opacity:.4}.ngx-spinner-wrapper{width:50px;height:50px;display:none}.ngx-spinner-wrapper.ngx-gallery-active{display:inline-block}.ngx-gallery-center{position:absolute;inset:0;margin:auto}.ngx-gallery-preview-text{width:100%;background:#000000b3;padding:10px;text-align:center;color:#fff;font-size:16px;flex:0 1 auto;z-index:10}.ngx-gallery-preview-wrapper{width:100%;height:100%;display:flex;flex-flow:column}.ngx-gallery-preview-img-wrapper{flex:1 1 auto;position:relative}\n"] }]
        }], ctorParameters: () => [{ type: i1.DomSanitizer }, { type: i0.ElementRef }, { type: NgxGalleryService }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }], propDecorators: { images: [{
                type: Input
            }], descriptions: [{
                type: Input
            }], showDescription: [{
                type: Input
            }], arrows: [{
                type: Input
            }], arrowsAutoHide: [{
                type: Input
            }], swipe: [{
                type: Input
            }], fullscreen: [{
                type: Input
            }], forceFullscreen: [{
                type: Input
            }], closeOnClick: [{
                type: Input
            }], closeOnEsc: [{
                type: Input
            }], keyboardNavigation: [{
                type: Input
            }], arrowPrevIcon: [{
                type: Input
            }], arrowNextIcon: [{
                type: Input
            }], closeIcon: [{
                type: Input
            }], fullscreenIcon: [{
                type: Input
            }], spinnerIcon: [{
                type: Input
            }], autoPlay: [{
                type: Input
            }], autoPlayInterval: [{
                type: Input
            }], autoPlayPauseOnHover: [{
                type: Input
            }], infinityMove: [{
                type: Input
            }], zoom: [{
                type: Input
            }], zoomStep: [{
                type: Input
            }], zoomMax: [{
                type: Input
            }], zoomMin: [{
                type: Input
            }], zoomInIcon: [{
                type: Input
            }], zoomOutIcon: [{
                type: Input
            }], animation: [{
                type: Input
            }], actions: [{
                type: Input
            }], rotate: [{
                type: Input
            }], rotateLeftIcon: [{
                type: Input
            }], rotateRightIcon: [{
                type: Input
            }], download: [{
                type: Input
            }], downloadIcon: [{
                type: Input
            }], bullets: [{
                type: Input
            }], previewOpen: [{
                type: Output
            }], previewClose: [{
                type: Output
            }], activeChange: [{
                type: Output
            }], previewImage: [{
                type: ViewChild,
                args: ['previewImage']
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class NgxGalleryAnimation {
    static { this.Fade = 'fade'; }
    static { this.Slide = 'slide'; }
    static { this.Rotate = 'rotate'; }
    static { this.Zoom = 'zoom'; }
}

class NgxGalleryImageComponent {
    set selectedIndex(index) {
        if (index > this._selectedIndex) {
            let action;
            if (this.animation === NgxGalleryAnimation.Slide) {
                action = 'slideRight';
            }
            else if (this.animation === NgxGalleryAnimation.Fade) {
                action = 'fade';
            }
            else if (this.animation === NgxGalleryAnimation.Rotate) {
                action = 'rotateRight';
            }
            else if (this.animation === NgxGalleryAnimation.Zoom) {
                action = 'zoom';
            }
            this.setAction(action);
        }
        else if (index < this._selectedIndex) {
            let action;
            if (this.animation === NgxGalleryAnimation.Slide) {
                action = 'slideLeft';
            }
            else if (this.animation === NgxGalleryAnimation.Fade) {
                action = 'fade';
            }
            else if (this.animation === NgxGalleryAnimation.Rotate) {
                action = 'rotateLeft';
            }
            else if (this.animation === NgxGalleryAnimation.Zoom) {
                action = 'zoom';
            }
            this.setAction(action);
        }
        this._selectedIndex = index;
    }
    constructor(sanitization, changeDetectorRef, elementRef, helperService) {
        this.sanitization = sanitization;
        this.changeDetectorRef = changeDetectorRef;
        this.elementRef = elementRef;
        this.helperService = helperService;
        this.imageClick = new EventEmitter();
        this.activeChange = new EventEmitter();
        this.animating = new EventEmitter();
        this.canChangeImage = true;
        this.isAnimating = false;
        this.changeDetectorRef = changeDetectorRef;
        this.action = 'none';
    }
    // @HostBinding('style.display') public display = 'inline-block';
    // @HostBinding('style.background-color') public color = 'lime';
    ngOnInit() {
        if (this.arrows && this.arrowsAutoHide) {
            this.arrows = false;
        }
        if (this.autoPlay) {
            this.startAutoPlay();
        }
    }
    ngOnChanges(changes) {
        if (changes['swipe']) {
            this.helperService.manageSwipe(this.swipe, this.elementRef, 'image', () => this.showNext(), () => this.showPrev());
        }
    }
    onMouseEnter() {
        if (this.arrowsAutoHide && !this.arrows) {
            this.arrows = true;
        }
        if (this.autoPlay && this.autoPlayPauseOnHover) {
            this.stopAutoPlay();
        }
    }
    onMouseLeave() {
        if (this.arrowsAutoHide && this.arrows) {
            this.arrows = false;
        }
        if (this.autoPlay && this.autoPlayPauseOnHover) {
            this.startAutoPlay();
        }
    }
    reset(index) {
        this._selectedIndex = index;
        this.action = 'none';
    }
    getImages() {
        if (!this.images) {
            return [];
        }
        if (this.lazyLoading) {
            const indexes = [this._selectedIndex];
            const prevIndex = this._selectedIndex - 1;
            if (prevIndex === -1 && this.infinityMove) {
                indexes.push(this.images.length - 1);
            }
            else if (prevIndex >= 0) {
                indexes.push(prevIndex);
            }
            const nextIndex = this._selectedIndex + 1;
            if (nextIndex === this.images.length && this.infinityMove) {
                indexes.push(0);
            }
            else if (nextIndex < this.images.length) {
                indexes.push(nextIndex);
            }
            return this.images.filter((img, i) => indexes.indexOf(i) !== -1);
        }
        else {
            return this.images;
        }
    }
    startAutoPlay() {
        this.stopAutoPlay();
        this.timer = setInterval(() => {
            if (!this.showNext()) {
                this._selectedIndex = -1;
                this.showNext();
            }
        }, this.autoPlayInterval);
    }
    stopAutoPlay() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
    handleClick(event, index) {
        if (this.clickable) {
            this.imageClick.emit(index);
            event.stopPropagation();
            event.preventDefault();
        }
    }
    show(index) {
        if (this.isAnimating) {
            return;
        }
        if (index > this._selectedIndex) {
            let action;
            if (this.animation === NgxGalleryAnimation.Slide) {
                action = 'slideRight';
            }
            else if (this.animation === NgxGalleryAnimation.Fade) {
                action = 'fade';
            }
            else if (this.animation === NgxGalleryAnimation.Rotate) {
                action = 'rotateRight';
            }
            else if (this.animation === NgxGalleryAnimation.Zoom) {
                action = 'zoom';
            }
            this.setAction(action);
        }
        else {
            let action;
            if (this.animation === NgxGalleryAnimation.Slide) {
                action = 'slideLeft';
            }
            else if (this.animation === NgxGalleryAnimation.Fade) {
                action = 'fade';
            }
            else if (this.animation === NgxGalleryAnimation.Rotate) {
                action = 'rotateLeft';
            }
            else if (this.animation === NgxGalleryAnimation.Zoom) {
                action = 'zoom';
            }
            this.setAction(action);
        }
        this._selectedIndex = index;
        this.activeChange.emit(this._selectedIndex);
        this.setChangeTimeout();
    }
    setAction(action) {
        this.action = action;
        this.changeDetectorRef.detectChanges();
    }
    showNext() {
        if (this.isAnimating) {
            return false;
        }
        if (this.canShowNext() && this.canChangeImage) {
            let action;
            if (this.animation === NgxGalleryAnimation.Slide) {
                action = 'slideRight';
            }
            else if (this.animation === NgxGalleryAnimation.Fade) {
                action = 'fade';
            }
            else if (this.animation === NgxGalleryAnimation.Rotate) {
                action = 'rotateRight';
            }
            else if (this.animation === NgxGalleryAnimation.Zoom) {
                action = 'zoom';
            }
            this.setAction(action);
            this._selectedIndex++;
            if (this._selectedIndex === this.images.length) {
                this._selectedIndex = 0;
            }
            this.activeChange.emit(this._selectedIndex);
            this.setChangeTimeout();
            return true;
        }
        else {
            return false;
        }
    }
    showPrev() {
        if (this.isAnimating) {
            return;
        }
        if (this.canShowPrev() && this.canChangeImage) {
            let action;
            if (this.animation === NgxGalleryAnimation.Slide) {
                action = 'slideLeft';
            }
            else if (this.animation === NgxGalleryAnimation.Fade) {
                action = 'fade';
            }
            else if (this.animation === NgxGalleryAnimation.Rotate) {
                action = 'rotateLeft';
            }
            else if (this.animation === NgxGalleryAnimation.Zoom) {
                action = 'zoom';
            }
            this.setAction(action);
            this._selectedIndex--;
            if (this._selectedIndex < 0) {
                this._selectedIndex = this.images.length - 1;
            }
            this.activeChange.emit(this._selectedIndex);
            this.setChangeTimeout();
        }
    }
    setChangeTimeout() {
        this.canChangeImage = false;
        let timeout = 1000;
        if (this.animation === NgxGalleryAnimation.Slide ||
            this.animation === NgxGalleryAnimation.Fade) {
            timeout = 500;
        }
        setTimeout(() => {
            this.canChangeImage = true;
        }, timeout);
    }
    canShowNext() {
        if (this.images) {
            return this.infinityMove || this._selectedIndex < this.images.length - 1;
        }
        else {
            return false;
        }
    }
    canShowPrev() {
        if (this.images) {
            return this.infinityMove || this._selectedIndex > 0;
        }
        else {
            return false;
        }
    }
    getSafeUrl(image) {
        return this.sanitization.bypassSecurityTrustStyle(this.helperService.getBackgroundUrl(image.toString()));
    }
    getFileType(fileSource) {
        return this.helperService.getFileType(fileSource);
    }
    onStart(event) {
        this.isAnimating = true;
        this.animating.emit(true);
    }
    onDone(event) {
        this.isAnimating = false;
        this.animating.emit(false);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryImageComponent, deps: [{ token: i1.DomSanitizer }, { token: i0.ChangeDetectorRef }, { token: i0.ElementRef }, { token: NgxGalleryService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.1.3", type: NgxGalleryImageComponent, isStandalone: true, selector: "ngx-gallery-image", inputs: { images: "images", clickable: "clickable", selectedIndex: "selectedIndex", arrows: "arrows", arrowsAutoHide: "arrowsAutoHide", swipe: "swipe", animation: "animation", size: "size", arrowPrevIcon: "arrowPrevIcon", arrowNextIcon: "arrowNextIcon", autoPlay: "autoPlay", autoPlayInterval: "autoPlayInterval", autoPlayPauseOnHover: "autoPlayPauseOnHover", infinityMove: "infinityMove", lazyLoading: "lazyLoading", actions: "actions", descriptions: "descriptions", showDescription: "showDescription", bullets: "bullets" }, outputs: { imageClick: "imageClick", activeChange: "activeChange", animating: "animating" }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()" } }, usesOnChanges: true, ngImport: i0, template: "<div\n  class=\"ngx-gallery-image-wrapper ngx-gallery-animation-{{\n    animation\n  }} ngx-gallery-image-size-{{ size }}\"\n>\n  @for (image of getImages(); track image; let i = $index) {\n    @if (image.type === 'image' && image.index === _selectedIndex) {\n      <div\n        class=\"ngx-gallery-image\"\n        [ngClass]=\"{ 'ngx-gallery-clickable': clickable }\"\n        [style.background-image]=\"getSafeUrl(image.src)\"\n        (click)=\"handleClick($event, image.index)\"\n        [@animation]=\"action\"\n        (@animation.start)=\"onStart($event)\"\n        (@animation.done)=\"onDone($event)\"\n      >\n        <div class=\"ngx-gallery-icons-wrapper\">\n          @for (action of actions; track action) {\n            <ngx-gallery-action\n              [icon]=\"action.icon\"\n              [disabled]=\"action.disabled\"\n              [titleText]=\"action.titleText\"\n              (closeClick)=\"action.onClick($event, image.index)\"\n            ></ngx-gallery-action>\n          }\n        </div>\n        @if (showDescription && descriptions[image.index]) {\n          <div\n            class=\"ngx-gallery-image-text\"\n            [innerHTML]=\"descriptions[image.index]\"\n            (click)=\"$event.stopPropagation()\"\n          ></div>\n        }\n      </div>\n    }\n    @if (image.type === 'video' && image.index === _selectedIndex) {\n      <div\n        class=\"ngx-gallery-image\"\n        [ngClass]=\"{ 'ngx-gallery-clickable': clickable }\"\n        [style.background-image]=\"getSafeUrl(image.src)\"\n        (click)=\"handleClick($event, image.index)\"\n        [@animation]=\"action\"\n        (@animation.start)=\"onStart($event)\"\n        (@animation.done)=\"onDone($event)\"\n      >\n        <video controls style=\"width: 100%; height: 100%; background: #000\">\n          <source [src]=\"image.src\" />\n          Your browser does not support the video tag.\n        </video>\n        <div class=\"ngx-gallery-icons-wrapper\">\n          @for (action of actions; track action) {\n            <ngx-gallery-action\n              [icon]=\"action.icon\"\n              [disabled]=\"action.disabled\"\n              [titleText]=\"action.titleText\"\n              (closeClick)=\"action.onClick($event, image.index)\"\n            ></ngx-gallery-action>\n          }\n        </div>\n        @if (showDescription && descriptions[image.index]) {\n          <div\n            class=\"ngx-gallery-image-text\"\n            [innerHTML]=\"descriptions[image.index]\"\n            (click)=\"$event.stopPropagation()\"\n          ></div>\n        }\n      </div>\n    }\n  }\n  @if (bullets) {\n    <ngx-gallery-bullets\n      [count]=\"images.length\"\n      [active]=\"_selectedIndex\"\n      (bulletChange)=\"show($event)\"\n    ></ngx-gallery-bullets>\n  }\n  @if (arrows) {\n    <ngx-gallery-arrows\n      class=\"ngx-gallery-image-size-{{ size }}\"\n      (prevClick)=\"showPrev()\"\n      (nextClick)=\"showNext()\"\n      [prevDisabled]=\"!canShowPrev()\"\n      [nextDisabled]=\"!canShowNext()\"\n      [arrowPrevIcon]=\"arrowPrevIcon\"\n      [arrowNextIcon]=\"arrowNextIcon\"\n    ></ngx-gallery-arrows>\n  }\n</div>\n", styles: [":host{width:100%;display:inline-block;position:relative;font-size:25px}.ngx-gallery-image-wrapper{width:100%;height:100%;position:absolute;left:0;top:0;overflow:hidden}.ngx-gallery-image{background-position:center;background-repeat:no-repeat;height:100%;width:100%;position:absolute;top:0}.ngx-gallery-image-size-cover .ngx-gallery-image{background-size:cover}.ngx-gallery-image-size-contain .ngx-gallery-image{background-size:contain}.ngx-gallery-animation-fade .ngx-gallery-image{left:0;opacity:1;transition:.5s ease-in-out}.ngx-gallery-animation-fade .ngx-gallery-image.ngx-gallery-active{opacity:1}.ngx-gallery-animation-rotate .ngx-gallery-image{transition:1s ease;transform:scale(1) rotate(0);left:0;opacity:1}.ngx-gallery-animation-zoom .ngx-gallery-image{transition:1s ease;transform:scale(1);left:0;opacity:1}.ngx-gallery-image-text{width:100%;background:#000000b3;padding:10px;text-align:center;color:#fff;font-size:16px;position:absolute;bottom:0;z-index:10}\n"], dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: NgxGalleryActionComponent, selector: "ngx-gallery-action", inputs: ["icon", "disabled", "titleText"], outputs: ["closeClick"] }, { kind: "component", type: NgxGalleryBulletsComponent, selector: "ngx-gallery-bullets", inputs: ["count", "active"], outputs: ["bulletChange"] }, { kind: "component", type: NgxGalleryArrowsComponent, selector: "ngx-gallery-arrows", inputs: ["prevDisabled", "nextDisabled", "arrowPrevIcon", "arrowNextIcon"], outputs: ["prevClick", "nextClick"] }], animations: [
            trigger('animation', [
                // ...
                state('slideRight', style({})),
                state('slideLeft', style({})),
                state('fade', style({})),
                state('rotateLeft', style({})),
                state('rotateRight', style({})),
                state('zoom', style({})),
                transition('slideRight => void', [
                    animate('500ms ease-in-out', style({ transform: 'translateX(-100%)' })),
                ]),
                transition('void => slideRight', [
                    style({ transform: 'translateX(100%)' }),
                    animate('500ms ease-in-out', style({ transform: 'translateX(0)' })),
                ]),
                transition('slideLeft => void', [
                    animate('500ms ease-in-out', style({ transform: 'translateX(100%)' })),
                ]),
                transition('void => slideLeft', [
                    style({ transform: 'translateX(-100%)' }),
                    animate('500ms ease-in-out', style({ transform: 'translateX(0)' })),
                ]),
                transition('fade => void', [animate('500ms ease-in-out', style({ opacity: '0' }))]),
                transition('void => fade', [
                    style({ opacity: '0' }),
                    animate('500ms ease-in-out', style({ opacity: '1' })),
                ]),
                transition('rotateLeft => void', [
                    animate('500ms ease-in-out', style({ transform: 'scale(1, 1) rotate(-90deg)', opacity: '0' })),
                ]),
                transition('void => rotateLeft', [
                    style({ transform: 'scale(1, 1) rotate(-90deg)', opacity: '0' }),
                    animate('500ms ease-in-out', style({ transform: 'scale(1, 1) rotate(0deg)', opacity: '1' })),
                ]),
                transition('rotateRight => void', [
                    animate('500ms ease-in-out', style({ transform: 'scale(1, 1) rotate(90deg)', opacity: '0' })),
                ]),
                transition('void => rotateRight', [
                    style({ transform: 'scale(1, 1) rotate(90deg)', opacity: '0' }),
                    animate('500ms ease-in-out', style({ transform: 'scale(1, 1) rotate(0deg)', opacity: '1' })),
                ]),
                transition('zoom => void', [
                    animate('500ms ease-in-out', style({ transform: 'scale(2.5,2.5)', opacity: '0' })),
                ]),
                transition('void => zoom', [
                    style({ transform: 'scale(2.5,2.5)', opacity: '0' }),
                    animate('500ms ease-in-out', style({ transform: 'scale(1, 1)', opacity: '1' })),
                ]),
            ]),
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryImageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-gallery-image', changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('animation', [
                            // ...
                            state('slideRight', style({})),
                            state('slideLeft', style({})),
                            state('fade', style({})),
                            state('rotateLeft', style({})),
                            state('rotateRight', style({})),
                            state('zoom', style({})),
                            transition('slideRight => void', [
                                animate('500ms ease-in-out', style({ transform: 'translateX(-100%)' })),
                            ]),
                            transition('void => slideRight', [
                                style({ transform: 'translateX(100%)' }),
                                animate('500ms ease-in-out', style({ transform: 'translateX(0)' })),
                            ]),
                            transition('slideLeft => void', [
                                animate('500ms ease-in-out', style({ transform: 'translateX(100%)' })),
                            ]),
                            transition('void => slideLeft', [
                                style({ transform: 'translateX(-100%)' }),
                                animate('500ms ease-in-out', style({ transform: 'translateX(0)' })),
                            ]),
                            transition('fade => void', [animate('500ms ease-in-out', style({ opacity: '0' }))]),
                            transition('void => fade', [
                                style({ opacity: '0' }),
                                animate('500ms ease-in-out', style({ opacity: '1' })),
                            ]),
                            transition('rotateLeft => void', [
                                animate('500ms ease-in-out', style({ transform: 'scale(1, 1) rotate(-90deg)', opacity: '0' })),
                            ]),
                            transition('void => rotateLeft', [
                                style({ transform: 'scale(1, 1) rotate(-90deg)', opacity: '0' }),
                                animate('500ms ease-in-out', style({ transform: 'scale(1, 1) rotate(0deg)', opacity: '1' })),
                            ]),
                            transition('rotateRight => void', [
                                animate('500ms ease-in-out', style({ transform: 'scale(1, 1) rotate(90deg)', opacity: '0' })),
                            ]),
                            transition('void => rotateRight', [
                                style({ transform: 'scale(1, 1) rotate(90deg)', opacity: '0' }),
                                animate('500ms ease-in-out', style({ transform: 'scale(1, 1) rotate(0deg)', opacity: '1' })),
                            ]),
                            transition('zoom => void', [
                                animate('500ms ease-in-out', style({ transform: 'scale(2.5,2.5)', opacity: '0' })),
                            ]),
                            transition('void => zoom', [
                                style({ transform: 'scale(2.5,2.5)', opacity: '0' }),
                                animate('500ms ease-in-out', style({ transform: 'scale(1, 1)', opacity: '1' })),
                            ]),
                        ]),
                    ], standalone: true, imports: [
                        NgClass,
                        NgxGalleryActionComponent,
                        NgxGalleryBulletsComponent,
                        NgxGalleryArrowsComponent,
                    ], template: "<div\n  class=\"ngx-gallery-image-wrapper ngx-gallery-animation-{{\n    animation\n  }} ngx-gallery-image-size-{{ size }}\"\n>\n  @for (image of getImages(); track image; let i = $index) {\n    @if (image.type === 'image' && image.index === _selectedIndex) {\n      <div\n        class=\"ngx-gallery-image\"\n        [ngClass]=\"{ 'ngx-gallery-clickable': clickable }\"\n        [style.background-image]=\"getSafeUrl(image.src)\"\n        (click)=\"handleClick($event, image.index)\"\n        [@animation]=\"action\"\n        (@animation.start)=\"onStart($event)\"\n        (@animation.done)=\"onDone($event)\"\n      >\n        <div class=\"ngx-gallery-icons-wrapper\">\n          @for (action of actions; track action) {\n            <ngx-gallery-action\n              [icon]=\"action.icon\"\n              [disabled]=\"action.disabled\"\n              [titleText]=\"action.titleText\"\n              (closeClick)=\"action.onClick($event, image.index)\"\n            ></ngx-gallery-action>\n          }\n        </div>\n        @if (showDescription && descriptions[image.index]) {\n          <div\n            class=\"ngx-gallery-image-text\"\n            [innerHTML]=\"descriptions[image.index]\"\n            (click)=\"$event.stopPropagation()\"\n          ></div>\n        }\n      </div>\n    }\n    @if (image.type === 'video' && image.index === _selectedIndex) {\n      <div\n        class=\"ngx-gallery-image\"\n        [ngClass]=\"{ 'ngx-gallery-clickable': clickable }\"\n        [style.background-image]=\"getSafeUrl(image.src)\"\n        (click)=\"handleClick($event, image.index)\"\n        [@animation]=\"action\"\n        (@animation.start)=\"onStart($event)\"\n        (@animation.done)=\"onDone($event)\"\n      >\n        <video controls style=\"width: 100%; height: 100%; background: #000\">\n          <source [src]=\"image.src\" />\n          Your browser does not support the video tag.\n        </video>\n        <div class=\"ngx-gallery-icons-wrapper\">\n          @for (action of actions; track action) {\n            <ngx-gallery-action\n              [icon]=\"action.icon\"\n              [disabled]=\"action.disabled\"\n              [titleText]=\"action.titleText\"\n              (closeClick)=\"action.onClick($event, image.index)\"\n            ></ngx-gallery-action>\n          }\n        </div>\n        @if (showDescription && descriptions[image.index]) {\n          <div\n            class=\"ngx-gallery-image-text\"\n            [innerHTML]=\"descriptions[image.index]\"\n            (click)=\"$event.stopPropagation()\"\n          ></div>\n        }\n      </div>\n    }\n  }\n  @if (bullets) {\n    <ngx-gallery-bullets\n      [count]=\"images.length\"\n      [active]=\"_selectedIndex\"\n      (bulletChange)=\"show($event)\"\n    ></ngx-gallery-bullets>\n  }\n  @if (arrows) {\n    <ngx-gallery-arrows\n      class=\"ngx-gallery-image-size-{{ size }}\"\n      (prevClick)=\"showPrev()\"\n      (nextClick)=\"showNext()\"\n      [prevDisabled]=\"!canShowPrev()\"\n      [nextDisabled]=\"!canShowNext()\"\n      [arrowPrevIcon]=\"arrowPrevIcon\"\n      [arrowNextIcon]=\"arrowNextIcon\"\n    ></ngx-gallery-arrows>\n  }\n</div>\n", styles: [":host{width:100%;display:inline-block;position:relative;font-size:25px}.ngx-gallery-image-wrapper{width:100%;height:100%;position:absolute;left:0;top:0;overflow:hidden}.ngx-gallery-image{background-position:center;background-repeat:no-repeat;height:100%;width:100%;position:absolute;top:0}.ngx-gallery-image-size-cover .ngx-gallery-image{background-size:cover}.ngx-gallery-image-size-contain .ngx-gallery-image{background-size:contain}.ngx-gallery-animation-fade .ngx-gallery-image{left:0;opacity:1;transition:.5s ease-in-out}.ngx-gallery-animation-fade .ngx-gallery-image.ngx-gallery-active{opacity:1}.ngx-gallery-animation-rotate .ngx-gallery-image{transition:1s ease;transform:scale(1) rotate(0);left:0;opacity:1}.ngx-gallery-animation-zoom .ngx-gallery-image{transition:1s ease;transform:scale(1);left:0;opacity:1}.ngx-gallery-image-text{width:100%;background:#000000b3;padding:10px;text-align:center;color:#fff;font-size:16px;position:absolute;bottom:0;z-index:10}\n"] }]
        }], ctorParameters: () => [{ type: i1.DomSanitizer }, { type: i0.ChangeDetectorRef }, { type: i0.ElementRef }, { type: NgxGalleryService }], propDecorators: { images: [{
                type: Input
            }], clickable: [{
                type: Input
            }], selectedIndex: [{
                type: Input
            }], arrows: [{
                type: Input
            }], arrowsAutoHide: [{
                type: Input
            }], swipe: [{
                type: Input
            }], animation: [{
                type: Input
            }], size: [{
                type: Input
            }], arrowPrevIcon: [{
                type: Input
            }], arrowNextIcon: [{
                type: Input
            }], autoPlay: [{
                type: Input
            }], autoPlayInterval: [{
                type: Input
            }], autoPlayPauseOnHover: [{
                type: Input
            }], infinityMove: [{
                type: Input
            }], lazyLoading: [{
                type: Input
            }], actions: [{
                type: Input
            }], descriptions: [{
                type: Input
            }], showDescription: [{
                type: Input
            }], bullets: [{
                type: Input
            }], imageClick: [{
                type: Output
            }], activeChange: [{
                type: Output
            }], animating: [{
                type: Output
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class NgxGalleryOrder {
    static { this.Column = 1; }
    static { this.Row = 2; }
    static { this.Page = 3; }
}

class NgxGalleryThumbnailsComponent {
    constructor(sanitization, elementRef, helperService) {
        this.sanitization = sanitization;
        this.elementRef = elementRef;
        this.helperService = helperService;
        this.minStopIndex = 0;
        this.activeChange = new EventEmitter();
        this.index = 0;
    }
    ngOnChanges(changes) {
        if (changes['selectedIndex']) {
            this.validateIndex();
        }
        if (changes['swipe']) {
            this.helperService.manageSwipe(this.swipe, this.elementRef, 'thumbnails', () => this.moveRight(), () => this.moveLeft());
        }
        if (this.images) {
            this.remainingCountValue = this.images.length - this.rows * this.columns;
        }
    }
    onMouseEnter() {
        this.mouseenter = true;
    }
    onMouseLeave() {
        this.mouseenter = false;
    }
    reset(index) {
        this.selectedIndex = index;
        this.setDefaultPosition();
        this.index = 0;
        this.validateIndex();
    }
    getImages() {
        if (!this.images) {
            return [];
        }
        if (this.remainingCount) {
            return this.images.slice(0, this.rows * this.columns);
        }
        else if (this.lazyLoading && this.order !== NgxGalleryOrder.Row) {
            let stopIndex = 0;
            if (this.order === NgxGalleryOrder.Column) {
                stopIndex = (this.index + this.columns + this.moveSize) * this.rows;
            }
            else if (this.order === NgxGalleryOrder.Page) {
                stopIndex = this.index + this.columns * this.rows * 2;
            }
            if (stopIndex <= this.minStopIndex) {
                stopIndex = this.minStopIndex;
            }
            else {
                this.minStopIndex = stopIndex;
            }
            return this.images.slice(0, stopIndex);
        }
        else {
            return this.images;
        }
    }
    handleClick(event, index) {
        if (!this.hasLink(index) && !this.isAnimating) {
            this.selectedIndex = index;
            this.activeChange.emit(index);
        }
        event.stopPropagation();
        event.preventDefault();
    }
    hasLink(index) {
        return !!(this.links && this.links.length && this.links[index]);
    }
    moveRight() {
        if (this.canMoveRight()) {
            this.index += this.moveSize;
            const maxIndex = this.getMaxIndex() - this.columns;
            if (this.index > maxIndex) {
                this.index = maxIndex;
            }
            this.setThumbnailsPosition();
        }
    }
    moveLeft() {
        if (this.canMoveLeft()) {
            this.index -= this.moveSize;
            if (this.index < 0) {
                this.index = 0;
            }
            this.setThumbnailsPosition();
        }
    }
    canMoveRight() {
        return this.index + this.columns < this.getMaxIndex();
    }
    canMoveLeft() {
        return this.index !== 0;
    }
    getThumbnailLeft(index) {
        let calculatedIndex;
        if (this.order === NgxGalleryOrder.Column) {
            calculatedIndex = Math.floor(index / this.rows);
        }
        else if (this.order === NgxGalleryOrder.Page) {
            calculatedIndex =
                (index % this.columns) +
                    Math.floor(index / (this.rows * this.columns)) * this.columns;
        }
        else if (this.order === NgxGalleryOrder.Row && this.remainingCount) {
            calculatedIndex = index % this.columns;
        }
        else {
            calculatedIndex = index % Math.ceil(this.images.length / this.rows);
        }
        return this.getThumbnailPosition(calculatedIndex, this.columns);
    }
    getThumbnailTop(index) {
        let calculatedIndex;
        if (this.order === NgxGalleryOrder.Column) {
            calculatedIndex = index % this.rows;
        }
        else if (this.order === NgxGalleryOrder.Page) {
            calculatedIndex =
                Math.floor(index / this.columns) -
                    Math.floor(index / (this.rows * this.columns)) * this.rows;
        }
        else if (this.order === NgxGalleryOrder.Row && this.remainingCount) {
            calculatedIndex = Math.floor(index / this.columns);
        }
        else {
            calculatedIndex = Math.floor(index / Math.ceil(this.images.length / this.rows));
        }
        return this.getThumbnailPosition(calculatedIndex, this.rows);
    }
    getThumbnailWidth() {
        return this.getThumbnailDimension(this.columns);
    }
    getThumbnailHeight() {
        return this.getThumbnailDimension(this.rows);
    }
    setThumbnailsPosition() {
        this.thumbnailsLeft = -((100 / this.columns) * this.index) + '%';
        this.thumbnailsMarginLeft =
            -((this.margin - ((this.columns - 1) * this.margin) / this.columns) * this.index) +
                'px';
    }
    setDefaultPosition() {
        this.thumbnailsLeft = '0px';
        this.thumbnailsMarginLeft = '0px';
    }
    canShowArrows() {
        if (this.remainingCount) {
            return false;
        }
        else {
            return (this.arrows &&
                this.images &&
                this.images.length > this.getVisibleCount() &&
                (!this.arrowsAutoHide || this.mouseenter));
        }
    }
    validateIndex() {
        if (this.images) {
            let newIndex;
            if (this.order === NgxGalleryOrder.Column) {
                newIndex = Math.floor(this.selectedIndex / this.rows);
            }
            else {
                newIndex = this.selectedIndex % Math.ceil(this.images.length / this.rows);
            }
            if (this.remainingCount) {
                newIndex = 0;
            }
            if (newIndex < this.index || newIndex >= this.index + this.columns) {
                const maxIndex = this.getMaxIndex() - this.columns;
                this.index = newIndex > maxIndex ? maxIndex : newIndex;
                this.setThumbnailsPosition();
            }
        }
    }
    getSafeUrl(image) {
        return this.sanitization.bypassSecurityTrustStyle(this.helperService.getBackgroundUrl(image.toString()));
    }
    getFileType(fileSource) {
        return this.helperService.getFileType(fileSource.toString());
    }
    getThumbnailPosition(index, count) {
        return this.getSafeStyle('calc(' +
            (100 / count) * index +
            '% + ' +
            (this.margin - ((count - 1) * this.margin) / count) * index +
            'px)');
    }
    getThumbnailDimension(count) {
        if (this.margin !== 0) {
            return this.getSafeStyle('calc(' + 100 / count + '% - ' + ((count - 1) * this.margin) / count + 'px)');
        }
        else {
            return this.getSafeStyle('calc(' + 100 / count + '% + 1px)');
        }
    }
    getMaxIndex() {
        if (this.order === NgxGalleryOrder.Page) {
            let maxIndex = Math.floor(this.images.length / this.getVisibleCount()) * this.columns;
            if (this.images.length % this.getVisibleCount() > this.columns) {
                maxIndex += this.columns;
            }
            else {
                maxIndex += this.images.length % this.getVisibleCount();
            }
            return maxIndex;
        }
        else {
            return Math.ceil(this.images.length / this.rows);
        }
    }
    getVisibleCount() {
        return this.columns * this.rows;
    }
    getSafeStyle(value) {
        return this.sanitization.bypassSecurityTrustStyle(value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryThumbnailsComponent, deps: [{ token: i1.DomSanitizer }, { token: i0.ElementRef }, { token: NgxGalleryService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.1.3", type: NgxGalleryThumbnailsComponent, isStandalone: true, selector: "ngx-gallery-thumbnails", inputs: { images: "images", isAnimating: "isAnimating", links: "links", labels: "labels", linkTarget: "linkTarget", columns: "columns", rows: "rows", arrows: "arrows", arrowsAutoHide: "arrowsAutoHide", margin: "margin", selectedIndex: "selectedIndex", clickable: "clickable", swipe: "swipe", size: "size", arrowPrevIcon: "arrowPrevIcon", arrowNextIcon: "arrowNextIcon", moveSize: "moveSize", order: "order", remainingCount: "remainingCount", lazyLoading: "lazyLoading", actions: "actions" }, outputs: { activeChange: "activeChange" }, host: { listeners: { "mouseenter": "onMouseEnter()", "mouseleave": "onMouseLeave()" } }, usesOnChanges: true, ngImport: i0, template: "<div class=\"ngx-gallery-thumbnails-wrapper ngx-gallery-thumbnail-size-{{ size }}\">\n  <div\n    class=\"ngx-gallery-thumbnails\"\n    [style.transform]=\"'translateX(' + thumbnailsLeft + ')'\"\n    [style.marginLeft]=\"thumbnailsMarginLeft\"\n  >\n    @for (image of getImages(); track image; let i = $index) {\n      <a\n        [href]=\"hasLink(i) ? links[i] : '#'\"\n        [target]=\"linkTarget\"\n        class=\"ngx-gallery-thumbnail\"\n        (click)=\"handleClick($event, i)\"\n        [style.width]=\"getThumbnailWidth()\"\n        [style.height]=\"getThumbnailHeight()\"\n        [style.left]=\"getThumbnailLeft(i)\"\n        [style.top]=\"getThumbnailTop(i)\"\n        [ngClass]=\"{\n          'ngx-gallery-active': i === selectedIndex,\n          'ngx-gallery-clickable': clickable,\n        }\"\n        [attr.aria-label]=\"labels[i]\"\n      >\n        @if (getFileType(image) === 'image') {\n          <div\n            [style.background-image]=\"getSafeUrl(image)\"\n            class=\"ngx-gallery-thumbnail\"\n            [ngClass]=\"{\n              'ngx-gallery-active': i === selectedIndex,\n              'ngx-gallery-clickable': clickable,\n            }\"\n            style=\"width: 100%; height: 100%; position: absolute\"\n          ></div>\n        }\n        @if (getFileType(image) === 'video') {\n          <div class=\"ngx-gallery-thumbnail-video\">\n            <video\n              class=\"ngx-gallery-thumbnail\"\n              [ngClass]=\"{\n                'ngx-gallery-active': i === selectedIndex,\n                'ngx-gallery-clickable': clickable,\n              }\"\n              style=\"\n                width: 100%;\n                height: 100%;\n                position: absolute;\n                left: 0;\n                background: #000;\n              \"\n            >\n              <source [src]=\"image\" />\n              Your browser does not support the video tag.\n            </video>\n          </div>\n        }\n        <div class=\"ngx-gallery-icons-wrapper\">\n          @for (action of actions; track action) {\n            <ngx-gallery-action\n              [icon]=\"action.icon\"\n              [disabled]=\"action.disabled\"\n              [titleText]=\"action.titleText\"\n              (closeClick)=\"action.onClick($event, i)\"\n            ></ngx-gallery-action>\n          }\n        </div>\n        @if (remainingCount && remainingCountValue && i === rows * columns - 1) {\n          <div class=\"ngx-gallery-remaining-count-overlay\">\n            <span class=\"ngx-gallery-remaining-count\">+{{ remainingCountValue }}</span>\n          </div>\n        }\n      </a>\n    }\n  </div>\n</div>\n@if (canShowArrows()) {\n  <ngx-gallery-arrows\n    (prevClick)=\"moveLeft()\"\n    (nextClick)=\"moveRight()\"\n    [prevDisabled]=\"!canMoveLeft()\"\n    [nextDisabled]=\"!canMoveRight()\"\n    [arrowPrevIcon]=\"arrowPrevIcon\"\n    [arrowNextIcon]=\"arrowNextIcon\"\n  ></ngx-gallery-arrows>\n}\n", styles: ["@charset \"UTF-8\";:host{width:100%;display:inline-block;position:relative;font-size:25px}.ngx-gallery-thumbnails-wrapper{width:100%;height:100%;position:absolute;overflow:hidden}.ngx-gallery-thumbnails{height:100%;width:100%;position:absolute;left:0;transform:translate(0);transition:transform .5s ease-in-out;will-change:transform}.ngx-gallery-thumbnails .ngx-gallery-thumbnail{position:absolute;height:100%;background-position:center;background-repeat:no-repeat;text-decoration:none;border:1px double black}.ngx-gallery-thumbnails .ngx-gallery-thumbnail .ngx-gallery-thumbnail-video:after{content:\"\\f144\";display:block;position:absolute;background:#0000;height:100%;width:100%;left:0;top:calc(50% - 20px);font-size:40px;color:#fff;margin:0;padding:0;font-family:fontawesome;text-shadow:0px 4px 3px rgba(0,0,0,.4),0px 8px 13px rgba(0,0,0,.1),0px 18px 23px rgba(0,0,0,.1)}.ngx-gallery-thumbnails .ngx-gallery-thumbnail .img{background-size:cover;height:100%}.ngx-gallery-thumbnails .ngx-gallery-thumbnail.ngx-gallery-active{border:1px double #cc4548}.ngx-gallery-thumbnail-size-cover .ngx-gallery-thumbnails .ngx-gallery-thumbnail{background-size:cover}.ngx-gallery-thumbnail-size-contain .ngx-gallery-thumbnails .ngx-gallery-thumbnail{background-size:contain}.ngx-gallery-remaining-count-overlay{width:100%;height:100%;position:absolute;left:0;top:0;background-color:#0006}.ngx-gallery-remaining-count{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:#fff;font-size:30px}\n"], dependencies: [{ kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: NgxGalleryActionComponent, selector: "ngx-gallery-action", inputs: ["icon", "disabled", "titleText"], outputs: ["closeClick"] }, { kind: "component", type: NgxGalleryArrowsComponent, selector: "ngx-gallery-arrows", inputs: ["prevDisabled", "nextDisabled", "arrowPrevIcon", "arrowNextIcon"], outputs: ["prevClick", "nextClick"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryThumbnailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-gallery-thumbnails', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [NgClass, NgxGalleryActionComponent, NgxGalleryArrowsComponent], template: "<div class=\"ngx-gallery-thumbnails-wrapper ngx-gallery-thumbnail-size-{{ size }}\">\n  <div\n    class=\"ngx-gallery-thumbnails\"\n    [style.transform]=\"'translateX(' + thumbnailsLeft + ')'\"\n    [style.marginLeft]=\"thumbnailsMarginLeft\"\n  >\n    @for (image of getImages(); track image; let i = $index) {\n      <a\n        [href]=\"hasLink(i) ? links[i] : '#'\"\n        [target]=\"linkTarget\"\n        class=\"ngx-gallery-thumbnail\"\n        (click)=\"handleClick($event, i)\"\n        [style.width]=\"getThumbnailWidth()\"\n        [style.height]=\"getThumbnailHeight()\"\n        [style.left]=\"getThumbnailLeft(i)\"\n        [style.top]=\"getThumbnailTop(i)\"\n        [ngClass]=\"{\n          'ngx-gallery-active': i === selectedIndex,\n          'ngx-gallery-clickable': clickable,\n        }\"\n        [attr.aria-label]=\"labels[i]\"\n      >\n        @if (getFileType(image) === 'image') {\n          <div\n            [style.background-image]=\"getSafeUrl(image)\"\n            class=\"ngx-gallery-thumbnail\"\n            [ngClass]=\"{\n              'ngx-gallery-active': i === selectedIndex,\n              'ngx-gallery-clickable': clickable,\n            }\"\n            style=\"width: 100%; height: 100%; position: absolute\"\n          ></div>\n        }\n        @if (getFileType(image) === 'video') {\n          <div class=\"ngx-gallery-thumbnail-video\">\n            <video\n              class=\"ngx-gallery-thumbnail\"\n              [ngClass]=\"{\n                'ngx-gallery-active': i === selectedIndex,\n                'ngx-gallery-clickable': clickable,\n              }\"\n              style=\"\n                width: 100%;\n                height: 100%;\n                position: absolute;\n                left: 0;\n                background: #000;\n              \"\n            >\n              <source [src]=\"image\" />\n              Your browser does not support the video tag.\n            </video>\n          </div>\n        }\n        <div class=\"ngx-gallery-icons-wrapper\">\n          @for (action of actions; track action) {\n            <ngx-gallery-action\n              [icon]=\"action.icon\"\n              [disabled]=\"action.disabled\"\n              [titleText]=\"action.titleText\"\n              (closeClick)=\"action.onClick($event, i)\"\n            ></ngx-gallery-action>\n          }\n        </div>\n        @if (remainingCount && remainingCountValue && i === rows * columns - 1) {\n          <div class=\"ngx-gallery-remaining-count-overlay\">\n            <span class=\"ngx-gallery-remaining-count\">+{{ remainingCountValue }}</span>\n          </div>\n        }\n      </a>\n    }\n  </div>\n</div>\n@if (canShowArrows()) {\n  <ngx-gallery-arrows\n    (prevClick)=\"moveLeft()\"\n    (nextClick)=\"moveRight()\"\n    [prevDisabled]=\"!canMoveLeft()\"\n    [nextDisabled]=\"!canMoveRight()\"\n    [arrowPrevIcon]=\"arrowPrevIcon\"\n    [arrowNextIcon]=\"arrowNextIcon\"\n  ></ngx-gallery-arrows>\n}\n", styles: ["@charset \"UTF-8\";:host{width:100%;display:inline-block;position:relative;font-size:25px}.ngx-gallery-thumbnails-wrapper{width:100%;height:100%;position:absolute;overflow:hidden}.ngx-gallery-thumbnails{height:100%;width:100%;position:absolute;left:0;transform:translate(0);transition:transform .5s ease-in-out;will-change:transform}.ngx-gallery-thumbnails .ngx-gallery-thumbnail{position:absolute;height:100%;background-position:center;background-repeat:no-repeat;text-decoration:none;border:1px double black}.ngx-gallery-thumbnails .ngx-gallery-thumbnail .ngx-gallery-thumbnail-video:after{content:\"\\f144\";display:block;position:absolute;background:#0000;height:100%;width:100%;left:0;top:calc(50% - 20px);font-size:40px;color:#fff;margin:0;padding:0;font-family:fontawesome;text-shadow:0px 4px 3px rgba(0,0,0,.4),0px 8px 13px rgba(0,0,0,.1),0px 18px 23px rgba(0,0,0,.1)}.ngx-gallery-thumbnails .ngx-gallery-thumbnail .img{background-size:cover;height:100%}.ngx-gallery-thumbnails .ngx-gallery-thumbnail.ngx-gallery-active{border:1px double #cc4548}.ngx-gallery-thumbnail-size-cover .ngx-gallery-thumbnails .ngx-gallery-thumbnail{background-size:cover}.ngx-gallery-thumbnail-size-contain .ngx-gallery-thumbnails .ngx-gallery-thumbnail{background-size:contain}.ngx-gallery-remaining-count-overlay{width:100%;height:100%;position:absolute;left:0;top:0;background-color:#0006}.ngx-gallery-remaining-count{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:#fff;font-size:30px}\n"] }]
        }], ctorParameters: () => [{ type: i1.DomSanitizer }, { type: i0.ElementRef }, { type: NgxGalleryService }], propDecorators: { images: [{
                type: Input
            }], isAnimating: [{
                type: Input
            }], links: [{
                type: Input
            }], labels: [{
                type: Input
            }], linkTarget: [{
                type: Input
            }], columns: [{
                type: Input
            }], rows: [{
                type: Input
            }], arrows: [{
                type: Input
            }], arrowsAutoHide: [{
                type: Input
            }], margin: [{
                type: Input
            }], selectedIndex: [{
                type: Input
            }], clickable: [{
                type: Input
            }], swipe: [{
                type: Input
            }], size: [{
                type: Input
            }], arrowPrevIcon: [{
                type: Input
            }], arrowNextIcon: [{
                type: Input
            }], moveSize: [{
                type: Input
            }], order: [{
                type: Input
            }], remainingCount: [{
                type: Input
            }], lazyLoading: [{
                type: Input
            }], actions: [{
                type: Input
            }], activeChange: [{
                type: Output
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class NgxGalleryAction {
    constructor(action) {
        this.icon = action.icon;
        this.disabled = action.disabled ? action.disabled : false;
        this.titleText = action.titleText ? action.titleText : '';
        this.onClick = action.onClick;
    }
}

class NgxGalleryLayout {
    static { this.ThumbnailsTop = 'thumbnails-top'; }
    static { this.ThumbnailsBottom = 'thumbnails-bottom'; }
}

class NgxGalleryImageSize {
    static { this.Cover = 'cover'; }
    static { this.Contain = 'contain'; }
}

class NgxGalleryOptions {
    constructor(obj) {
        const preventDefaults = obj.breakpoint === undefined ? false : true;
        function use(source, defaultValue) {
            return obj && (source !== undefined || preventDefaults) ? source : defaultValue;
        }
        this.breakpoint = use(obj.breakpoint, undefined);
        this.width = use(obj.width, '500px');
        this.height = use(obj.height, '400px');
        this.fullWidth = use(obj.fullWidth, false);
        this.layout = use(obj.layout, NgxGalleryLayout.ThumbnailsBottom);
        this.startIndex = use(obj.startIndex, 0);
        this.linkTarget = use(obj.linkTarget, '_blank');
        this.lazyLoading = use(obj.lazyLoading, true);
        this.image = use(obj.image, true);
        this.imagePercent = use(obj.imagePercent, 75);
        this.imageArrows = use(obj.imageArrows, true);
        this.imageArrowsAutoHide = use(obj.imageArrowsAutoHide, false);
        this.imageSwipe = use(obj.imageSwipe, false);
        this.imageAnimation = use(obj.imageAnimation, NgxGalleryAnimation.Fade);
        this.imageSize = use(obj.imageSize, NgxGalleryImageSize.Cover);
        this.imageAutoPlay = use(obj.imageAutoPlay, false);
        this.imageAutoPlayInterval = use(obj.imageAutoPlayInterval, 2000);
        this.imageAutoPlayPauseOnHover = use(obj.imageAutoPlayPauseOnHover, false);
        this.imageInfinityMove = use(obj.imageInfinityMove, false);
        if (obj && obj.imageActions && obj.imageActions.length) {
            obj.imageActions = obj.imageActions.map((action) => new NgxGalleryAction(action));
        }
        this.imageActions = use(obj.imageActions, []);
        this.imageDescription = use(obj.imageDescription, false);
        this.imageBullets = use(obj.imageBullets, false);
        this.thumbnails = use(obj.thumbnails, true);
        this.thumbnailsColumns = use(obj.thumbnailsColumns, 4);
        this.thumbnailsRows = use(obj.thumbnailsRows, 1);
        this.thumbnailsPercent = use(obj.thumbnailsPercent, 25);
        this.thumbnailsMargin = use(obj.thumbnailsMargin, 10);
        this.thumbnailsArrows = use(obj.thumbnailsArrows, true);
        this.thumbnailsArrowsAutoHide = use(obj.thumbnailsArrowsAutoHide, false);
        this.thumbnailsSwipe = use(obj.thumbnailsSwipe, false);
        this.thumbnailsMoveSize = use(obj.thumbnailsMoveSize, 1);
        this.thumbnailsOrder = use(obj.thumbnailsOrder, NgxGalleryOrder.Column);
        this.thumbnailsRemainingCount = use(obj.thumbnailsRemainingCount, false);
        this.thumbnailsAsLinks = use(obj.thumbnailsAsLinks, false);
        this.thumbnailsAutoHide = use(obj.thumbnailsAutoHide, false);
        this.thumbnailMargin = use(obj.thumbnailMargin, 10);
        this.thumbnailSize = use(obj.thumbnailSize, NgxGalleryImageSize.Cover);
        if (obj && obj.thumbnailActions && obj.thumbnailActions.length) {
            obj.thumbnailActions = obj.thumbnailActions.map((action) => new NgxGalleryAction(action));
        }
        this.thumbnailActions = use(obj.thumbnailActions, []);
        this.thumbnailClasses = use(obj.thumbnailClasses, []);
        this.preview = use(obj.preview, true);
        this.previewDescription = use(obj.previewDescription, true);
        this.previewArrows = use(obj.previewArrows, true);
        this.previewArrowsAutoHide = use(obj.previewArrowsAutoHide, false);
        this.previewSwipe = use(obj.previewSwipe, false);
        this.previewFullscreen = use(obj.previewFullscreen, false);
        this.previewForceFullscreen = use(obj.previewForceFullscreen, false);
        this.previewCloseOnClick = use(obj.previewCloseOnClick, false);
        this.previewCloseOnEsc = use(obj.previewCloseOnEsc, false);
        this.previewKeyboardNavigation = use(obj.previewKeyboardNavigation, false);
        this.previewAnimation = use(obj.previewAnimation, true);
        this.previewAutoPlay = use(obj.previewAutoPlay, false);
        this.previewAutoPlayInterval = use(obj.previewAutoPlayInterval, 2000);
        this.previewAutoPlayPauseOnHover = use(obj.previewAutoPlayPauseOnHover, false);
        this.previewInfinityMove = use(obj.previewInfinityMove, false);
        this.previewZoom = use(obj.previewZoom, false);
        this.previewZoomStep = use(obj.previewZoomStep, 0.1);
        this.previewZoomMax = use(obj.previewZoomMax, 2);
        this.previewZoomMin = use(obj.previewZoomMin, 0.5);
        this.previewRotate = use(obj.previewRotate, false);
        this.previewDownload = use(obj.previewDownload, false);
        this.previewCustom = use(obj.previewCustom, undefined);
        this.previewBullets = use(obj.previewBullets, false);
        this.arrowPrevIcon = use(obj.arrowPrevIcon, 'fa fa-arrow-circle-left');
        this.arrowNextIcon = use(obj.arrowNextIcon, 'fa fa-arrow-circle-right');
        this.closeIcon = use(obj.closeIcon, 'fa fa-times-circle');
        this.fullscreenIcon = use(obj.fullscreenIcon, 'fa fa-arrows-alt');
        this.spinnerIcon = use(obj.spinnerIcon, 'fa fa-spinner fa-pulse fa-3x fa-fw');
        this.zoomInIcon = use(obj.zoomInIcon, 'fa fa-search-plus');
        this.zoomOutIcon = use(obj.zoomOutIcon, 'fa fa-search-minus');
        this.rotateLeftIcon = use(obj.rotateLeftIcon, 'fa fa-undo');
        this.rotateRightIcon = use(obj.rotateRightIcon, 'fa fa-repeat');
        this.downloadIcon = use(obj.downloadIcon, 'fa fa-arrow-circle-down');
        if (obj && obj.actions && obj.actions.length) {
            obj.actions = obj.actions.map((action) => new NgxGalleryAction(action));
        }
        this.actions = use(obj.actions, []);
    }
}

class NgxGalleryOrderedImage {
    constructor(obj) {
        this.src = obj.src;
        this.type = obj.type;
        this.index = obj.index;
    }
}

class NgxGalleryComponent {
    constructor(myElement, helperService) {
        this.myElement = myElement;
        this.helperService = helperService;
        this.options = [{}];
        this.imagesReady = new EventEmitter();
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.change = new EventEmitter();
        this.previewOpen = new EventEmitter();
        this.previewClose = new EventEmitter();
        this.previewChange = new EventEmitter();
        this.oldImagesLength = 0;
        this.selectedIndex = 0;
        this.breakpoint = undefined;
        this.prevBreakpoint = undefined;
    }
    ngOnInit() {
        this.options = this.options.map((opt) => new NgxGalleryOptions(opt));
        this.sortOptions();
        this.setBreakpoint();
        this.setOptions();
        this.checkFullWidth();
        if (this.currentOptions) {
            this.selectedIndex = this.currentOptions.startIndex;
        }
    }
    ngDoCheck() {
        if ((this.images !== undefined && this.images.length !== this.oldImagesLength) ||
            this.images !== this.oldImages) {
            this.oldImagesLength = this.images.length;
            this.oldImages = this.images;
            this.setOptions();
            this.setImages();
            if (this.images && this.images.length) {
                this.imagesReady.emit();
            }
            if (this.image) {
                this.image.reset(this.currentOptions.startIndex);
            }
            if (this.currentOptions.thumbnailsAutoHide &&
                this.currentOptions.thumbnails &&
                this.images.length <= 1) {
                this.currentOptions.thumbnails = false;
                this.currentOptions.imageArrows = false;
            }
            this.resetThumbnails();
        }
    }
    ngAfterViewInit() {
        this.checkFullWidth();
    }
    onResize() {
        this.setBreakpoint();
        if (this.prevBreakpoint !== this.breakpoint) {
            this.setOptions();
            this.resetThumbnails();
        }
        if (this.currentOptions && this.currentOptions.fullWidth) {
            if (this.fullWidthTimeout) {
                clearTimeout(this.fullWidthTimeout);
            }
            this.fullWidthTimeout = setTimeout(() => {
                this.checkFullWidth();
            }, 200);
        }
    }
    getImageHeight() {
        return this.currentOptions && this.currentOptions.thumbnails
            ? this.currentOptions.imagePercent + '%'
            : '100%';
    }
    getThumbnailsHeight() {
        if (this.currentOptions && this.currentOptions.image) {
            return ('calc(' +
                this.currentOptions.thumbnailsPercent +
                '% - ' +
                this.currentOptions.thumbnailsMargin +
                'px)');
        }
        else {
            return '100%';
        }
    }
    getThumbnailsMarginTop() {
        if (this.currentOptions &&
            this.currentOptions.layout === NgxGalleryLayout.ThumbnailsBottom) {
            return this.currentOptions.thumbnailsMargin + 'px';
        }
        else {
            return '0px';
        }
    }
    getThumbnailsMarginBottom() {
        if (this.currentOptions &&
            this.currentOptions.layout === NgxGalleryLayout.ThumbnailsTop) {
            return this.currentOptions.thumbnailsMargin + 'px';
        }
        else {
            return '0px';
        }
    }
    openPreview(index) {
        if (this.currentOptions.previewCustom) {
            this.currentOptions.previewCustom(index);
        }
        else {
            this.previewEnabled = true;
            this.preview.open(index);
        }
    }
    onPreviewOpen() {
        this.previewOpen.emit();
        if (this.image && this.image.autoPlay) {
            this.image.stopAutoPlay();
        }
    }
    onPreviewClose() {
        this.previewEnabled = false;
        this.previewClose.emit();
        if (this.image && this.image.autoPlay) {
            this.image.startAutoPlay();
        }
    }
    selectFromImage(index) {
        this.select(index);
    }
    selectFromThumbnails(index) {
        this.select(index);
        if (this.currentOptions &&
            this.currentOptions.thumbnails &&
            this.currentOptions.preview &&
            (!this.currentOptions.image || this.currentOptions.thumbnailsRemainingCount)) {
            this.openPreview(this.selectedIndex);
        }
    }
    show(index) {
        this.select(index);
    }
    showNext() {
        this.image.showNext();
    }
    showPrev() {
        this.image.showPrev();
    }
    canShowNext() {
        if (this.images && this.currentOptions) {
            return !!(this.currentOptions.imageInfinityMove ||
                this.selectedIndex < this.images.length - 1);
        }
        else {
            return false;
        }
    }
    canShowPrev() {
        if (this.images && this.currentOptions) {
            return !!(this.currentOptions.imageInfinityMove || this.selectedIndex > 0);
        }
        else {
            return false;
        }
    }
    previewSelect(index) {
        this.previewChange.emit({ index, image: this.images[index] });
    }
    moveThumbnailsRight() {
        this.thumbnails.moveRight();
    }
    moveThumbnailsLeft() {
        this.thumbnails.moveLeft();
    }
    canMoveThumbnailsRight() {
        return this.thumbnails.canMoveRight();
    }
    canMoveThumbnailsLeft() {
        return this.thumbnails.canMoveLeft();
    }
    resetThumbnails() {
        if (this.thumbnails) {
            this.thumbnails.reset(this.currentOptions.startIndex);
        }
    }
    select(index) {
        this.selectedIndex = index;
        this.change.emit({
            index,
            image: this.images[index],
        });
    }
    checkFullWidth() {
        if (this.currentOptions && this.currentOptions.fullWidth) {
            this.width = document.body.clientWidth + 'px';
            this.left =
                'translateX(' +
                    -(document.body.clientWidth - this.myElement.nativeElement.parentNode.innerWidth) /
                        2 +
                    'px)';
        }
    }
    setImages() {
        this.images.forEach((img) => (img.type = this.helperService.getFileType(img.url ||
            img.big ||
            img.medium ||
            img.small ||
            '')));
        this.smallImages = this.images.map((img) => img.small);
        this.mediumImages = this.images.map((img, i) => new NgxGalleryOrderedImage({
            src: img.medium,
            type: img.type,
            index: i,
        }));
        this.bigImages = this.images.map((img) => img.big);
        this.descriptions = this.images.map((img) => img.description);
        this.links = this.images.map((img) => img.url);
        this.labels = this.images.map((img) => img.label);
    }
    setBreakpoint() {
        this.prevBreakpoint = this.breakpoint;
        let breakpoints;
        if (typeof window !== 'undefined') {
            breakpoints = this.options
                .filter((opt) => opt.breakpoint >= window.innerWidth)
                .map((opt) => opt.breakpoint);
        }
        if (breakpoints && breakpoints.length) {
            this.breakpoint = breakpoints.pop();
        }
        else {
            this.breakpoint = undefined;
        }
    }
    sortOptions() {
        this.options = [
            ...this.options.filter((a) => a.breakpoint === undefined),
            ...this.options
                .filter((a) => a.breakpoint !== undefined)
                .sort((a, b) => b.breakpoint - a.breakpoint),
        ];
    }
    setOptions() {
        this.currentOptions = new NgxGalleryOptions({});
        this.options
            .filter((opt) => opt.breakpoint === undefined || opt.breakpoint >= this.breakpoint)
            .map((opt) => this.combineOptions(this.currentOptions, opt));
        this.width = this.currentOptions.width;
        this.height = this.currentOptions.height;
    }
    combineOptions(first, second) {
        Object.keys(second).forEach((key) => {
            first[key] = second[key] !== undefined ? second[key] : first[key];
        });
    }
    setAnimating(event) {
        this.isAnimating = event;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryComponent, deps: [{ token: i0.ElementRef }, { token: NgxGalleryService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.1.3", type: NgxGalleryComponent, isStandalone: true, selector: "ngx-gallery", inputs: { options: "options", images: "images" }, outputs: { imagesReady: "imagesReady", change: "change", previewOpen: "previewOpen", previewClose: "previewClose", previewChange: "previewChange" }, host: { listeners: { "window:resize": "onResize()" }, properties: { "style.width": "this.width", "style.height": "this.height", "style.transform": "this.left" } }, providers: [NgxGalleryService], viewQueries: [{ propertyName: "preview", first: true, predicate: NgxGalleryPreviewComponent, descendants: true }, { propertyName: "image", first: true, predicate: NgxGalleryImageComponent, descendants: true }, { propertyName: "thumbnails", first: true, predicate: NgxGalleryThumbnailsComponent, descendants: true }], ngImport: i0, template: "<div class=\"ngx-gallery-layout {{ currentOptions?.layout }}\">\n  @if (currentOptions?.image) {\n    <ngx-gallery-image\n      [style.height]=\"getImageHeight()\"\n      [images]=\"mediumImages\"\n      [clickable]=\"currentOptions?.preview\"\n      [selectedIndex]=\"selectedIndex\"\n      [arrows]=\"currentOptions?.imageArrows\"\n      [arrowsAutoHide]=\"currentOptions?.imageArrowsAutoHide\"\n      [arrowPrevIcon]=\"currentOptions?.arrowPrevIcon\"\n      [arrowNextIcon]=\"currentOptions?.arrowNextIcon\"\n      [swipe]=\"currentOptions?.imageSwipe\"\n      [animation]=\"currentOptions?.imageAnimation\"\n      [size]=\"currentOptions?.imageSize\"\n      [autoPlay]=\"currentOptions?.imageAutoPlay\"\n      [autoPlayInterval]=\"currentOptions?.imageAutoPlayInterval\"\n      [autoPlayPauseOnHover]=\"currentOptions?.imageAutoPlayPauseOnHover\"\n      [infinityMove]=\"currentOptions?.imageInfinityMove\"\n      [lazyLoading]=\"currentOptions?.lazyLoading\"\n      [actions]=\"currentOptions?.imageActions\"\n      [descriptions]=\"descriptions\"\n      [showDescription]=\"currentOptions?.imageDescription\"\n      [bullets]=\"currentOptions?.imageBullets\"\n      (imageClick)=\"openPreview($event)\"\n      (activeChange)=\"selectFromImage($event)\"\n      (animating)=\"setAnimating($event)\"\n    ></ngx-gallery-image>\n  }\n\n  @if (currentOptions?.thumbnails) {\n    <ngx-gallery-thumbnails\n      [style.marginTop]=\"getThumbnailsMarginTop()\"\n      [style.marginBottom]=\"getThumbnailsMarginBottom()\"\n      [style.height]=\"getThumbnailsHeight()\"\n      [images]=\"smallImages\"\n      [isAnimating]=\"isAnimating\"\n      [links]=\"currentOptions?.thumbnailsAsLinks ? links : []\"\n      [labels]=\"labels\"\n      [linkTarget]=\"currentOptions?.linkTarget\"\n      [selectedIndex]=\"selectedIndex\"\n      [columns]=\"currentOptions?.thumbnailsColumns\"\n      [rows]=\"currentOptions?.thumbnailsRows\"\n      [margin]=\"currentOptions?.thumbnailMargin\"\n      [arrows]=\"currentOptions?.thumbnailsArrows\"\n      [arrowsAutoHide]=\"currentOptions?.thumbnailsArrowsAutoHide\"\n      [arrowPrevIcon]=\"currentOptions?.arrowPrevIcon\"\n      [arrowNextIcon]=\"currentOptions?.arrowNextIcon\"\n      [clickable]=\"currentOptions?.image || currentOptions?.preview\"\n      [swipe]=\"currentOptions?.thumbnailsSwipe\"\n      [size]=\"currentOptions?.thumbnailSize\"\n      [moveSize]=\"currentOptions?.thumbnailsMoveSize\"\n      [order]=\"currentOptions?.thumbnailsOrder\"\n      [remainingCount]=\"currentOptions?.thumbnailsRemainingCount\"\n      [lazyLoading]=\"currentOptions?.lazyLoading\"\n      [actions]=\"currentOptions?.thumbnailActions\"\n      (activeChange)=\"selectFromThumbnails($event)\"\n      [ngClass]=\"currentOptions?.thumbnailClasses\"\n    ></ngx-gallery-thumbnails>\n  }\n\n  <ngx-gallery-preview\n    [images]=\"bigImages\"\n    [descriptions]=\"descriptions\"\n    [showDescription]=\"currentOptions?.previewDescription\"\n    [arrowPrevIcon]=\"currentOptions?.arrowPrevIcon\"\n    [arrowNextIcon]=\"currentOptions?.arrowNextIcon\"\n    [closeIcon]=\"currentOptions?.closeIcon\"\n    [fullscreenIcon]=\"currentOptions?.fullscreenIcon\"\n    [spinnerIcon]=\"currentOptions?.spinnerIcon\"\n    [arrows]=\"currentOptions?.previewArrows\"\n    [arrowsAutoHide]=\"currentOptions?.previewArrowsAutoHide\"\n    [swipe]=\"currentOptions?.previewSwipe\"\n    [fullscreen]=\"currentOptions?.previewFullscreen\"\n    [forceFullscreen]=\"currentOptions?.previewForceFullscreen\"\n    [closeOnClick]=\"currentOptions?.previewCloseOnClick\"\n    [closeOnEsc]=\"currentOptions?.previewCloseOnEsc\"\n    [keyboardNavigation]=\"currentOptions?.previewKeyboardNavigation\"\n    [animation]=\"currentOptions?.previewAnimation\"\n    [autoPlay]=\"currentOptions?.previewAutoPlay\"\n    [autoPlayInterval]=\"currentOptions?.previewAutoPlayInterval\"\n    [autoPlayPauseOnHover]=\"currentOptions?.previewAutoPlayPauseOnHover\"\n    [infinityMove]=\"currentOptions?.previewInfinityMove\"\n    [zoom]=\"currentOptions?.previewZoom\"\n    [zoomStep]=\"currentOptions?.previewZoomStep\"\n    [zoomMax]=\"currentOptions?.previewZoomMax\"\n    [zoomMin]=\"currentOptions?.previewZoomMin\"\n    [zoomInIcon]=\"currentOptions?.zoomInIcon\"\n    [zoomOutIcon]=\"currentOptions?.zoomOutIcon\"\n    [actions]=\"currentOptions?.actions\"\n    [rotate]=\"currentOptions?.previewRotate\"\n    [rotateLeftIcon]=\"currentOptions?.rotateLeftIcon\"\n    [rotateRightIcon]=\"currentOptions?.rotateRightIcon\"\n    [download]=\"currentOptions?.previewDownload\"\n    [downloadIcon]=\"currentOptions?.downloadIcon\"\n    [bullets]=\"currentOptions?.previewBullets\"\n    (previewClose)=\"onPreviewClose()\"\n    (previewOpen)=\"onPreviewOpen()\"\n    (activeChange)=\"previewSelect($event)\"\n    [class.ngx-gallery-active]=\"previewEnabled\"\n  ></ngx-gallery-preview>\n</div>\n", styles: [":host{display:inline-block}:host>*{float:left}.ngx-gallery-layout{width:100%;height:100%;display:flex;flex-direction:column}.ngx-gallery-layout.thumbnails-top ngx-gallery-image{order:2}.ngx-gallery-layout.thumbnails-top ngx-gallery-thumbnails{order:1}.ngx-gallery-layout.thumbnails-bottom ngx-gallery-image{order:1}.ngx-gallery-layout.thumbnails-bottom ngx-gallery-thumbnails{order:2}*{box-sizing:border-box}.ngx-gallery-icon{color:#fff;position:absolute;display:inline-block}.ngx-gallery-icon .ngx-gallery-icon-content{display:block}ngx-gallery-preview{font-size:25px}ngx-gallery-preview .ngx-gallery-icon{z-index:2000}.ngx-gallery-clickable{cursor:pointer}.ngx-gallery-icons-wrapper .ngx-gallery-icon{position:relative;margin-right:5px;margin-top:5px;font-size:20px;cursor:pointer}.ngx-gallery-icons-wrapper{float:right}\n"], dependencies: [{ kind: "component", type: NgxGalleryImageComponent, selector: "ngx-gallery-image", inputs: ["images", "clickable", "selectedIndex", "arrows", "arrowsAutoHide", "swipe", "animation", "size", "arrowPrevIcon", "arrowNextIcon", "autoPlay", "autoPlayInterval", "autoPlayPauseOnHover", "infinityMove", "lazyLoading", "actions", "descriptions", "showDescription", "bullets"], outputs: ["imageClick", "activeChange", "animating"] }, { kind: "component", type: NgxGalleryThumbnailsComponent, selector: "ngx-gallery-thumbnails", inputs: ["images", "isAnimating", "links", "labels", "linkTarget", "columns", "rows", "arrows", "arrowsAutoHide", "margin", "selectedIndex", "clickable", "swipe", "size", "arrowPrevIcon", "arrowNextIcon", "moveSize", "order", "remainingCount", "lazyLoading", "actions"], outputs: ["activeChange"] }, { kind: "directive", type: NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: NgxGalleryPreviewComponent, selector: "ngx-gallery-preview", inputs: ["images", "descriptions", "showDescription", "arrows", "arrowsAutoHide", "swipe", "fullscreen", "forceFullscreen", "closeOnClick", "closeOnEsc", "keyboardNavigation", "arrowPrevIcon", "arrowNextIcon", "closeIcon", "fullscreenIcon", "spinnerIcon", "autoPlay", "autoPlayInterval", "autoPlayPauseOnHover", "infinityMove", "zoom", "zoomStep", "zoomMax", "zoomMin", "zoomInIcon", "zoomOutIcon", "animation", "actions", "rotate", "rotateLeftIcon", "rotateRightIcon", "download", "downloadIcon", "bullets"], outputs: ["previewOpen", "previewClose", "activeChange"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ngx-gallery', encapsulation: ViewEncapsulation.None, providers: [NgxGalleryService], changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, imports: [
                        NgxGalleryImageComponent,
                        NgxGalleryThumbnailsComponent,
                        NgClass,
                        NgxGalleryPreviewComponent,
                    ], template: "<div class=\"ngx-gallery-layout {{ currentOptions?.layout }}\">\n  @if (currentOptions?.image) {\n    <ngx-gallery-image\n      [style.height]=\"getImageHeight()\"\n      [images]=\"mediumImages\"\n      [clickable]=\"currentOptions?.preview\"\n      [selectedIndex]=\"selectedIndex\"\n      [arrows]=\"currentOptions?.imageArrows\"\n      [arrowsAutoHide]=\"currentOptions?.imageArrowsAutoHide\"\n      [arrowPrevIcon]=\"currentOptions?.arrowPrevIcon\"\n      [arrowNextIcon]=\"currentOptions?.arrowNextIcon\"\n      [swipe]=\"currentOptions?.imageSwipe\"\n      [animation]=\"currentOptions?.imageAnimation\"\n      [size]=\"currentOptions?.imageSize\"\n      [autoPlay]=\"currentOptions?.imageAutoPlay\"\n      [autoPlayInterval]=\"currentOptions?.imageAutoPlayInterval\"\n      [autoPlayPauseOnHover]=\"currentOptions?.imageAutoPlayPauseOnHover\"\n      [infinityMove]=\"currentOptions?.imageInfinityMove\"\n      [lazyLoading]=\"currentOptions?.lazyLoading\"\n      [actions]=\"currentOptions?.imageActions\"\n      [descriptions]=\"descriptions\"\n      [showDescription]=\"currentOptions?.imageDescription\"\n      [bullets]=\"currentOptions?.imageBullets\"\n      (imageClick)=\"openPreview($event)\"\n      (activeChange)=\"selectFromImage($event)\"\n      (animating)=\"setAnimating($event)\"\n    ></ngx-gallery-image>\n  }\n\n  @if (currentOptions?.thumbnails) {\n    <ngx-gallery-thumbnails\n      [style.marginTop]=\"getThumbnailsMarginTop()\"\n      [style.marginBottom]=\"getThumbnailsMarginBottom()\"\n      [style.height]=\"getThumbnailsHeight()\"\n      [images]=\"smallImages\"\n      [isAnimating]=\"isAnimating\"\n      [links]=\"currentOptions?.thumbnailsAsLinks ? links : []\"\n      [labels]=\"labels\"\n      [linkTarget]=\"currentOptions?.linkTarget\"\n      [selectedIndex]=\"selectedIndex\"\n      [columns]=\"currentOptions?.thumbnailsColumns\"\n      [rows]=\"currentOptions?.thumbnailsRows\"\n      [margin]=\"currentOptions?.thumbnailMargin\"\n      [arrows]=\"currentOptions?.thumbnailsArrows\"\n      [arrowsAutoHide]=\"currentOptions?.thumbnailsArrowsAutoHide\"\n      [arrowPrevIcon]=\"currentOptions?.arrowPrevIcon\"\n      [arrowNextIcon]=\"currentOptions?.arrowNextIcon\"\n      [clickable]=\"currentOptions?.image || currentOptions?.preview\"\n      [swipe]=\"currentOptions?.thumbnailsSwipe\"\n      [size]=\"currentOptions?.thumbnailSize\"\n      [moveSize]=\"currentOptions?.thumbnailsMoveSize\"\n      [order]=\"currentOptions?.thumbnailsOrder\"\n      [remainingCount]=\"currentOptions?.thumbnailsRemainingCount\"\n      [lazyLoading]=\"currentOptions?.lazyLoading\"\n      [actions]=\"currentOptions?.thumbnailActions\"\n      (activeChange)=\"selectFromThumbnails($event)\"\n      [ngClass]=\"currentOptions?.thumbnailClasses\"\n    ></ngx-gallery-thumbnails>\n  }\n\n  <ngx-gallery-preview\n    [images]=\"bigImages\"\n    [descriptions]=\"descriptions\"\n    [showDescription]=\"currentOptions?.previewDescription\"\n    [arrowPrevIcon]=\"currentOptions?.arrowPrevIcon\"\n    [arrowNextIcon]=\"currentOptions?.arrowNextIcon\"\n    [closeIcon]=\"currentOptions?.closeIcon\"\n    [fullscreenIcon]=\"currentOptions?.fullscreenIcon\"\n    [spinnerIcon]=\"currentOptions?.spinnerIcon\"\n    [arrows]=\"currentOptions?.previewArrows\"\n    [arrowsAutoHide]=\"currentOptions?.previewArrowsAutoHide\"\n    [swipe]=\"currentOptions?.previewSwipe\"\n    [fullscreen]=\"currentOptions?.previewFullscreen\"\n    [forceFullscreen]=\"currentOptions?.previewForceFullscreen\"\n    [closeOnClick]=\"currentOptions?.previewCloseOnClick\"\n    [closeOnEsc]=\"currentOptions?.previewCloseOnEsc\"\n    [keyboardNavigation]=\"currentOptions?.previewKeyboardNavigation\"\n    [animation]=\"currentOptions?.previewAnimation\"\n    [autoPlay]=\"currentOptions?.previewAutoPlay\"\n    [autoPlayInterval]=\"currentOptions?.previewAutoPlayInterval\"\n    [autoPlayPauseOnHover]=\"currentOptions?.previewAutoPlayPauseOnHover\"\n    [infinityMove]=\"currentOptions?.previewInfinityMove\"\n    [zoom]=\"currentOptions?.previewZoom\"\n    [zoomStep]=\"currentOptions?.previewZoomStep\"\n    [zoomMax]=\"currentOptions?.previewZoomMax\"\n    [zoomMin]=\"currentOptions?.previewZoomMin\"\n    [zoomInIcon]=\"currentOptions?.zoomInIcon\"\n    [zoomOutIcon]=\"currentOptions?.zoomOutIcon\"\n    [actions]=\"currentOptions?.actions\"\n    [rotate]=\"currentOptions?.previewRotate\"\n    [rotateLeftIcon]=\"currentOptions?.rotateLeftIcon\"\n    [rotateRightIcon]=\"currentOptions?.rotateRightIcon\"\n    [download]=\"currentOptions?.previewDownload\"\n    [downloadIcon]=\"currentOptions?.downloadIcon\"\n    [bullets]=\"currentOptions?.previewBullets\"\n    (previewClose)=\"onPreviewClose()\"\n    (previewOpen)=\"onPreviewOpen()\"\n    (activeChange)=\"previewSelect($event)\"\n    [class.ngx-gallery-active]=\"previewEnabled\"\n  ></ngx-gallery-preview>\n</div>\n", styles: [":host{display:inline-block}:host>*{float:left}.ngx-gallery-layout{width:100%;height:100%;display:flex;flex-direction:column}.ngx-gallery-layout.thumbnails-top ngx-gallery-image{order:2}.ngx-gallery-layout.thumbnails-top ngx-gallery-thumbnails{order:1}.ngx-gallery-layout.thumbnails-bottom ngx-gallery-image{order:1}.ngx-gallery-layout.thumbnails-bottom ngx-gallery-thumbnails{order:2}*{box-sizing:border-box}.ngx-gallery-icon{color:#fff;position:absolute;display:inline-block}.ngx-gallery-icon .ngx-gallery-icon-content{display:block}ngx-gallery-preview{font-size:25px}ngx-gallery-preview .ngx-gallery-icon{z-index:2000}.ngx-gallery-clickable{cursor:pointer}.ngx-gallery-icons-wrapper .ngx-gallery-icon{position:relative;margin-right:5px;margin-top:5px;font-size:20px;cursor:pointer}.ngx-gallery-icons-wrapper{float:right}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: NgxGalleryService }], propDecorators: { options: [{
                type: Input
            }], images: [{
                type: Input
            }], imagesReady: [{
                type: Output
            }], change: [{
                type: Output
            }], previewOpen: [{
                type: Output
            }], previewClose: [{
                type: Output
            }], previewChange: [{
                type: Output
            }], preview: [{
                type: ViewChild,
                args: [NgxGalleryPreviewComponent]
            }], image: [{
                type: ViewChild,
                args: [NgxGalleryImageComponent]
            }], thumbnails: [{
                type: ViewChild,
                args: [NgxGalleryThumbnailsComponent]
            }], width: [{
                type: HostBinding,
                args: ['style.width']
            }], height: [{
                type: HostBinding,
                args: ['style.height']
            }], left: [{
                type: HostBinding,
                args: ['style.transform']
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

class CustomHammerConfig extends HammerGestureConfig {
    constructor() {
        super(...arguments);
        this.overrides = {
            pinch: { enable: false },
            rotate: { enable: false },
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CustomHammerConfig, deps: null, target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CustomHammerConfig }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: CustomHammerConfig, decorators: [{
            type: Injectable
        }] });
class NgxGalleryModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryModule, imports: [CommonModule,
            NgxGalleryComponent,
            NgxGalleryImageComponent,
            NgxGalleryArrowsComponent,
            NgxGalleryThumbnailsComponent,
            NgxGalleryPreviewComponent,
            NgxGalleryActionComponent,
            NgxGalleryBulletsComponent], exports: [NgxGalleryComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryModule, providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig }], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.1.3", ngImport: i0, type: NgxGalleryModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        NgxGalleryComponent,
                        NgxGalleryImageComponent,
                        NgxGalleryArrowsComponent,
                        NgxGalleryThumbnailsComponent,
                        NgxGalleryPreviewComponent,
                        NgxGalleryActionComponent,
                        NgxGalleryBulletsComponent,
                    ],
                    exports: [NgxGalleryComponent],
                    providers: [{ provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig }],
                }]
        }] });

class NgxGalleryImage {
    constructor(obj) {
        this.small = obj.small;
        this.medium = obj.medium;
        this.big = obj.big;
        this.description = obj.description;
        this.url = obj.url;
        this.type = obj.type;
        this.label = obj.label;
    }
}

/*
 * Public API Surface of ngx-gallery
 */

// MODULES

/**
 * Generated bundle index. Do not edit.
 */

export { APP_CONFIG, AccessGuard, AttributeService, AuthService, AutocompleteType, BanksCalculator, BestSellingService, BlockService, CartService, CategoryDisplayMode, CategoryPageType, CategoryService, ConfigService, ContactFormService, CookieConsentService, CoreModule, CountryService, CouponService, CurrencyService, CustomHammerConfig, CustomerService, DataService, DebounceClickDirective, EventsService, ExtendedValidator, FaviconService, FirstLetterPipe, FirstLetterPipeModule, GoogleAnalyticsService, InbankService, JsonParsePipe, JsonParsePipeModule, LayeredService, MetaService, MouseoverDirective, NewsletterService, NgxGalleryAction, NgxGalleryAnimation, NgxGalleryArrowsComponent, NgxGalleryBulletsComponent, NgxGalleryComponent, NgxGalleryImage, NgxGalleryImageSize, NgxGalleryLayout, NgxGalleryModule, NgxGalleryOptions, NgxGalleryOrder, NgxGalleryOrderedImage, NgxGalleryPreviewComponent, NgxGalleryService, NgxGalleryThumbnailsComponent, NoCommaPipe, NoCommaPipeModule, PageService, PricePipe, PricePipeModule, ProductBundleOptionType, ProductService, ProductStockService, ProductType, ProductionService, RouterService, SRouterLinkActiveDirective, SRouterLinkWithHrefDirective, SVGMatIconModule, SafeHtmlPipe, SearchService, SeoService, ServerResponseService, SpeedyCookieService, StoreResolver, StoreService, SwiperDirective, TaxService, TranslateDirective, TranslatePipe, TranslationService, TrustPipe, UrlRewriteService, UrlService, WishListApiService, WishListConfigService, ZendeskService, authInterceptor, credentialsInterceptor, currencySigns, dateValidator, filterNil, findBlockById, findBlockByIdentifier, formatImageToWebp, generateSliderConfig, getAuthServiceConfigs, getExistedBlocksLength, intersection, isEnumValue, isEqual, isObject, isObjectEmpty, objectNumberToString, optionalToFixed, passwordConfirmationValidator, relatedProdsCartConfig, storeInterceptor, updateObjectValues, updateObjectWith };
